/*
 * %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
 *
 * Template Name: Sasna - Multipurpose Business HTML Template   
 * Template URI: https://thememarch.com/demo/html/sasna/
 * Description: Sasna is a multipurpose business HTML template which comes with the unique and clean design. It helps you to create a beautiful multipurpose business HTML website. It has also e-commerce support. E-commerce pages are included on this template.
 * Author: Thememarch
 * Author URI: https://thememarch.com
 * Version: 4.5
 *
 * %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
 */

/*! WOW wow.js - v1.3.0 - 2016-10-04
* https://wowjs.uk
* Copyright (c) 2016 Thomas Grainger; Licensed MIT */
!function(a, b) {
    if ("function" == typeof define && define.amd)
        define(["module", "exports"], b);
    else if ("undefined" != typeof exports)
        b(module, exports);
    else {
        var c = {
            exports: {}
        };
        b(c, c.exports),
        a.WOW = c.exports
    }
}(this, function(a, b) {
    "use strict";
    function c(a, b) {
        if (!(a instanceof b))
            throw new TypeError("Cannot call a class as a function")
    }
    function d(a, b) {
        return b.indexOf(a) >= 0
    }
    function e(a, b) {
        for (var c in b)
            if (null == a[c]) {
                var d = b[c];
                a[c] = d
            }
        return a
    }
    function f(a) {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(a)
    }
    function g(a) {
        var b = arguments.length <= 1 || void 0 === arguments[1] ? !1 : arguments[1]
          , c = arguments.length <= 2 || void 0 === arguments[2] ? !1 : arguments[2]
          , d = arguments.length <= 3 || void 0 === arguments[3] ? null : arguments[3]
          , e = void 0;
        return null != document.createEvent ? (e = document.createEvent("CustomEvent"),
        e.initCustomEvent(a, b, c, d)) : null != document.createEventObject ? (e = document.createEventObject(),
        e.eventType = a) : e.eventName = a,
        e
    }
    function h(a, b) {
        null != a.dispatchEvent ? a.dispatchEvent(b) : b in (null != a) ? a[b]() : "on" + b in (null != a) && a["on" + b]()
    }
    function i(a, b, c) {
        null != a.addEventListener ? a.addEventListener(b, c, !1) : null != a.attachEvent ? a.attachEvent("on" + b, c) : a[b] = c
    }
    function j(a, b, c) {
        null != a.removeEventListener ? a.removeEventListener(b, c, !1) : null != a.detachEvent ? a.detachEvent("on" + b, c) : delete a[b]
    }
    function k() {
        return "innerHeight"in window ? window.innerHeight : document.documentElement.clientHeight
    }
    Object.defineProperty(b, "__esModule", {
        value: !0
    });
    var l, m, n = function() {
        function a(a, b) {
            for (var c = 0; c < b.length; c++) {
                var d = b[c];
                d.enumerable = d.enumerable || !1,
                d.configurable = !0,
                "value"in d && (d.writable = !0),
                Object.defineProperty(a, d.key, d)
            }
        }
        return function(b, c, d) {
            return c && a(b.prototype, c),
            d && a(b, d),
            b
        }
    }(), o = window.WeakMap || window.MozWeakMap || function() {
        function a() {
            c(this, a),
            this.keys = [],
            this.values = []
        }
        return n(a, [{
            key: "get",
            value: function(a) {
                for (var b = 0; b < this.keys.length; b++) {
                    var c = this.keys[b];
                    if (c === a)
                        return this.values[b]
                }
            }
        }, {
            key: "set",
            value: function(a, b) {
                for (var c = 0; c < this.keys.length; c++) {
                    var d = this.keys[c];
                    if (d === a)
                        return this.values[c] = b,
                        this
                }
                return this.keys.push(a),
                this.values.push(b),
                this
            }
        }]),
        a
    }(), p = window.MutationObserver || window.WebkitMutationObserver || window.MozMutationObserver || (m = l = function() {
        function a() {
            c(this, a),
            "undefined" != typeof console && null !== console && (console.warn("MutationObserver is not supported by your browser."),
            console.warn("WOW.js cannot detect dom mutations, please call .sync() after loading new content."))
        }
        return n(a, [{
            key: "observe",
            value: function() {}
        }]),
        a
    }(),
    l.notSupported = !0,
    m), q = window.getComputedStyle || function(a) {
        var b = /(\-([a-z]){1})/g;
        return {
            getPropertyValue: function(c) {
                "float" === c && (c = "styleFloat"),
                b.test(c) && c.replace(b, function(a, b) {
                    return b.toUpperCase()
                });
                var d = a.currentStyle;
                return (null != d ? d[c] : void 0) || null
            }
        }
    }
    , r = function() {
        function a() {
            var b = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
            c(this, a),
            this.defaults = {
                boxClass: "wow",
                animateClass: "animated",
                offset: 0,
                mobile: !0,
                live: !0,
                callback: null,
                scrollContainer: null,
                resetAnimation: !0
            },
            this.animate = function() {
                return "requestAnimationFrame"in window ? function(a) {
                    return window.requestAnimationFrame(a)
                }
                : function(a) {
                    return a()
                }
            }(),
            this.vendors = ["moz", "webkit"],
            this.start = this.start.bind(this),
            this.resetAnimation = this.resetAnimation.bind(this),
            this.scrollHandler = this.scrollHandler.bind(this),
            this.scrollCallback = this.scrollCallback.bind(this),
            this.scrolled = !0,
            this.config = e(b, this.defaults),
            null != b.scrollContainer && (this.config.scrollContainer = document.querySelector(b.scrollContainer)),
            this.animationNameCache = new o,
            this.wowEvent = g(this.config.boxClass)
        }
        return n(a, [{
            key: "init",
            value: function() {
                this.element = window.document.documentElement,
                d(document.readyState, ["interactive", "complete"]) ? this.start() : i(document, "DOMContentLoaded", this.start),
                this.finished = []
            }
        }, {
            key: "start",
            value: function() {
                var a = this;
                if (this.stopped = !1,
                this.boxes = [].slice.call(this.element.querySelectorAll("." + this.config.boxClass)),
                this.all = this.boxes.slice(0),
                this.boxes.length)
                    if (this.disabled())
                        this.resetStyle();
                    else
                        for (var b = 0; b < this.boxes.length; b++) {
                            var c = this.boxes[b];
                            this.applyStyle(c, !0)
                        }
                if (this.disabled() || (i(this.config.scrollContainer || window, "scroll", this.scrollHandler),
                i(window, "resize", this.scrollHandler),
                this.interval = setInterval(this.scrollCallback, 50)),
                this.config.live) {
                    var d = new p(function(b) {
                        for (var c = 0; c < b.length; c++)
                            for (var d = b[c], e = 0; e < d.addedNodes.length; e++) {
                                var f = d.addedNodes[e];
                                a.doSync(f)
                            }
                    }
                    );
                    d.observe(document.body, {
                        childList: !0,
                        subtree: !0
                    })
                }
            }
        }, {
            key: "stop",
            value: function() {
                this.stopped = !0,
                j(this.config.scrollContainer || window, "scroll", this.scrollHandler),
                j(window, "resize", this.scrollHandler),
                null != this.interval && clearInterval(this.interval)
            }
        }, {
            key: "sync",
            value: function() {
                p.notSupported && this.doSync(this.element)
            }
        }, {
            key: "doSync",
            value: function(a) {
                if ("undefined" != typeof a && null !== a || (a = this.element),
                1 === a.nodeType) {
                    a = a.parentNode || a;
                    for (var b = a.querySelectorAll("." + this.config.boxClass), c = 0; c < b.length; c++) {
                        var e = b[c];
                        d(e, this.all) || (this.boxes.push(e),
                        this.all.push(e),
                        this.stopped || this.disabled() ? this.resetStyle() : this.applyStyle(e, !0),
                        this.scrolled = !0)
                    }
                }
            }
        }, {
            key: "show",
            value: function(a) {
                return this.applyStyle(a),
                a.className = a.className + " " + this.config.animateClass,
                null != this.config.callback && this.config.callback(a),
                h(a, this.wowEvent),
                this.config.resetAnimation && (i(a, "animationend", this.resetAnimation),
                i(a, "oanimationend", this.resetAnimation),
                i(a, "webkitAnimationEnd", this.resetAnimation),
                i(a, "MSAnimationEnd", this.resetAnimation)),
                a
            }
        }, {
            key: "applyStyle",
            value: function(a, b) {
                var c = this
                  , d = a.getAttribute("data-wow-duration")
                  , e = a.getAttribute("data-wow-delay")
                  , f = a.getAttribute("data-wow-iteration");
                return this.animate(function() {
                    return c.customStyle(a, b, d, e, f)
                })
            }
        }, {
            key: "resetStyle",
            value: function() {
                for (var a = 0; a < this.boxes.length; a++) {
                    var b = this.boxes[a];
                    b.style.visibility = "visible"
                }
            }
        }, {
            key: "resetAnimation",
            value: function(a) {
                if (a.type.toLowerCase().indexOf("animationend") >= 0) {
                    var b = a.target || a.srcElement;
                    b.className = b.className.replace(this.config.animateClass, "").trim()
                }
            }
        }, {
            key: "customStyle",
            value: function(a, b, c, d, e) {
                return b && this.cacheAnimationName(a),
                a.style.visibility = b ? "hidden" : "visible",
                c && this.vendorSet(a.style, {
                    animationDuration: c
                }),
                d && this.vendorSet(a.style, {
                    animationDelay: d
                }),
                e && this.vendorSet(a.style, {
                    animationIterationCount: e
                }),
                this.vendorSet(a.style, {
                    animationName: b ? "none" : this.cachedAnimationName(a)
                }),
                a
            }
        }, {
            key: "vendorSet",
            value: function(a, b) {
                for (var c in b)
                    if (b.hasOwnProperty(c)) {
                        var d = b[c];
                        a["" + c] = d;
                        for (var e = 0; e < this.vendors.length; e++) {
                            var f = this.vendors[e];
                            a["" + f + c.charAt(0).toUpperCase() + c.substr(1)] = d
                        }
                    }
            }
        }, {
            key: "vendorCSS",
            value: function(a, b) {
                for (var c = q(a), d = c.getPropertyCSSValue(b), e = 0; e < this.vendors.length; e++) {
                    var f = this.vendors[e];
                    d = d || c.getPropertyCSSValue("-" + f + "-" + b)
                }
                return d
            }
        }, {
            key: "animationName",
            value: function(a) {
                var b = void 0;
                try {
                    b = this.vendorCSS(a, "animation-name").cssText
                } catch (c) {
                    b = q(a).getPropertyValue("animation-name")
                }
                return "none" === b ? "" : b
            }
        }, {
            key: "cacheAnimationName",
            value: function(a) {
                return this.animationNameCache.set(a, this.animationName(a))
            }
        }, {
            key: "cachedAnimationName",
            value: function(a) {
                return this.animationNameCache.get(a)
            }
        }, {
            key: "scrollHandler",
            value: function() {
                this.scrolled = !0
            }
        }, {
            key: "scrollCallback",
            value: function() {
                if (this.scrolled) {
                    this.scrolled = !1;
                    for (var a = [], b = 0; b < this.boxes.length; b++) {
                        var c = this.boxes[b];
                        if (c) {
                            if (this.isVisible(c)) {
                                this.show(c);
                                continue
                            }
                            a.push(c)
                        }
                    }
                    this.boxes = a,
                    this.boxes.length || this.config.live || this.stop()
                }
            }
        }, {
            key: "offsetTop",
            value: function(a) {
                for (; void 0 === a.offsetTop; )
                    a = a.parentNode;
                for (var b = a.offsetTop; a.offsetParent; )
                    a = a.offsetParent,
                    b += a.offsetTop;
                return b
            }
        }, {
            key: "isVisible",
            value: function(a) {
                var b = a.getAttribute("data-wow-offset") || this.config.offset
                  , c = this.config.scrollContainer && this.config.scrollContainer.scrollTop || window.pageYOffset
                  , d = c + Math.min(this.element.clientHeight, k()) - b
                  , e = this.offsetTop(a)
                  , f = e + a.clientHeight;
                return d >= e && f >= c
            }
        }, {
            key: "disabled",
            value: function() {
                return !this.config.mobile && f(navigator.userAgent)
            }
        }]),
        a
    }();
    b["default"] = r,
    a.exports = b["default"]
});

/* Slick Slider */
!function(i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function(i) {
    "use strict";
    var e = window.Slick || {};
    (e = function() {
        var e = 0;
        return function(t, o) {
            var s, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(e, t) {
                    return i('<button type="button" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            },
            n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            },
            i.extend(n, n.initials),
            n.activeBreakpoint = null,
            n.animType = null,
            n.animProp = null,
            n.breakpoints = [],
            n.breakpointSettings = [],
            n.cssTransitions = !1,
            n.focussed = !1,
            n.interrupted = !1,
            n.hidden = "hidden",
            n.paused = !0,
            n.positionProp = null,
            n.respondTo = null,
            n.rowCount = 1,
            n.shouldClick = !0,
            n.$slider = i(t),
            n.$slidesCache = null,
            n.transformType = null,
            n.transitionType = null,
            n.visibilityChange = "visibilitychange",
            n.windowWidth = 0,
            n.windowTimer = null,
            s = i(t).data("slick") || {},
            n.options = i.extend({}, n.defaults, o, s),
            n.currentSlide = n.options.initialSlide,
            n.originalSettings = n.options,
            void 0 !== document.mozHidden ? (n.hidden = "mozHidden",
            n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden",
            n.visibilityChange = "webkitvisibilitychange"),
            n.autoPlay = i.proxy(n.autoPlay, n),
            n.autoPlayClear = i.proxy(n.autoPlayClear, n),
            n.autoPlayIterator = i.proxy(n.autoPlayIterator, n),
            n.changeSlide = i.proxy(n.changeSlide, n),
            n.clickHandler = i.proxy(n.clickHandler, n),
            n.selectHandler = i.proxy(n.selectHandler, n),
            n.setPosition = i.proxy(n.setPosition, n),
            n.swipeHandler = i.proxy(n.swipeHandler, n),
            n.dragHandler = i.proxy(n.dragHandler, n),
            n.keyHandler = i.proxy(n.keyHandler, n),
            n.instanceUid = e++,
            n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            n.registerBreakpoints(),
            n.init(!0)
        }
    }()).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }
    ,
    e.prototype.addSlide = e.prototype.slickAdd = function(e, t, o) {
        var s = this;
        if ("boolean" == typeof t)
            o = t,
            t = null;
        else if (t < 0 || t >= s.slideCount)
            return !1;
        s.unload(),
        "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack),
        s.$slides = s.$slideTrack.children(this.options.slide),
        s.$slideTrack.children(this.options.slide).detach(),
        s.$slideTrack.append(s.$slides),
        s.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e)
        }),
        s.$slidesCache = s.$slides,
        s.reinit()
    }
    ,
    e.prototype.animateHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({
                height: e
            }, i.options.speed)
        }
    }
    ,
    e.prototype.animateSlide = function(e, t) {
        var o = {}
          , s = this;
        s.animateHeight(),
        !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
        !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
            left: e
        }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
            top: e
        }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
        i({
            animStart: s.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function(i) {
                i = Math.ceil(i),
                !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)",
                s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)",
                s.$slideTrack.css(o))
            },
            complete: function() {
                t && t.call()
            }
        })) : (s.applyTransition(),
        e = Math.ceil(e),
        !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)",
        s.$slideTrack.css(o),
        t && setTimeout(function() {
            s.disableTransition(),
            t.call()
        }, s.options.speed))
    }
    ,
    e.prototype.getNavTarget = function() {
        var e = this
          , t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)),
        t
    }
    ,
    e.prototype.asNavFor = function(e) {
        var t = this.getNavTarget();
        null !== t && "object" == typeof t && t.each(function() {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }
    ,
    e.prototype.applyTransition = function(i) {
        var e = this
          , t = {};
        !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }
    ,
    e.prototype.autoPlay = function() {
        var i = this;
        i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }
    ,
    e.prototype.autoPlayClear = function() {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer)
    }
    ,
    e.prototype.autoPlayIterator = function() {
        var i = this
          , e = i.currentSlide + i.options.slidesToScroll;
        i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll,
        i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e))
    }
    ,
    e.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"),
        e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"),
        e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
        !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }
    ,
    e.prototype.buildDots = function() {
        var e, t, o = this;
        if (!0 === o.options.dots) {
            for (o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e = 0; e <= o.getDotCount(); e += 1)
                t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            o.$dots = t.appendTo(o.options.appendDots),
            o.$dots.find("li").first().addClass("slick-active")
        }
    }
    ,
    e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
        }),
        e.$slider.addClass("slick-slider"),
        e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(),
        e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(),
        e.$slideTrack.css("opacity", 0),
        !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
        !0 === e.options.draggable && e.$list.addClass("draggable")
    }
    ,
    e.prototype.buildRows = function() {
        var i, e, t, o, s, n, r, l = this;
        if (o = document.createDocumentFragment(),
        n = l.$slider.children(),
        l.options.rows > 1) {
            for (r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i = 0; i < s; i++) {
                var d = document.createElement("div");
                for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                        var c = i * r + (e * l.options.slidesPerRow + t);
                        n.get(c) && a.appendChild(n.get(c))
                    }
                    d.appendChild(a)
                }
                o.appendChild(d)
            }
            l.$slider.empty().append(o),
            l.$slider.children().children().children().css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }
    ,
    e.prototype.checkResponsive = function(e, t) {
        var o, s, n, r = this, l = !1, d = r.$slider.width(), a = window.innerWidth || i(window).width();
        if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)),
        r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            s = null;
            for (o in r.breakpoints)
                r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s,
            "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e)),
            l = s) : (r.activeBreakpoint = s,
            "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e)),
            l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null,
            r.options = r.originalSettings,
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e),
            l = s),
            e || !1 === l || r.$slider.trigger("breakpoint", [r, l])
        }
    }
    ,
    e.prototype.changeSlide = function(e, t) {
        var o, s, n, r = this, l = i(e.currentTarget);
        switch (l.is("a") && e.preventDefault(),
        l.is("li") || (l = l.closest("li")),
        n = r.slideCount % r.options.slidesToScroll != 0,
        o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll,
        e.data.message) {
        case "previous":
            s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o,
            r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
            break;
        case "next":
            s = 0 === o ? r.options.slidesToScroll : o,
            r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
            break;
        case "index":
            var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(d), !1, t),
            l.children().trigger("focus");
            break;
        default:
            return
        }
    }
    ,
    e.prototype.checkNavigable = function(i) {
        var e, t;
        if (e = this.getNavigableIndexes(),
        t = 0,
        i > e[e.length - 1])
            i = e[e.length - 1];
        else
            for (var o in e) {
                if (i < e[o]) {
                    i = t;
                    break
                }
                t = e[o]
            }
        return i
    }
    ,
    e.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
        !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)),
        e.$slider.off("focus.slick blur.slick"),
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
        e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
        !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
        e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        i(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler),
        i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
        i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
        i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }
    ,
    e.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }
    ,
    e.prototype.cleanUpRows = function() {
        var i, e = this;
        e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"),
        e.$slider.empty().append(i))
    }
    ,
    e.prototype.clickHandler = function(i) {
        !1 === this.shouldClick && (i.stopImmediatePropagation(),
        i.stopPropagation(),
        i.preventDefault())
    }
    ,
    e.prototype.destroy = function(e) {
        var t = this;
        t.autoPlayClear(),
        t.touchObject = {},
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            i(this).attr("style", i(this).data("originalStyling"))
        }),
        t.$slideTrack.children(this.options.slide).detach(),
        t.$slideTrack.detach(),
        t.$list.detach(),
        t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        t.unslicked = !0,
        e || t.$slider.trigger("destroy", [t])
    }
    ,
    e.prototype.disableTransition = function(i) {
        var e = this
          , t = {};
        t[e.transitionType] = "",
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }
    ,
    e.prototype.fadeSlide = function(i, e) {
        var t = this;
        !1 === t.cssTransitions ? (t.$slides.eq(i).css({
            zIndex: t.options.zIndex
        }),
        t.$slides.eq(i).animate({
            opacity: 1
        }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i),
        t.$slides.eq(i).css({
            opacity: 1,
            zIndex: t.options.zIndex
        }),
        e && setTimeout(function() {
            t.disableTransition(i),
            e.call()
        }, t.options.speed))
    }
    ,
    e.prototype.fadeSlideOut = function(i) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(i).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(i),
        e.$slides.eq(i).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }
    ,
    e.prototype.filterSlides = e.prototype.slickFilter = function(i) {
        var e = this;
        null !== i && (e.$slidesCache = e.$slides,
        e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(i).appendTo(e.$slideTrack),
        e.reinit())
    }
    ,
    e.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(t) {
            t.stopImmediatePropagation();
            var o = i(this);
            setTimeout(function() {
                e.options.pauseOnFocus && (e.focussed = o.is(":focus"),
                e.autoPlay())
            }, 0)
        })
    }
    ,
    e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }
    ,
    e.prototype.getDotCount = function() {
        var i = this
          , e = 0
          , t = 0
          , o = 0;
        if (!0 === i.options.infinite)
            if (i.slideCount <= i.options.slidesToShow)
                ++o;
            else
                for (; e < i.slideCount; )
                    ++o,
                    e = t + i.options.slidesToScroll,
                    t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else if (!0 === i.options.centerMode)
            o = i.slideCount;
        else if (i.options.asNavFor)
            for (; e < i.slideCount; )
                ++o,
                e = t + i.options.slidesToScroll,
                t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else
            o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
        return o - 1
    }
    ,
    e.prototype.getLeft = function(i) {
        var e, t, o, s, n = this, r = 0;
        return n.slideOffset = 0,
        t = n.$slides.first().outerHeight(!0),
        !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1,
        s = -1,
        !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)),
        r = t * n.options.slidesToShow * s),
        n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1,
        r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1,
        r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth,
        r = (i + n.options.slidesToShow - n.slideCount) * t),
        n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0,
        r = 0),
        !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0,
        n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)),
        e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r,
        !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow),
        e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0,
        !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1),
        e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0,
        e += (n.$list.width() - o.outerWidth()) / 2)),
        e
    }
    ,
    e.prototype.getOption = e.prototype.slickGetOption = function(i) {
        return this.options[i]
    }
    ,
    e.prototype.getNavigableIndexes = function() {
        var i, e = this, t = 0, o = 0, s = [];
        for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll,
        o = -1 * e.options.slidesToScroll,
        i = 2 * e.slideCount); t < i; )
            s.push(t),
            t = o + e.options.slidesToScroll,
            o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }
    ,
    e.prototype.getSlick = function() {
        return this
    }
    ,
    e.prototype.getSlideCount = function() {
        var e, t, o = this;
        return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0,
        !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(s, n) {
            if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
                return e = n,
                !1
        }),
        Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }
    ,
    e.prototype.goTo = e.prototype.slickGoTo = function(i, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(i)
            }
        }, e)
    }
    ,
    e.prototype.init = function(e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e && t.$slider.trigger("init", [t]),
        !0 === t.options.accessibility && t.initADA(),
        t.options.autoplay && (t.paused = !1,
        t.autoPlay())
    }
    ,
    e.prototype.initADA = function() {
        var e = this
          , t = Math.ceil(e.slideCount / e.options.slidesToShow)
          , o = e.getNavigableIndexes().filter(function(i) {
            return i >= 0 && i < e.slideCount
        });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t) {
            var s = o.indexOf(t);
            i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + t,
                tabindex: -1
            }),
            -1 !== s && i(this).attr({
                "aria-describedby": "slick-slide-control" + e.instanceUid + s
            })
        }),
        e.$dots.attr("role", "tablist").find("li").each(function(s) {
            var n = o[s];
            i(this).attr({
                role: "presentation"
            }),
            i(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + s,
                "aria-controls": "slick-slide" + e.instanceUid + n,
                "aria-label": s + 1 + " of " + t,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
            e.$slides.eq(s).attr("tabindex", 0);
        e.activateADA()
    }
    ,
    e.prototype.initArrowEvents = function() {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, i.changeSlide),
        i.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, i.changeSlide),
        !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler),
        i.$nextArrow.on("keydown.slick", i.keyHandler)))
    }
    ,
    e.prototype.initDotEvents = function() {
        var e = this;
        !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide),
        !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)),
        !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }
    ,
    e.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
    }
    ,
    e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler),
        e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler),
        e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("click.slick", e.clickHandler),
        i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
        !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
        i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
        i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(e.setPosition)
    }
    ,
    e.prototype.initUI = function() {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(),
        i.$nextArrow.show()),
        !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }
    ,
    e.prototype.keyHandler = function(i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "next" : "previous"
            }
        }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "previous" : "next"
            }
        }))
    }
    ,
    e.prototype.lazyLoad = function() {
        function e(e) {
            i("img[data-lazy]", e).each(function() {
                var e = i(this)
                  , t = i(this).attr("data-lazy")
                  , o = i(this).attr("data-srcset")
                  , s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes")
                  , r = document.createElement("img");
                r.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        o && (e.attr("srcset", o),
                        s && e.attr("sizes", s)),
                        e.attr("src", t).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }),
                        n.$slider.trigger("lazyLoaded", [n, e, t])
                    })
                }
                ,
                r.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    n.$slider.trigger("lazyLoadError", [n, e, t])
                }
                ,
                r.src = t
            })
        }
        var t, o, s, n = this;
        if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)),
        s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide,
        s = Math.ceil(o + n.options.slidesToShow),
        !0 === n.options.fade && (o > 0 && o--,
        s <= n.slideCount && s++)),
        t = n.$slider.find(".slick-slide").slice(o, s),
        "anticipated" === n.options.lazyLoad)
            for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++)
                r < 0 && (r = n.slideCount - 1),
                t = (t = t.add(d.eq(r))).add(d.eq(l)),
                r--,
                l++;
        e(t),
        n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
    }
    ,
    e.prototype.loadSlider = function() {
        var i = this;
        i.setPosition(),
        i.$slideTrack.css({
            opacity: 1
        }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }
    ,
    e.prototype.next = e.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    e.prototype.orientationChange = function() {
        var i = this;
        i.checkResponsive(),
        i.setPosition()
    }
    ,
    e.prototype.pause = e.prototype.slickPause = function() {
        var i = this;
        i.autoPlayClear(),
        i.paused = !0
    }
    ,
    e.prototype.play = e.prototype.slickPlay = function() {
        var i = this;
        i.autoPlay(),
        i.options.autoplay = !0,
        i.paused = !1,
        i.focussed = !1,
        i.interrupted = !1
    }
    ,
    e.prototype.postSlide = function(e) {
        var t = this;
        t.unslicked || (t.$slider.trigger("afterChange", [t, e]),
        t.animating = !1,
        t.slideCount > t.options.slidesToShow && t.setPosition(),
        t.swipeLeft = null,
        t.options.autoplay && t.autoPlay(),
        !0 === t.options.accessibility && (t.initADA(),
        t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
    }
    ,
    e.prototype.prev = e.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }
    ,
    e.prototype.preventDefault = function(i) {
        i.preventDefault()
    }
    ,
    e.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var t, o, s, n, r, l = this, d = i("img[data-lazy]", l.$slider);
        d.length ? (t = d.first(),
        o = t.attr("data-lazy"),
        s = t.attr("data-srcset"),
        n = t.attr("data-sizes") || l.$slider.attr("data-sizes"),
        (r = document.createElement("img")).onload = function() {
            s && (t.attr("srcset", s),
            n && t.attr("sizes", n)),
            t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
            !0 === l.options.adaptiveHeight && l.setPosition(),
            l.$slider.trigger("lazyLoaded", [l, t, o]),
            l.progressiveLazyLoad()
        }
        ,
        r.onerror = function() {
            e < 3 ? setTimeout(function() {
                l.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
            l.$slider.trigger("lazyLoadError", [l, t, o]),
            l.progressiveLazyLoad())
        }
        ,
        r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
    }
    ,
    e.prototype.refresh = function(e) {
        var t, o, s = this;
        o = s.slideCount - s.options.slidesToShow,
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        t = s.currentSlide,
        s.destroy(!0),
        i.extend(s, s.initials, {
            currentSlide: t
        }),
        s.init(),
        e || s.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !1)
    }
    ,
    e.prototype.registerBreakpoints = function() {
        var e, t, o, s = this, n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
            s.respondTo = s.options.respondTo || "window";
            for (e in n)
                if (o = s.breakpoints.length - 1,
                n.hasOwnProperty(e)) {
                    for (t = n[e].breakpoint; o >= 0; )
                        s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1),
                        o--;
                    s.breakpoints.push(t),
                    s.breakpointSettings[t] = n[e].settings
                }
            s.breakpoints.sort(function(i, e) {
                return s.options.mobileFirst ? i - e : e - i
            })
        }
    }
    ,
    e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
        e.setPosition(),
        e.focusHandler(),
        e.paused = !e.options.autoplay,
        e.autoPlay(),
        e.$slider.trigger("reInit", [e])
    }
    ,
    e.prototype.resize = function() {
        var e = this;
        i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
        e.windowDelay = window.setTimeout(function() {
            e.windowWidth = i(window).width(),
            e.checkResponsive(),
            e.unslicked || e.setPosition()
        }, 50))
    }
    ,
    e.prototype.removeSlide = e.prototype.slickRemove = function(i, e, t) {
        var o = this;
        if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i,
        o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
            return !1;
        o.unload(),
        !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
        o.$slides = o.$slideTrack.children(this.options.slide),
        o.$slideTrack.children(this.options.slide).detach(),
        o.$slideTrack.append(o.$slides),
        o.$slidesCache = o.$slides,
        o.reinit()
    }
    ,
    e.prototype.setCSS = function(i) {
        var e, t, o = this, s = {};
        !0 === o.options.rtl && (i = -i),
        e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px",
        t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px",
        s[o.positionProp] = i,
        !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {},
        !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")",
        o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)",
        o.$slideTrack.css(s)))
    }
    ,
    e.prototype.setDimensions = function() {
        var i = this;
        !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
            padding: "0px " + i.options.centerPadding
        }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
        !0 === i.options.centerMode && i.$list.css({
            padding: i.options.centerPadding + " 0px"
        })),
        i.listWidth = i.$list.width(),
        i.listHeight = i.$list.height(),
        !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow),
        i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth),
        i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
    }
    ,
    e.prototype.setFade = function() {
        var e, t = this;
        t.$slides.each(function(o, s) {
            e = t.slideWidth * o * -1,
            !0 === t.options.rtl ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            }) : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            })
        }),
        t.$slides.eq(t.currentSlide).css({
            zIndex: t.options.zIndex - 1,
            opacity: 1
        })
    }
    ,
    e.prototype.setHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
    }
    ,
    e.prototype.setOption = e.prototype.slickSetOption = function() {
        var e, t, o, s, n, r = this, l = !1;
        if ("object" === i.type(arguments[0]) ? (o = arguments[0],
        l = arguments[1],
        n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0],
        s = arguments[1],
        l = arguments[2],
        "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")),
        "single" === n)
            r.options[o] = s;
        else if ("multiple" === n)
            i.each(o, function(i, e) {
                r.options[i] = e
            });
        else if ("responsive" === n)
            for (t in s)
                if ("array" !== i.type(r.options.responsive))
                    r.options.responsive = [s[t]];
                else {
                    for (e = r.options.responsive.length - 1; e >= 0; )
                        r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1),
                        e--;
                    r.options.responsive.push(s[t])
                }
        l && (r.unload(),
        r.reinit())
    }
    ,
    e.prototype.setPosition = function() {
        var i = this;
        i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(),
        i.$slider.trigger("setPosition", [i])
    }
    ,
    e.prototype.setProps = function() {
        var i = this
          , e = document.body.style;
        i.positionProp = !0 === i.options.vertical ? "top" : "left",
        "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
        void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0),
        i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex),
        void 0 !== e.OTransform && (i.animType = "OTransform",
        i.transformType = "-o-transform",
        i.transitionType = "OTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.MozTransform && (i.animType = "MozTransform",
        i.transformType = "-moz-transform",
        i.transitionType = "MozTransition",
        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
        void 0 !== e.webkitTransform && (i.animType = "webkitTransform",
        i.transformType = "-webkit-transform",
        i.transitionType = "webkitTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.msTransform && (i.animType = "msTransform",
        i.transformType = "-ms-transform",
        i.transitionType = "msTransition",
        void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform",
        i.transformType = "transform",
        i.transitionType = "transition"),
        i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
    }
    ,
    e.prototype.setSlideClasses = function(i) {
        var e, t, o, s, n = this;
        if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
        n.$slides.eq(i).addClass("slick-current"),
        !0 === n.options.centerMode) {
            var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
            e = Math.floor(n.options.slidesToShow / 2),
            !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i,
            t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
            0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
            n.$slides.eq(i).addClass("slick-center")
        } else
            i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow,
            o = !0 === n.options.infinite ? n.options.slidesToShow + i : i,
            n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }
    ,
    e.prototype.setupInfinite = function() {
        var e, t, o, s = this;
        if (!0 === s.options.fade && (s.options.centerMode = !1),
        !0 === s.options.infinite && !1 === s.options.fade && (t = null,
        s.slideCount > s.options.slidesToShow)) {
            for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow,
            e = s.slideCount; e > s.slideCount - o; e -= 1)
                t = e - 1,
                i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < o + s.slideCount; e += 1)
                t = e,
                i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                i(this).attr("id", "")
            })
        }
    }
    ,
    e.prototype.interrupt = function(i) {
        var e = this;
        i || e.autoPlay(),
        e.interrupted = i
    }
    ,
    e.prototype.selectHandler = function(e) {
        var t = this
          , o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide")
          , s = parseInt(o.attr("data-slick-index"));
        s || (s = 0),
        t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s)
    }
    ,
    e.prototype.slideHandler = function(i, e, t) {
        var o, s, n, r, l, d = null, a = this;
        if (e = e || !1,
        !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i))
            if (!1 === e && a.asNavFor(i),
            o = i,
            d = a.getLeft(o),
            r = a.getLeft(a.currentSlide),
            a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft,
            !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
                !1 === a.options.fade && (o = a.currentSlide,
                !0 !== t ? a.animateSlide(r, function() {
                    a.postSlide(o)
                }) : a.postSlide(o));
            else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll))
                !1 === a.options.fade && (o = a.currentSlide,
                !0 !== t ? a.animateSlide(r, function() {
                    a.postSlide(o)
                }) : a.postSlide(o));
            else {
                if (a.options.autoplay && clearInterval(a.autoPlayTimer),
                s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o,
                a.animating = !0,
                a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                n = a.currentSlide,
                a.currentSlide = s,
                a.setSlideClasses(a.currentSlide),
                a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide),
                a.updateDots(),
                a.updateArrows(),
                !0 === a.options.fade)
                    return !0 !== t ? (a.fadeSlideOut(n),
                    a.fadeSlide(s, function() {
                        a.postSlide(s)
                    })) : a.postSlide(s),
                    void a.animateHeight();
                !0 !== t ? a.animateSlide(d, function() {
                    a.postSlide(s)
                }) : a.postSlide(s)
            }
    }
    ,
    e.prototype.startLoad = function() {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(),
        i.$nextArrow.hide()),
        !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
        i.$slider.addClass("slick-loading")
    }
    ,
    e.prototype.swipeDirection = function() {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX,
        e = s.touchObject.startY - s.touchObject.curY,
        t = Math.atan2(e, i),
        (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
    }
    ,
    e.prototype.swipeEnd = function(i) {
        var e, t, o = this;
        if (o.dragging = !1,
        o.swiping = !1,
        o.scrolling)
            return o.scrolling = !1,
            !1;
        if (o.interrupted = !1,
        o.shouldClick = !(o.touchObject.swipeLength > 10),
        void 0 === o.touchObject.curX)
            return !1;
        if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {
            case "left":
            case "down":
                e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(),
                o.currentDirection = 0;
                break;
            case "right":
            case "up":
                e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(),
                o.currentDirection = 1
            }
            "vertical" != t && (o.slideHandler(e),
            o.touchObject = {},
            o.$slider.trigger("swipe", [o, t]))
        } else
            o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide),
            o.touchObject = {})
    }
    ,
    e.prototype.swipeHandler = function(i) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend"in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse")))
            switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1,
            e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
            !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
            i.data.action) {
            case "start":
                e.swipeStart(i);
                break;
            case "move":
                e.swipeMove(i);
                break;
            case "end":
                e.swipeEnd(i)
            }
    }
    ,
    e.prototype.swipeMove = function(i) {
        var e, t, o, s, n, r, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null,
        !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide),
        l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX,
        l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY,
        l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))),
        r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))),
        !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0,
        !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r),
        t = l.swipeDirection(),
        void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0,
        i.preventDefault()),
        s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1),
        !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
        o = l.touchObject.swipeLength,
        l.touchObject.edgeHit = !1,
        !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction,
        l.touchObject.edgeHit = !0),
        !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s,
        !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
        !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null,
        !1) : void l.setCSS(l.swipeLeft))))
    }
    ,
    e.prototype.swipeStart = function(i) {
        var e, t = this;
        if (t.interrupted = !0,
        1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow)
            return t.touchObject = {},
            !1;
        void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
        t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX,
        t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY,
        t.dragging = !0
    }
    ,
    e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var i = this;
        null !== i.$slidesCache && (i.unload(),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slidesCache.appendTo(i.$slideTrack),
        i.reinit())
    }
    ,
    e.prototype.unload = function() {
        var e = this;
        i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
        e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
        e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }
    ,
    e.prototype.unslick = function(i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]),
        e.destroy()
    }
    ,
    e.prototype.updateArrows = function() {
        var i = this;
        Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }
    ,
    e.prototype.updateDots = function() {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(),
        i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
    }
    ,
    e.prototype.visibility = function() {
        var i = this;
        i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
    }
    ,
    i.fn.slick = function() {
        var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), r = o.length;
        for (i = 0; i < r; i++)
            if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i],s) : t = o[i].slick[s].apply(o[i].slick, n),
            void 0 !== t)
                return t;
        return o
    }
});

/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
!function(a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery)
}(function(a) {
    "use strict";
    function b(a) {
        if (a instanceof Date)
            return a;
        if (String(a).match(g))
            return String(a).match(/^[0-9]*$/) && (a = Number(a)),
            String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")),
            new Date(a);
        throw new Error("Couldn't cast `" + a + "` to a date object.")
    }
    function c(a) {
        var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(b)
    }
    function d(a) {
        return function(b) {
            var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (d)
                for (var f = 0, g = d.length; f < g; ++f) {
                    var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/)
                      , j = c(h[0])
                      , k = h[1] || ""
                      , l = h[3] || ""
                      , m = null;
                    h = h[2],
                    i.hasOwnProperty(h) && (m = i[h],
                    m = Number(a[m])),
                    null !== m && ("!" === k && (m = e(l, m)),
                    "" === k && m < 10 && (m = "0" + m.toString()),
                    b = b.replace(j, m.toString()))
                }
            return b = b.replace(/%%/, "%")
        }
    }
    function e(a, b) {
        var c = "s"
          , d = "";
        return a && (a = a.replace(/(:|;|\s)/gi, "").split(/\,/),
        1 === a.length ? c = a[0] : (d = a[0],
        c = a[1])),
        Math.abs(b) > 1 ? c : d
    }
    var f = []
      , g = []
      , h = {
        precision: 100,
        elapse: !1,
        defer: !1
    };
    g.push(/^[0-9]*$/.source),
    g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g = new RegExp(g.join("|"));
    var i = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        d: "daysToWeek",
        w: "weeks",
        W: "weeksToMonth",
        H: "hours",
        M: "minutes",
        S: "seconds",
        D: "totalDays",
        I: "totalHours",
        N: "totalMinutes",
        T: "totalSeconds"
    }
      , j = function(b, c, d) {
        this.el = b,
        this.$el = a(b),
        this.interval = null,
        this.offset = {},
        this.options = a.extend({}, h),
        this.instanceNumber = f.length,
        f.push(this),
        this.$el.data("countdown-instance", this.instanceNumber),
        d && ("function" == typeof d ? (this.$el.on("update.countdown", d),
        this.$el.on("stoped.countdown", d),
        this.$el.on("finish.countdown", d)) : this.options = a.extend({}, h, d)),
        this.setFinalDate(c),
        this.options.defer === !1 && this.start()
    };
    a.extend(j.prototype, {
        start: function() {
            null !== this.interval && clearInterval(this.interval);
            var a = this;
            this.update(),
            this.interval = setInterval(function() {
                a.update.call(a)
            }, this.options.precision)
        },
        stop: function() {
            clearInterval(this.interval),
            this.interval = null,
            this.dispatchEvent("stoped")
        },
        toggle: function() {
            this.interval ? this.stop() : this.start()
        },
        pause: function() {
            this.stop()
        },
        resume: function() {
            this.start()
        },
        remove: function() {
            this.stop.call(this),
            f[this.instanceNumber] = null,
            delete this.$el.data().countdownInstance
        },
        setFinalDate: function(a) {
            this.finalDate = b(a)
        },
        update: function() {
            if (0 === this.$el.closest("html").length)
                return void this.remove();
            var b, c = void 0 !== a._data(this.el, "events"), d = new Date;
            b = this.finalDate.getTime() - d.getTime(),
            b = Math.ceil(b / 1e3),
            b = !this.options.elapse && b < 0 ? 0 : Math.abs(b),
            this.totalSecsLeft !== b && c && (this.totalSecsLeft = b,
            this.elapsed = d >= this.finalDate,
            this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - d.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft
            },
            this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(),
            this.dispatchEvent("finish")))
        },
        dispatchEvent: function(b) {
            var c = a.Event(b + ".countdown");
            c.finalDate = this.finalDate,
            c.elapsed = this.elapsed,
            c.offset = a.extend({}, this.offset),
            c.strftime = d(this.offset),
            this.$el.trigger(c)
        }
    }),
    a.fn.countdown = function() {
        var b = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var c = a(this).data("countdown-instance");
            if (void 0 !== c) {
                var d = f[c]
                  , e = b[0];
                j.prototype.hasOwnProperty(e) ? d[e].apply(d, b.slice(1)) : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i) ? (d.setFinalDate.call(d, e),
                d.start()) : a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, e))
            } else
                new j(this,b[0],b[1])
        })
    }
});

/*! odometer 0.4.6 */
(function() {
    var a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G = [].slice;
    q = '<span class="odometer-value"></span>',
    n = '<span class="odometer-ribbon"><span class="odometer-ribbon-inner">' + q + "</span></span>",
    d = '<span class="odometer-digit"><span class="odometer-digit-spacer">8</span><span class="odometer-digit-inner">' + n + "</span></span>",
    g = '<span class="odometer-formatting-mark"></span>',
    c = "(,ddd).dd",
    h = /^\(?([^)]*)\)?(?:(.)(d+))?$/,
    i = 30,
    f = 2e3,
    a = 20,
    j = 2,
    e = .5,
    k = 1e3 / i,
    b = 1e3 / a,
    o = "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",
    y = document.createElement("div").style,
    p = null != y.transition || null != y.webkitTransition || null != y.mozTransition || null != y.oTransition,
    w = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame,
    l = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
    s = function(a) {
        var b;
        return b = document.createElement("div"),
        b.innerHTML = a,
        b.children[0]
    }
    ,
    v = function(a, b) {
        return a.className = a.className.replace(new RegExp("(^| )" + b.split(" ").join("|") + "( |$)","gi"), " ")
    }
    ,
    r = function(a, b) {
        return v(a, b),
        a.className += " " + b
    }
    ,
    z = function(a, b) {
        var c;
        return null != document.createEvent ? (c = document.createEvent("HTMLEvents"),
        c.initEvent(b, !0, !0),
        a.dispatchEvent(c)) : void 0
    }
    ,
    u = function() {
        var a, b;
        return null != (a = null != (b = window.performance) ? "function" == typeof b.now ? b.now() : void 0 : void 0) ? a : +new Date
    }
    ,
    x = function(a, b) {
        return null == b && (b = 0),
        b ? (a *= Math.pow(10, b),
        a += .5,
        a = Math.floor(a),
        a /= Math.pow(10, b)) : Math.round(a)
    }
    ,
    A = function(a) {
        return 0 > a ? Math.ceil(a) : Math.floor(a)
    }
    ,
    t = function(a) {
        return a - x(a)
    }
    ,
    C = !1,
    (B = function() {
        var a, b, c, d, e;
        if (!C && null != window.jQuery) {
            for (C = !0,
            d = ["html", "text"],
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(function(a) {
                    var b;
                    return b = window.jQuery.fn[a],
                    window.jQuery.fn[a] = function(a) {
                        var c;
                        return null == a || null == (null != (c = this[0]) ? c.odometer : void 0) ? b.apply(this, arguments) : this[0].odometer.update(a)
                    }
                }(a));
            return e
        }
    }
    )(),
    setTimeout(B, 0),
    m = function() {
        function a(b) {
            var c, d, e, g, h, i, l, m, n, o, p = this;
            if (this.options = b,
            this.el = this.options.el,
            null != this.el.odometer)
                return this.el.odometer;
            this.el.odometer = this,
            m = a.options;
            for (d in m)
                g = m[d],
                null == this.options[d] && (this.options[d] = g);
            null == (h = this.options).duration && (h.duration = f),
            this.MAX_VALUES = this.options.duration / k / j | 0,
            this.resetFormat(),
            this.value = this.cleanValue(null != (n = this.options.value) ? n : ""),
            this.renderInside(),
            this.render();
            try {
                for (o = ["innerHTML", "innerText", "textContent"],
                i = 0,
                l = o.length; l > i; i++)
                    e = o[i],
                    null != this.el[e] && !function(a) {
                        return Object.defineProperty(p.el, a, {
                            get: function() {
                                var b;
                                return "innerHTML" === a ? p.inside.outerHTML : null != (b = p.inside.innerText) ? b : p.inside.textContent
                            },
                            set: function(a) {
                                return p.update(a)
                            }
                        })
                    }(e)
            } catch (q) {
                c = q,
                this.watchForMutations()
            }
        }
        return a.prototype.renderInside = function() {
            return this.inside = document.createElement("div"),
            this.inside.className = "odometer-inside",
            this.el.innerHTML = "",
            this.el.appendChild(this.inside)
        }
        ,
        a.prototype.watchForMutations = function() {
            var a, b = this;
            if (null != l)
                try {
                    return null == this.observer && (this.observer = new l(function() {
                        var a;
                        return a = b.el.innerText,
                        b.renderInside(),
                        b.render(b.value),
                        b.update(a)
                    }
                    )),
                    this.watchMutations = !0,
                    this.startWatchingMutations()
                } catch (c) {
                    a = c
                }
        }
        ,
        a.prototype.startWatchingMutations = function() {
            return this.watchMutations ? this.observer.observe(this.el, {
                childList: !0
            }) : void 0
        }
        ,
        a.prototype.stopWatchingMutations = function() {
            var a;
            return null != (a = this.observer) ? a.disconnect() : void 0
        }
        ,
        a.prototype.cleanValue = function(a) {
            var b;
            return "string" == typeof a && (a = a.replace(null != (b = this.format.radix) ? b : ".", "<radix>"),
            a = a.replace(/[.,]/g, ""),
            a = a.replace("<radix>", "."),
            a = parseFloat(a, 10) || 0),
            x(a, this.format.precision)
        }
        ,
        a.prototype.bindTransitionEnd = function() {
            var a, b, c, d, e, f, g = this;
            if (!this.transitionEndBound) {
                for (this.transitionEndBound = !0,
                b = !1,
                e = o.split(" "),
                f = [],
                c = 0,
                d = e.length; d > c; c++)
                    a = e[c],
                    f.push(this.el.addEventListener(a, function() {
                        return b ? !0 : (b = !0,
                        setTimeout(function() {
                            return g.render(),
                            b = !1,
                            z(g.el, "odometerdone")
                        }, 0),
                        !0)
                    }, !1));
                return f
            }
        }
        ,
        a.prototype.resetFormat = function() {
            var a, b, d, e, f, g, i, j;
            if (a = null != (i = this.options.format) ? i : c,
            a || (a = "d"),
            d = h.exec(a),
            !d)
                throw new Error("Odometer: Unparsable digit format");
            return j = d.slice(1, 4),
            g = j[0],
            f = j[1],
            b = j[2],
            e = (null != b ? b.length : void 0) || 0,
            this.format = {
                repeating: g,
                radix: f,
                precision: e
            }
        }
        ,
        a.prototype.render = function(a) {
            var b, c, d, e, f, g, h, i, j, k, l, m;
            for (null == a && (a = this.value),
            this.stopWatchingMutations(),
            this.resetFormat(),
            this.inside.innerHTML = "",
            g = this.options.theme,
            b = this.el.className.split(" "),
            f = [],
            i = 0,
            k = b.length; k > i; i++)
                c = b[i],
                c.length && ((e = /^odometer-theme-(.+)$/.exec(c)) ? g = e[1] : /^odometer(-|$)/.test(c) || f.push(c));
            for (f.push("odometer"),
            p || f.push("odometer-no-transitions"),
            f.push(g ? "odometer-theme-" + g : "odometer-auto-theme"),
            this.el.className = f.join(" "),
            this.ribbons = {},
            this.digits = [],
            h = !this.format.precision || !t(a) || !1,
            m = a.toString().split("").reverse(),
            j = 0,
            l = m.length; l > j; j++)
                d = m[j],
                "." === d && (h = !0),
                this.addDigit(d, h);
            return this.startWatchingMutations()
        }
        ,
        a.prototype.update = function(a) {
            var b, c = this;
            return a = this.cleanValue(a),
            (b = a - this.value) ? (v(this.el, "odometer-animating-up odometer-animating-down odometer-animating"),
            b > 0 ? r(this.el, "odometer-animating-up") : r(this.el, "odometer-animating-down"),
            this.stopWatchingMutations(),
            this.animate(a),
            this.startWatchingMutations(),
            setTimeout(function() {
                return c.el.offsetHeight,
                r(c.el, "odometer-animating")
            }, 0),
            this.value = a) : void 0
        }
        ,
        a.prototype.renderDigit = function() {
            return s(d)
        }
        ,
        a.prototype.insertDigit = function(a, b) {
            return null != b ? this.inside.insertBefore(a, b) : this.inside.children.length ? this.inside.insertBefore(a, this.inside.children[0]) : this.inside.appendChild(a)
        }
        ,
        a.prototype.addSpacer = function(a, b, c) {
            var d;
            return d = s(g),
            d.innerHTML = a,
            c && r(d, c),
            this.insertDigit(d, b)
        }
        ,
        a.prototype.addDigit = function(a, b) {
            var c, d, e, f;
            if (null == b && (b = !0),
            "-" === a)
                return this.addSpacer(a, null, "odometer-negation-mark");
            if ("." === a)
                return this.addSpacer(null != (f = this.format.radix) ? f : ".", null, "odometer-radix-mark");
            if (b)
                for (e = !1; ; ) {
                    if (!this.format.repeating.length) {
                        if (e)
                            throw new Error("Bad odometer format without digits");
                        this.resetFormat(),
                        e = !0
                    }
                    if (c = this.format.repeating[this.format.repeating.length - 1],
                    this.format.repeating = this.format.repeating.substring(0, this.format.repeating.length - 1),
                    "d" === c)
                        break;
                    this.addSpacer(c)
                }
            return d = this.renderDigit(),
            d.querySelector(".odometer-value").innerHTML = a,
            this.digits.push(d),
            this.insertDigit(d)
        }
        ,
        a.prototype.animate = function(a) {
            return p && "count" !== this.options.animation ? this.animateSlide(a) : this.animateCount(a)
        }
        ,
        a.prototype.animateCount = function(a) {
            var c, d, e, f, g, h = this;
            if (d = +a - this.value)
                return f = e = u(),
                c = this.value,
                (g = function() {
                    var i, j, k;
                    return u() - f > h.options.duration ? (h.value = a,
                    h.render(),
                    void z(h.el, "odometerdone")) : (i = u() - e,
                    i > b && (e = u(),
                    k = i / h.options.duration,
                    j = d * k,
                    c += j,
                    h.render(Math.round(c))),
                    null != w ? w(g) : setTimeout(g, b))
                }
                )()
        }
        ,
        a.prototype.getDigitCount = function() {
            var a, b, c, d, e, f;
            for (d = 1 <= arguments.length ? G.call(arguments, 0) : [],
            a = e = 0,
            f = d.length; f > e; a = ++e)
                c = d[a],
                d[a] = Math.abs(c);
            return b = Math.max.apply(Math, d),
            Math.ceil(Math.log(b + 1) / Math.log(10))
        }
        ,
        a.prototype.getFractionalDigitCount = function() {
            var a, b, c, d, e, f, g;
            for (e = 1 <= arguments.length ? G.call(arguments, 0) : [],
            b = /^\-?\d*\.(\d*?)0*$/,
            a = f = 0,
            g = e.length; g > f; a = ++f)
                d = e[a],
                e[a] = d.toString(),
                c = b.exec(e[a]),
                e[a] = null == c ? 0 : c[1].length;
            return Math.max.apply(Math, e)
        }
        ,
        a.prototype.resetDigits = function() {
            return this.digits = [],
            this.ribbons = [],
            this.inside.innerHTML = "",
            this.resetFormat()
        }
        ,
        a.prototype.animateSlide = function(a) {
            var b, c, d, f, g, h, i, j, k, l, m, n, o, p, q, s, t, u, v, w, x, y, z, B, C, D, E;
            if (s = this.value,
            j = this.getFractionalDigitCount(s, a),
            j && (a *= Math.pow(10, j),
            s *= Math.pow(10, j)),
            d = a - s) {
                for (this.bindTransitionEnd(),
                f = this.getDigitCount(s, a),
                g = [],
                b = 0,
                m = v = 0; f >= 0 ? f > v : v > f; m = f >= 0 ? ++v : --v) {
                    if (t = A(s / Math.pow(10, f - m - 1)),
                    i = A(a / Math.pow(10, f - m - 1)),
                    h = i - t,
                    Math.abs(h) > this.MAX_VALUES) {
                        for (l = [],
                        n = h / (this.MAX_VALUES + this.MAX_VALUES * b * e),
                        c = t; h > 0 && i > c || 0 > h && c > i; )
                            l.push(Math.round(c)),
                            c += n;
                        l[l.length - 1] !== i && l.push(i),
                        b++
                    } else
                        l = function() {
                            E = [];
                            for (var a = t; i >= t ? i >= a : a >= i; i >= t ? a++ : a--)
                                E.push(a);
                            return E
                        }
                        .apply(this);
                    for (m = w = 0,
                    y = l.length; y > w; m = ++w)
                        k = l[m],
                        l[m] = Math.abs(k % 10);
                    g.push(l)
                }
                for (this.resetDigits(),
                D = g.reverse(),
                m = x = 0,
                z = D.length; z > x; m = ++x)
                    for (l = D[m],
                    this.digits[m] || this.addDigit(" ", m >= j),
                    null == (u = this.ribbons)[m] && (u[m] = this.digits[m].querySelector(".odometer-ribbon-inner")),
                    this.ribbons[m].innerHTML = "",
                    0 > d && (l = l.reverse()),
                    o = C = 0,
                    B = l.length; B > C; o = ++C)
                        k = l[o],
                        q = document.createElement("div"),
                        q.className = "odometer-value",
                        q.innerHTML = k,
                        this.ribbons[m].appendChild(q),
                        o === l.length - 1 && r(q, "odometer-last-value"),
                        0 === o && r(q, "odometer-first-value");
                return 0 > t && this.addDigit("-"),
                p = this.inside.querySelector(".odometer-radix-mark"),
                null != p && p.parent.removeChild(p),
                j ? this.addSpacer(this.format.radix, this.digits[j - 1], "odometer-radix-mark") : void 0
            }
        }
        ,
        a
    }(),
    m.options = null != (E = window.odometerOptions) ? E : {},
    setTimeout(function() {
        var a, b, c, d, e;
        if (window.odometerOptions) {
            d = window.odometerOptions,
            e = [];
            for (a in d)
                b = d[a],
                e.push(null != (c = m.options)[a] ? (c = m.options)[a] : c[a] = b);
            return e
        }
    }, 0),
    m.init = function() {
        var a, b, c, d, e, f;
        if (null != document.querySelectorAll) {
            for (b = document.querySelectorAll(m.options.selector || ".odometer"),
            f = [],
            c = 0,
            d = b.length; d > c; c++)
                a = b[c],
                f.push(a.odometer = new m({
                    el: a,
                    value: null != (e = a.innerText) ? e : a.textContent
                }));
            return f
        }
    }
    ,
    null != (null != (F = document.documentElement) ? F.doScroll : void 0) && null != document.createEventObject ? (D = document.onreadystatechange,
    document.onreadystatechange = function() {
        return "complete" === document.readyState && m.options.auto !== !1 && m.init(),
        null != D ? D.apply(this, arguments) : void 0
    }
    ) : document.addEventListener("DOMContentLoaded", function() {
        return m.options.auto !== !1 ? m.init() : void 0
    }, !1),
    "function" == typeof define && define.amd ? define(["jquery"], function() {
        return m
    }) : typeof exports === !1 ? module.exports = m : window.Odometer = m
}
).call(this);

/* Meanmenu */
!function($) {
    "use strict";
    $.fn.meanmenu = function(e) {
        var n = {
            meanMenuTarget: jQuery(this),
            meanMenuContainer: "body",
            meanMenuClose: "X",
            meanMenuCloseSize: "18px",
            meanMenuOpen: "<span /><span /><span />",
            meanRevealPosition: "right",
            meanRevealPositionDistance: "0",
            meanRevealColour: "",
            meanScreenWidth: "480",
            meanNavPush: "",
            meanShowChildren: !0,
            meanExpandableChildren: !0,
            meanExpand: "+",
            meanContract: "-",
            meanRemoveAttrs: !1,
            onePage: !1,
            meanDisplay: "block",
            removeElements: ""
        };
        e = $.extend(n, e);
        var a = window.innerWidth || document.documentElement.clientWidth;
        return this.each(function() {
            var n = e.meanMenuTarget
              , t = e.meanMenuContainer
              , r = e.meanMenuClose
              , i = e.meanMenuCloseSize
              , s = e.meanMenuOpen
              , u = e.meanRevealPosition
              , m = e.meanRevealPositionDistance
              , l = e.meanRevealColour
              , o = e.meanScreenWidth
              , c = e.meanNavPush
              , v = ".meanmenu-reveal"
              , h = e.meanShowChildren
              , d = e.meanExpandableChildren
              , y = e.meanExpand
              , j = e.meanContract
              , Q = e.meanRemoveAttrs
              , f = e.onePage
              , g = e.meanDisplay
              , p = e.removeElements
              , C = !1;
            (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/Blackberry/i) || navigator.userAgent.match(/Windows Phone/i)) && (C = !0),
            (navigator.userAgent.match(/MSIE 8/i) || navigator.userAgent.match(/MSIE 7/i)) && jQuery("html").css("overflow-y", "scroll");
            var w = ""
              , x = function() {
                if ("center" === u) {
                    var e = window.innerWidth || document.documentElement.clientWidth
                      , n = e / 2 - 22 + "px";
                    w = "left:" + n + ";right:auto;",
                    C ? jQuery(".meanmenu-reveal").animate({
                        left: n
                    }) : jQuery(".meanmenu-reveal").css("left", n)
                }
            }
              , A = !1
              , E = !1;
            "right" === u && (w = "right:" + m + ";left:auto;"),
            "left" === u && (w = "left:" + m + ";right:auto;"),
            x();
            var M = ""
              , P = function() {
                M.html(jQuery(M).is(".meanmenu-reveal.meanclose") ? r : s)
            }
              , W = function() {
                jQuery(".mean-bar,.mean-push").remove(),
                jQuery(t).removeClass("mean-container"),
                jQuery(n).css("display", g),
                A = !1,
                E = !1,
                jQuery(p).removeClass("mean-remove")
            }
              , b = function() {
                var e = "background:" + l + ";color:" + l + ";" + w;
                if (o >= a) {
                    jQuery(p).addClass("mean-remove"),
                    E = !0,
                    jQuery(t).addClass("mean-container"),
                    jQuery(".mean-container").prepend('<div class="mean-bar"><a href="#nav" class="meanmenu-reveal" style="' + e + '">Show Navigation</a><nav class="mean-nav"></nav></div>');
                    var r = jQuery(n).html();
                    jQuery(".mean-nav").html(r),
                    Q && jQuery("nav.mean-nav ul, nav.mean-nav ul *").each(function() {
                        jQuery(this).is(".mean-remove") ? jQuery(this).attr("class", "mean-remove") : jQuery(this).removeAttr("class"),
                        jQuery(this).removeAttr("id")
                    }),
                    jQuery(n).before('<div class="mean-push" />'),
                    jQuery(".mean-push").css("margin-top", c),
                    jQuery(n).hide(),
                    jQuery(".meanmenu-reveal").show(),
                    jQuery(v).html(s),
                    M = jQuery(v),
                    jQuery(".mean-nav ul").hide(),
                    h ? d ? (jQuery(".mean-nav ul ul").each(function() {
                        jQuery(this).children().length && jQuery(this, "li:first").parent().append('<a class="mean-expand" href="#" style="font-size: ' + i + '">' + y + "</a>")
                    }),
                    jQuery(".mean-expand").on("click", function(e) {
                        e.preventDefault(),
                        jQuery(this).hasClass("mean-clicked") ? (jQuery(this).text(y),
                        jQuery(this).prev("ul").slideUp(300, function() {})) : (jQuery(this).text(j),
                        jQuery(this).prev("ul").slideDown(300, function() {})),
                        jQuery(this).toggleClass("mean-clicked")
                    })) : jQuery(".mean-nav ul ul").show() : jQuery(".mean-nav ul ul").hide(),
                    jQuery(".mean-nav ul li").last().addClass("mean-last"),
                    M.removeClass("meanclose"),
                    jQuery(M).click(function(e) {
                        e.preventDefault(),
                        A === !1 ? (M.css("text-align", "center"),
                        M.css("text-indent", "0"),
                        M.css("font-size", i),
                        jQuery(".mean-nav ul:first").slideDown(),
                        A = !0) : (jQuery(".mean-nav ul:first").slideUp(),
                        A = !1),
                        M.toggleClass("meanclose"),
                        P(),
                        jQuery(p).addClass("mean-remove")
                    }),
                    f && jQuery(".mean-nav ul > li > a:first-child").on("click", function() {
                        jQuery(".mean-nav ul:first").slideUp(),
                        A = !1,
                        jQuery(M).toggleClass("meanclose").html(s)
                    })
                } else
                    W()
            };
            C || jQuery(window).resize(function() {
                a = window.innerWidth || document.documentElement.clientWidth,
                a > o,
                W(),
                o >= a ? (b(),
                x()) : W()
            }),
            jQuery(window).resize(function() {
                a = window.innerWidth || document.documentElement.clientWidth,
                C ? (x(),
                o >= a ? E === !1 && b() : W()) : (W(),
                o >= a && (b(),
                x()))
            }),
            b()
        })
    }
}(jQuery);

/**
 * sticky-sidebar - A JavaScript plugin for making smart and high performance.
 * @version v3.3.1
 * @link https://github.com/abouolia/sticky-sidebar
 * @author Ahmed Bouhuolia
 * @license The MIT License (MIT)
**/
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.StickySidebar = e()
}(this, function() {
    "use strict";
    "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
    function t(t) {
        return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t
    }
    function e(t, e) {
        return t(e = {
            exports: {}
        }, e.exports),
        e.exports
    }
    var i = e(function(t, e) {
        (function(t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var l, n, e = function() {
                function n(t, e) {
                    for (var i = 0; i < e.length; i++) {
                        var n = e[i];
                        n.enumerable = n.enumerable || !1,
                        n.configurable = !0,
                        "value"in n && (n.writable = !0),
                        Object.defineProperty(t, n.key, n)
                    }
                }
                return function(t, e, i) {
                    return e && n(t.prototype, e),
                    i && n(t, i),
                    t
                }
            }(), i = (l = ".stickySidebar",
            n = {
                topSpacing: 0,
                bottomSpacing: 0,
                containerSelector: !1,
                innerWrapperSelector: ".inner-wrapper-sticky",
                stickyClass: "is-affixed",
                resizeSensor: !0,
                minWidth: !1
            },
            function() {
                function c(t) {
                    var e = this
                      , i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                    if (function(t, e) {
                        if (!(t instanceof e))
                            throw new TypeError("Cannot call a class as a function")
                    }(this, c),
                    this.options = c.extend(n, i),
                    this.sidebar = "string" == typeof t ? document.querySelector(t) : t,
                    void 0 === this.sidebar)
                        throw new Error("There is no specific sidebar element.");
                    this.sidebarInner = !1,
                    this.container = this.sidebar.parentElement,
                    this.affixedType = "STATIC",
                    this.direction = "down",
                    this.support = {
                        transform: !1,
                        transform3d: !1
                    },
                    this._initialized = !1,
                    this._reStyle = !1,
                    this._breakpoint = !1,
                    this.dimensions = {
                        translateY: 0,
                        maxTranslateY: 0,
                        topSpacing: 0,
                        lastTopSpacing: 0,
                        bottomSpacing: 0,
                        lastBottomSpacing: 0,
                        sidebarHeight: 0,
                        sidebarWidth: 0,
                        containerTop: 0,
                        containerHeight: 0,
                        viewportHeight: 0,
                        viewportTop: 0,
                        lastViewportTop: 0
                    },
                    ["handleEvent"].forEach(function(t) {
                        e[t] = e[t].bind(e)
                    }),
                    this.initialize()
                }
                return e(c, [{
                    key: "initialize",
                    value: function() {
                        var i = this;
                        if (this._setSupportFeatures(),
                        this.options.innerWrapperSelector && (this.sidebarInner = this.sidebar.querySelector(this.options.innerWrapperSelector),
                        null === this.sidebarInner && (this.sidebarInner = !1)),
                        !this.sidebarInner) {
                            var t = document.createElement("div");
                            for (t.setAttribute("class", "inner-wrapper-sticky"),
                            this.sidebar.appendChild(t); this.sidebar.firstChild != t; )
                                t.appendChild(this.sidebar.firstChild);
                            this.sidebarInner = this.sidebar.querySelector(".inner-wrapper-sticky")
                        }
                        if (this.options.containerSelector) {
                            var e = document.querySelectorAll(this.options.containerSelector);
                            if ((e = Array.prototype.slice.call(e)).forEach(function(t, e) {
                                t.contains(i.sidebar) && (i.container = t)
                            }),
                            !e.length)
                                throw new Error("The container does not contains on the sidebar.")
                        }
                        "function" != typeof this.options.topSpacing && (this.options.topSpacing = parseInt(this.options.topSpacing) || 0),
                        "function" != typeof this.options.bottomSpacing && (this.options.bottomSpacing = parseInt(this.options.bottomSpacing) || 0),
                        this._widthBreakpoint(),
                        this.calcDimensions(),
                        this.stickyPosition(),
                        this.bindEvents(),
                        this._initialized = !0
                    }
                }, {
                    key: "bindEvents",
                    value: function() {
                        window.addEventListener("resize", this, {
                            passive: !0,
                            capture: !1
                        }),
                        window.addEventListener("scroll", this, {
                            passive: !0,
                            capture: !1
                        }),
                        this.sidebar.addEventListener("update" + l, this),
                        this.options.resizeSensor && "undefined" != typeof ResizeSensor && (new ResizeSensor(this.sidebarInner,this.handleEvent),
                        new ResizeSensor(this.container,this.handleEvent))
                    }
                }, {
                    key: "handleEvent",
                    value: function(t) {
                        this.updateSticky(t)
                    }
                }, {
                    key: "calcDimensions",
                    value: function() {
                        if (!this._breakpoint) {
                            var t = this.dimensions;
                            t.containerTop = c.offsetRelative(this.container).top,
                            t.containerHeight = this.container.clientHeight,
                            t.containerBottom = t.containerTop + t.containerHeight,
                            t.sidebarHeight = this.sidebarInner.offsetHeight,
                            t.sidebarWidth = this.sidebarInner.offsetWidth,
                            t.viewportHeight = window.innerHeight,
                            t.maxTranslateY = t.containerHeight - t.sidebarHeight,
                            this._calcDimensionsWithScroll()
                        }
                    }
                }, {
                    key: "_calcDimensionsWithScroll",
                    value: function() {
                        var t = this.dimensions;
                        t.sidebarLeft = c.offsetRelative(this.sidebar).left,
                        t.viewportTop = document.documentElement.scrollTop || document.body.scrollTop,
                        t.viewportBottom = t.viewportTop + t.viewportHeight,
                        t.viewportLeft = document.documentElement.scrollLeft || document.body.scrollLeft,
                        t.topSpacing = this.options.topSpacing,
                        t.bottomSpacing = this.options.bottomSpacing,
                        "function" == typeof t.topSpacing && (t.topSpacing = parseInt(t.topSpacing(this.sidebar)) || 0),
                        "function" == typeof t.bottomSpacing && (t.bottomSpacing = parseInt(t.bottomSpacing(this.sidebar)) || 0),
                        "VIEWPORT-TOP" === this.affixedType ? t.topSpacing < t.lastTopSpacing && (t.translateY += t.lastTopSpacing - t.topSpacing,
                        this._reStyle = !0) : "VIEWPORT-BOTTOM" === this.affixedType && t.bottomSpacing < t.lastBottomSpacing && (t.translateY += t.lastBottomSpacing - t.bottomSpacing,
                        this._reStyle = !0),
                        t.lastTopSpacing = t.topSpacing,
                        t.lastBottomSpacing = t.bottomSpacing
                    }
                }, {
                    key: "isSidebarFitsViewport",
                    value: function() {
                        var t = this.dimensions
                          , e = "down" === this.scrollDirection ? t.lastBottomSpacing : t.lastTopSpacing;
                        return this.dimensions.sidebarHeight + e < this.dimensions.viewportHeight
                    }
                }, {
                    key: "observeScrollDir",
                    value: function() {
                        var t = this.dimensions;
                        if (t.lastViewportTop !== t.viewportTop) {
                            var e = "down" === this.direction ? Math.min : Math.max;
                            t.viewportTop === e(t.viewportTop, t.lastViewportTop) && (this.direction = "down" === this.direction ? "up" : "down")
                        }
                    }
                }, {
                    key: "getAffixType",
                    value: function() {
                        this._calcDimensionsWithScroll();
                        var t = this.dimensions
                          , e = t.viewportTop + t.topSpacing
                          , i = this.affixedType;
                        return e <= t.containerTop || t.containerHeight <= t.sidebarHeight ? (t.translateY = 0,
                        i = "STATIC") : i = "up" === this.direction ? this._getAffixTypeScrollingUp() : this._getAffixTypeScrollingDown(),
                        t.translateY = Math.max(0, t.translateY),
                        t.translateY = Math.min(t.containerHeight, t.translateY),
                        t.translateY = Math.round(t.translateY),
                        t.lastViewportTop = t.viewportTop,
                        i
                    }
                }, {
                    key: "_getAffixTypeScrollingDown",
                    value: function() {
                        var t = this.dimensions
                          , e = t.sidebarHeight + t.containerTop
                          , i = t.viewportTop + t.topSpacing
                          , n = t.viewportBottom - t.bottomSpacing
                          , o = this.affixedType;
                        return this.isSidebarFitsViewport() ? t.sidebarHeight + i >= t.containerBottom ? (t.translateY = t.containerBottom - e,
                        o = "CONTAINER-BOTTOM") : i >= t.containerTop && (t.translateY = i - t.containerTop,
                        o = "VIEWPORT-TOP") : t.containerBottom <= n ? (t.translateY = t.containerBottom - e,
                        o = "CONTAINER-BOTTOM") : e + t.translateY <= n ? (t.translateY = n - e,
                        o = "VIEWPORT-BOTTOM") : t.containerTop + t.translateY <= i && 0 !== t.translateY && t.maxTranslateY !== t.translateY && (o = "VIEWPORT-UNBOTTOM"),
                        o
                    }
                }, {
                    key: "_getAffixTypeScrollingUp",
                    value: function() {
                        var t = this.dimensions
                          , e = t.sidebarHeight + t.containerTop
                          , i = t.viewportTop + t.topSpacing
                          , n = t.viewportBottom - t.bottomSpacing
                          , o = this.affixedType;
                        return i <= t.translateY + t.containerTop ? (t.translateY = i - t.containerTop,
                        o = "VIEWPORT-TOP") : t.containerBottom <= n ? (t.translateY = t.containerBottom - e,
                        o = "CONTAINER-BOTTOM") : this.isSidebarFitsViewport() || t.containerTop <= i && 0 !== t.translateY && t.maxTranslateY !== t.translateY && (o = "VIEWPORT-UNBOTTOM"),
                        o
                    }
                }, {
                    key: "_getStyle",
                    value: function(t) {
                        if (void 0 !== t) {
                            var e = {
                                inner: {},
                                outer: {}
                            }
                              , i = this.dimensions;
                            switch (t) {
                            case "VIEWPORT-TOP":
                                e.inner = {
                                    position: "fixed",
                                    top: i.topSpacing,
                                    left: i.sidebarLeft - i.viewportLeft,
                                    width: i.sidebarWidth
                                };
                                break;
                            case "VIEWPORT-BOTTOM":
                                e.inner = {
                                    position: "fixed",
                                    top: "auto",
                                    left: i.sidebarLeft,
                                    bottom: i.bottomSpacing,
                                    width: i.sidebarWidth
                                };
                                break;
                            case "CONTAINER-BOTTOM":
                            case "VIEWPORT-UNBOTTOM":
                                var n = this._getTranslate(0, i.translateY + "px");
                                e.inner = n ? {
                                    transform: n
                                } : {
                                    position: "absolute",
                                    top: i.translateY,
                                    width: i.sidebarWidth
                                }
                            }
                            switch (t) {
                            case "VIEWPORT-TOP":
                            case "VIEWPORT-BOTTOM":
                            case "VIEWPORT-UNBOTTOM":
                            case "CONTAINER-BOTTOM":
                                e.outer = {
                                    height: i.sidebarHeight,
                                    position: "relative"
                                }
                            }
                            return e.outer = c.extend({
                                height: "",
                                position: ""
                            }, e.outer),
                            e.inner = c.extend({
                                position: "relative",
                                top: "",
                                left: "",
                                bottom: "",
                                width: "",
                                transform: ""
                            }, e.inner),
                            e
                        }
                    }
                }, {
                    key: "stickyPosition",
                    value: function(t) {
                        if (!this._breakpoint) {
                            t = this._reStyle || t || !1,
                            this.options.topSpacing,
                            this.options.bottomSpacing;
                            var e = this.getAffixType()
                              , i = this._getStyle(e);
                            if ((this.affixedType != e || t) && e) {
                                var n = "affix." + e.toLowerCase().replace("viewport-", "") + l;
                                for (var o in c.eventTrigger(this.sidebar, n),
                                "STATIC" === e ? c.removeClass(this.sidebar, this.options.stickyClass) : c.addClass(this.sidebar, this.options.stickyClass),
                                i.outer) {
                                    var s = "number" == typeof i.outer[o] ? "px" : "";
                                    this.sidebar.style[o] = i.outer[o] + s
                                }
                                for (var r in i.inner) {
                                    var a = "number" == typeof i.inner[r] ? "px" : "";
                                    this.sidebarInner.style[r] = i.inner[r] + a
                                }
                                var p = "affixed." + e.toLowerCase().replace("viewport-", "") + l;
                                c.eventTrigger(this.sidebar, p)
                            } else
                                this._initialized && (this.sidebarInner.style.left = i.inner.left);
                            this.affixedType = e
                        }
                    }
                }, {
                    key: "_widthBreakpoint",
                    value: function() {
                        window.innerWidth <= this.options.minWidth ? (this._breakpoint = !0,
                        this.affixedType = "STATIC",
                        this.sidebar.removeAttribute("style"),
                        c.removeClass(this.sidebar, this.options.stickyClass),
                        this.sidebarInner.removeAttribute("style")) : this._breakpoint = !1
                    }
                }, {
                    key: "updateSticky",
                    value: function() {
                        var t, e = this, i = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                        this._running || (this._running = !0,
                        t = i.type,
                        requestAnimationFrame(function() {
                            switch (t) {
                            case "scroll":
                                e._calcDimensionsWithScroll(),
                                e.observeScrollDir(),
                                e.stickyPosition();
                                break;
                            case "resize":
                            default:
                                e._widthBreakpoint(),
                                e.calcDimensions(),
                                e.stickyPosition(!0)
                            }
                            e._running = !1
                        }))
                    }
                }, {
                    key: "_setSupportFeatures",
                    value: function() {
                        var t = this.support;
                        t.transform = c.supportTransform(),
                        t.transform3d = c.supportTransform(!0)
                    }
                }, {
                    key: "_getTranslate",
                    value: function() {
                        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0
                          , e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0
                          , i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0;
                        return this.support.transform3d ? "translate3d(" + t + ", " + e + ", " + i + ")" : !!this.support.translate && "translate(" + t + ", " + e + ")"
                    }
                }, {
                    key: "destroy",
                    value: function() {
                        window.removeEventListener("resize", this, {
                            capture: !1
                        }),
                        window.removeEventListener("scroll", this, {
                            capture: !1
                        }),
                        this.sidebar.classList.remove(this.options.stickyClass),
                        this.sidebar.style.minHeight = "",
                        this.sidebar.removeEventListener("update" + l, this);
                        var t = {
                            inner: {},
                            outer: {}
                        };
                        for (var e in t.inner = {
                            position: "",
                            top: "",
                            left: "",
                            bottom: "",
                            width: "",
                            transform: ""
                        },
                        t.outer = {
                            height: "",
                            position: ""
                        },
                        t.outer)
                            this.sidebar.style[e] = t.outer[e];
                        for (var i in t.inner)
                            this.sidebarInner.style[i] = t.inner[i];
                        this.options.resizeSensor && "undefined" != typeof ResizeSensor && (ResizeSensor.detach(this.sidebarInner, this.handleEvent),
                        ResizeSensor.detach(this.container, this.handleEvent))
                    }
                }], [{
                    key: "supportTransform",
                    value: function(t) {
                        var i = !1
                          , e = t ? "perspective" : "transform"
                          , n = e.charAt(0).toUpperCase() + e.slice(1)
                          , o = document.createElement("support").style;
                        return (e + " " + ["Webkit", "Moz", "O", "ms"].join(n + " ") + n).split(" ").forEach(function(t, e) {
                            if (void 0 !== o[t])
                                return i = t,
                                !1
                        }),
                        i
                    }
                }, {
                    key: "eventTrigger",
                    value: function(t, e, i) {
                        try {
                            var n = new CustomEvent(e,{
                                detail: i
                            })
                        } catch (t) {
                            (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, i)
                        }
                        t.dispatchEvent(n)
                    }
                }, {
                    key: "extend",
                    value: function(t, e) {
                        var i = {};
                        for (var n in t)
                            void 0 !== e[n] ? i[n] = e[n] : i[n] = t[n];
                        return i
                    }
                }, {
                    key: "offsetRelative",
                    value: function(t) {
                        var e = {
                            left: 0,
                            top: 0
                        };
                        do {
                            var i = t.offsetTop
                              , n = t.offsetLeft;
                            isNaN(i) || (e.top += i),
                            isNaN(n) || (e.left += n),
                            t = "BODY" === t.tagName ? t.parentElement : t.offsetParent
                        } while (t);
                        return e
                    }
                }, {
                    key: "addClass",
                    value: function(t, e) {
                        c.hasClass(t, e) || (t.classList ? t.classList.add(e) : t.className += " " + e)
                    }
                }, {
                    key: "removeClass",
                    value: function(t, e) {
                        c.hasClass(t, e) && (t.classList ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)","gi"), " "))
                    }
                }, {
                    key: "hasClass",
                    value: function(t, e) {
                        return t.classList ? t.classList.contains(e) : new RegExp("(^| )" + e + "( |$)","gi").test(t.className)
                    }
                }, {
                    key: "defaults",
                    get: function() {
                        return n
                    }
                }]),
                c
            }());
            t.default = i,
            window.StickySidebar = i
        }
        )(e)
    });
    return t(i),
    t(e(function(t, e) {
        (function(t) {
            var e, s = (e = t) && e.__esModule ? e : {
                default: e
            };
            !function() {
                if ("undefined" != typeof window) {
                    var n = window.$ || window.jQuery || window.Zepto
                      , o = "stickySidebar";
                    if (n) {
                        n.fn.stickySidebar = function(i) {
                            return this.each(function() {
                                var t = n(this)
                                  , e = n(this).data(o);
                                if (e || (e = new s.default(this,"object" == typeof i && i),
                                t.data(o, e)),
                                "string" == typeof i) {
                                    if (void 0 === e[i] && -1 === ["destroy", "updateSticky"].indexOf(i))
                                        throw new Error('No method named "' + i + '"');
                                    e[i]()
                                }
                            })
                        }
                        ,
                        n.fn.stickySidebar.Constructor = s.default;
                        var t = n.fn.stickySidebar;
                        n.fn.stickySidebar.noConflict = function() {
                            return n.fn.stickySidebar = t,
                            this
                        }
                    }
                }
            }()
        }
        )(i)
    }))
});

/*! lightgallery - v1.6.11 - 2018-05-22
* http://sachinchoolur.github.io/lightGallery/
* Copyright (c) 2018 Sachin N; Licensed GPLv3 */
!function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof module && module.exports ? module.exports = b(require("jquery")) : b(a.jQuery)
}(this, function(a) {
    !function() {
        "use strict";
        function b(b, d) {
            if (this.el = b,
            this.$el = a(b),
            this.s = a.extend({}, c, d),
            this.s.dynamic && "undefined" !== this.s.dynamicEl && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length)
                throw "When using dynamic mode, you must also define dynamicEl as an Array.";
            return this.modules = {},
            this.lGalleryOn = !1,
            this.lgBusy = !1,
            this.hideBartimeout = !1,
            this.isTouch = "ontouchstart"in document.documentElement,
            this.s.slideEndAnimatoin && (this.s.hideControlOnEnd = !1),
            this.s.dynamic ? this.$items = this.s.dynamicEl : "this" === this.s.selector ? this.$items = this.$el : "" !== this.s.selector ? this.s.selectWithin ? this.$items = a(this.s.selectWithin).find(this.s.selector) : this.$items = this.$el.find(a(this.s.selector)) : this.$items = this.$el.children(),
            this.$slide = "",
            this.$outer = "",
            this.init(),
            this
        }
        var c = {
            mode: "lg-slide",
            cssEasing: "ease",
            easing: "linear",
            speed: 600,
            height: "100%",
            width: "100%",
            addClass: "",
            startClass: "lg-start-zoom",
            backdropDuration: 150,
            hideBarsDelay: 6e3,
            useLeft: !1,
            closable: !0,
            loop: !0,
            escKey: !0,
            keyPress: !0,
            controls: !0,
            slideEndAnimatoin: !0,
            hideControlOnEnd: !1,
            mousewheel: !0,
            getCaptionFromTitleOrAlt: !0,
            appendSubHtmlTo: ".lg-sub-html",
            subHtmlSelectorRelative: !1,
            preload: 1,
            showAfterLoad: !0,
            selector: "",
            selectWithin: "",
            nextHtml: "",
            prevHtml: "",
            index: !1,
            iframeMaxWidth: "100%",
            download: !0,
            counter: !0,
            appendCounterTo: ".lg-toolbar",
            swipeThreshold: 50,
            enableSwipe: !0,
            enableDrag: !0,
            dynamic: !1,
            dynamicEl: [],
            galleryId: 1
        };
        b.prototype.init = function() {
            var b = this;
            b.s.preload > b.$items.length && (b.s.preload = b.$items.length);
            var c = window.location.hash;
            c.indexOf("lg=" + this.s.galleryId) > 0 && (b.index = parseInt(c.split("&slide=")[1], 10),
            a("body").addClass("lg-from-hash"),
            a("body").hasClass("lg-on") || (setTimeout(function() {
                b.build(b.index)
            }),
            a("body").addClass("lg-on"))),
            b.s.dynamic ? (b.$el.trigger("onBeforeOpen.lg"),
            b.index = b.s.index || 0,
            a("body").hasClass("lg-on") || setTimeout(function() {
                b.build(b.index),
                a("body").addClass("lg-on")
            })) : b.$items.on("click.lgcustom", function(c) {
                try {
                    c.preventDefault(),
                    c.preventDefault()
                } catch (a) {
                    c.returnValue = !1
                }
                b.$el.trigger("onBeforeOpen.lg"),
                b.index = b.s.index || b.$items.index(this),
                a("body").hasClass("lg-on") || (b.build(b.index),
                a("body").addClass("lg-on"))
            })
        }
        ,
        b.prototype.build = function(b) {
            var c = this;
            c.structure(),
            a.each(a.fn.lightGallery.modules, function(b) {
                c.modules[b] = new a.fn.lightGallery.modules[b](c.el)
            }),
            c.slide(b, !1, !1, !1),
            c.s.keyPress && c.keyPress(),
            c.$items.length > 1 ? (c.arrow(),
            setTimeout(function() {
                c.enableDrag(),
                c.enableSwipe()
            }, 50),
            c.s.mousewheel && c.mousewheel()) : c.$slide.on("click.lg", function() {
                c.$el.trigger("onSlideClick.lg")
            }),
            c.counter(),
            c.closeGallery(),
            c.$el.trigger("onAfterOpen.lg"),
            c.$outer.on("mousemove.lg click.lg touchstart.lg", function() {
                c.$outer.removeClass("lg-hide-items"),
                clearTimeout(c.hideBartimeout),
                c.hideBartimeout = setTimeout(function() {
                    c.$outer.addClass("lg-hide-items")
                }, c.s.hideBarsDelay)
            }),
            c.$outer.trigger("mousemove.lg")
        }
        ,
        b.prototype.structure = function() {
            var b, c = "", d = "", e = 0, f = "", g = this;
            for (a("body").append('<div class="lg-backdrop"></div>'),
            a(".lg-backdrop").css("transition-duration", this.s.backdropDuration + "ms"),
            e = 0; e < this.$items.length; e++)
                c += '<div class="lg-item"></div>';
            if (this.s.controls && this.$items.length > 1 && (d = '<div class="lg-actions"><button class="lg-prev lg-icon">' + this.s.prevHtml + '</button><button class="lg-next lg-icon">' + this.s.nextHtml + "</button></div>"),
            ".lg-sub-html" === this.s.appendSubHtmlTo && (f = '<div class="lg-sub-html"></div>'),
            b = '<div class="lg-outer ' + this.s.addClass + " " + this.s.startClass + '"><div class="lg" style="width:' + this.s.width + "; height:" + this.s.height + '"><div class="lg-inner">' + c + '</div><div class="lg-toolbar lg-group"><span class="lg-close lg-icon"></span></div>' + d + f + "</div></div>",
            a("body").append(b),
            this.$outer = a(".lg-outer"),
            this.$slide = this.$outer.find(".lg-item"),
            this.s.useLeft ? (this.$outer.addClass("lg-use-left"),
            this.s.mode = "lg-slide") : this.$outer.addClass("lg-use-css3"),
            g.setTop(),
            a(window).on("resize.lg orientationchange.lg", function() {
                setTimeout(function() {
                    g.setTop()
                }, 100)
            }),
            this.$slide.eq(this.index).addClass("lg-current"),
            this.doCss() ? this.$outer.addClass("lg-css3") : (this.$outer.addClass("lg-css"),
            this.s.speed = 0),
            this.$outer.addClass(this.s.mode),
            this.s.enableDrag && this.$items.length > 1 && this.$outer.addClass("lg-grab"),
            this.s.showAfterLoad && this.$outer.addClass("lg-show-after-load"),
            this.doCss()) {
                var h = this.$outer.find(".lg-inner");
                h.css("transition-timing-function", this.s.cssEasing),
                h.css("transition-duration", this.s.speed + "ms")
            }
            setTimeout(function() {
                a(".lg-backdrop").addClass("in")
            }),
            setTimeout(function() {
                g.$outer.addClass("lg-visible")
            }, this.s.backdropDuration),
            this.s.download && this.$outer.find(".lg-toolbar").append('<a id="lg-download" target="_blank" download class="lg-download lg-icon"></a>'),
            this.prevScrollTop = a(window).scrollTop()
        }
        ,
        b.prototype.setTop = function() {
            if ("100%" !== this.s.height) {
                var b = a(window).height()
                  , c = (b - parseInt(this.s.height, 10)) / 2
                  , d = this.$outer.find(".lg");
                b >= parseInt(this.s.height, 10) ? d.css("top", c + "px") : d.css("top", "0px")
            }
        }
        ,
        b.prototype.doCss = function() {
            return !!function() {
                var a = ["transition", "MozTransition", "WebkitTransition", "OTransition", "msTransition", "KhtmlTransition"]
                  , b = document.documentElement
                  , c = 0;
                for (c = 0; c < a.length; c++)
                    if (a[c]in b.style)
                        return !0
            }()
        }
        ,
        b.prototype.isVideo = function(a, b) {
            var c;
            if (c = this.s.dynamic ? this.s.dynamicEl[b].html : this.$items.eq(b).attr("data-html"),
            !a)
                return c ? {
                    html5: !0
                } : (console.error("lightGallery :- data-src is not pvovided on slide item " + (b + 1) + ". Please make sure the selector property is properly configured. More info - http://sachinchoolur.github.io/lightGallery/demos/html-markup.html"),
                !1);
            var d = a.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i)
              , e = a.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i)
              , f = a.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i)
              , g = a.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);
            return d ? {
                youtube: d
            } : e ? {
                vimeo: e
            } : f ? {
                dailymotion: f
            } : g ? {
                vk: g
            } : void 0
        }
        ,
        b.prototype.counter = function() {
            this.s.counter && a(this.s.appendCounterTo).append('<div id="lg-counter"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.$items.length + "</span></div>")
        }
        ,
        b.prototype.addHtml = function(b) {
            var c, d, e = null;
            if (this.s.dynamic ? this.s.dynamicEl[b].subHtmlUrl ? c = this.s.dynamicEl[b].subHtmlUrl : e = this.s.dynamicEl[b].subHtml : (d = this.$items.eq(b),
            d.attr("data-sub-html-url") ? c = d.attr("data-sub-html-url") : (e = d.attr("data-sub-html"),
            this.s.getCaptionFromTitleOrAlt && !e && (e = d.attr("title") || d.find("img").first().attr("alt")))),
            !c)
                if (void 0 !== e && null !== e) {
                    var f = e.substring(0, 1);
                    "." !== f && "#" !== f || (e = this.s.subHtmlSelectorRelative && !this.s.dynamic ? d.find(e).html() : a(e).html())
                } else
                    e = "";
            ".lg-sub-html" === this.s.appendSubHtmlTo ? c ? this.$outer.find(this.s.appendSubHtmlTo).load(c) : this.$outer.find(this.s.appendSubHtmlTo).html(e) : c ? this.$slide.eq(b).load(c) : this.$slide.eq(b).append(e),
            void 0 !== e && null !== e && ("" === e ? this.$outer.find(this.s.appendSubHtmlTo).addClass("lg-empty-html") : this.$outer.find(this.s.appendSubHtmlTo).removeClass("lg-empty-html")),
            this.$el.trigger("onAfterAppendSubHtml.lg", [b])
        }
        ,
        b.prototype.preload = function(a) {
            var b = 1
              , c = 1;
            for (b = 1; b <= this.s.preload && !(b >= this.$items.length - a); b++)
                this.loadContent(a + b, !1, 0);
            for (c = 1; c <= this.s.preload && !(a - c < 0); c++)
                this.loadContent(a - c, !1, 0)
        }
        ,
        b.prototype.loadContent = function(b, c, d) {
            var e, f, g, h, i, j, k = this, l = !1, m = function(b) {
                for (var c = [], d = [], e = 0; e < b.length; e++) {
                    var g = b[e].split(" ");
                    "" === g[0] && g.splice(0, 1),
                    d.push(g[0]),
                    c.push(g[1])
                }
                for (var h = a(window).width(), i = 0; i < c.length; i++)
                    if (parseInt(c[i], 10) > h) {
                        f = d[i];
                        break
                    }
            };
            if (k.s.dynamic) {
                if (k.s.dynamicEl[b].poster && (l = !0,
                g = k.s.dynamicEl[b].poster),
                j = k.s.dynamicEl[b].html,
                f = k.s.dynamicEl[b].src,
                k.s.dynamicEl[b].responsive) {
                    m(k.s.dynamicEl[b].responsive.split(","))
                }
                h = k.s.dynamicEl[b].srcset,
                i = k.s.dynamicEl[b].sizes
            } else {
                if (k.$items.eq(b).attr("data-poster") && (l = !0,
                g = k.$items.eq(b).attr("data-poster")),
                j = k.$items.eq(b).attr("data-html"),
                f = k.$items.eq(b).attr("href") || k.$items.eq(b).attr("data-src"),
                k.$items.eq(b).attr("data-responsive")) {
                    m(k.$items.eq(b).attr("data-responsive").split(","))
                }
                h = k.$items.eq(b).attr("data-srcset"),
                i = k.$items.eq(b).attr("data-sizes")
            }
            var n = !1;
            k.s.dynamic ? k.s.dynamicEl[b].iframe && (n = !0) : "true" === k.$items.eq(b).attr("data-iframe") && (n = !0);
            var o = k.isVideo(f, b);
            if (!k.$slide.eq(b).hasClass("lg-loaded")) {
                if (n)
                    k.$slide.eq(b).prepend('<div class="lg-video-cont lg-has-iframe" style="max-width:' + k.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + f + '"  allowfullscreen="true"></iframe></div></div>');
                else if (l) {
                    var p = "";
                    p = o && o.youtube ? "lg-has-youtube" : o && o.vimeo ? "lg-has-vimeo" : "lg-has-html5",
                    k.$slide.eq(b).prepend('<div class="lg-video-cont ' + p + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + g + '" /></div></div>')
                } else
                    o ? (k.$slide.eq(b).prepend('<div class="lg-video-cont "><div class="lg-video"></div></div>'),
                    k.$el.trigger("hasVideo.lg", [b, f, j])) : k.$slide.eq(b).prepend('<div class="lg-img-wrap"><img class="lg-object lg-image" src="' + f + '" /></div>');
                if (k.$el.trigger("onAferAppendSlide.lg", [b]),
                e = k.$slide.eq(b).find(".lg-object"),
                i && e.attr("sizes", i),
                h) {
                    e.attr("srcset", h);
                    try {
                        picturefill({
                            elements: [e[0]]
                        })
                    } catch (a) {
                        console.warn("lightGallery :- If you want srcset to be supported for older browser please include picturefil version 2 javascript library in your document.")
                    }
                }
                ".lg-sub-html" !== this.s.appendSubHtmlTo && k.addHtml(b),
                k.$slide.eq(b).addClass("lg-loaded")
            }
            k.$slide.eq(b).find(".lg-object").on("load.lg error.lg", function() {
                var c = 0;
                d && !a("body").hasClass("lg-from-hash") && (c = d),
                setTimeout(function() {
                    k.$slide.eq(b).addClass("lg-complete"),
                    k.$el.trigger("onSlideItemLoad.lg", [b, d || 0])
                }, c)
            }),
            o && o.html5 && !l && k.$slide.eq(b).addClass("lg-complete"),
            !0 === c && (k.$slide.eq(b).hasClass("lg-complete") ? k.preload(b) : k.$slide.eq(b).find(".lg-object").on("load.lg error.lg", function() {
                k.preload(b)
            }))
        }
        ,
        b.prototype.slide = function(b, c, d, e) {
            var f = this.$outer.find(".lg-current").index()
              , g = this;
            if (!g.lGalleryOn || f !== b) {
                var h = this.$slide.length
                  , i = g.lGalleryOn ? this.s.speed : 0;
                if (!g.lgBusy) {
                    if (this.s.download) {
                        var j;
                        j = g.s.dynamic ? !1 !== g.s.dynamicEl[b].downloadUrl && (g.s.dynamicEl[b].downloadUrl || g.s.dynamicEl[b].src) : "false" !== g.$items.eq(b).attr("data-download-url") && (g.$items.eq(b).attr("data-download-url") || g.$items.eq(b).attr("href") || g.$items.eq(b).attr("data-src")),
                        j ? (a("#lg-download").attr("href", j),
                        g.$outer.removeClass("lg-hide-download")) : g.$outer.addClass("lg-hide-download")
                    }
                    if (this.$el.trigger("onBeforeSlide.lg", [f, b, c, d]),
                    g.lgBusy = !0,
                    clearTimeout(g.hideBartimeout),
                    ".lg-sub-html" === this.s.appendSubHtmlTo && setTimeout(function() {
                        g.addHtml(b)
                    }, i),
                    this.arrowDisable(b),
                    e || (b < f ? e = "prev" : b > f && (e = "next")),
                    c) {
                        this.$slide.removeClass("lg-prev-slide lg-current lg-next-slide");
                        var k, l;
                        h > 2 ? (k = b - 1,
                        l = b + 1,
                        0 === b && f === h - 1 ? (l = 0,
                        k = h - 1) : b === h - 1 && 0 === f && (l = 0,
                        k = h - 1)) : (k = 0,
                        l = 1),
                        "prev" === e ? g.$slide.eq(l).addClass("lg-next-slide") : g.$slide.eq(k).addClass("lg-prev-slide"),
                        g.$slide.eq(b).addClass("lg-current")
                    } else
                        g.$outer.addClass("lg-no-trans"),
                        this.$slide.removeClass("lg-prev-slide lg-next-slide"),
                        "prev" === e ? (this.$slide.eq(b).addClass("lg-prev-slide"),
                        this.$slide.eq(f).addClass("lg-next-slide")) : (this.$slide.eq(b).addClass("lg-next-slide"),
                        this.$slide.eq(f).addClass("lg-prev-slide")),
                        setTimeout(function() {
                            g.$slide.removeClass("lg-current"),
                            g.$slide.eq(b).addClass("lg-current"),
                            g.$outer.removeClass("lg-no-trans")
                        }, 50);
                    g.lGalleryOn ? (setTimeout(function() {
                        g.loadContent(b, !0, 0)
                    }, this.s.speed + 50),
                    setTimeout(function() {
                        g.lgBusy = !1,
                        g.$el.trigger("onAfterSlide.lg", [f, b, c, d])
                    }, this.s.speed)) : (g.loadContent(b, !0, g.s.backdropDuration),
                    g.lgBusy = !1,
                    g.$el.trigger("onAfterSlide.lg", [f, b, c, d])),
                    g.lGalleryOn = !0,
                    this.s.counter && a("#lg-counter-current").text(b + 1)
                }
                g.index = b
            }
        }
        ,
        b.prototype.goToNextSlide = function(a) {
            var b = this
              , c = b.s.loop;
            a && b.$slide.length < 3 && (c = !1),
            b.lgBusy || (b.index + 1 < b.$slide.length ? (b.index++,
            b.$el.trigger("onBeforeNextSlide.lg", [b.index]),
            b.slide(b.index, a, !1, "next")) : c ? (b.index = 0,
            b.$el.trigger("onBeforeNextSlide.lg", [b.index]),
            b.slide(b.index, a, !1, "next")) : b.s.slideEndAnimatoin && !a && (b.$outer.addClass("lg-right-end"),
            setTimeout(function() {
                b.$outer.removeClass("lg-right-end")
            }, 400)))
        }
        ,
        b.prototype.goToPrevSlide = function(a) {
            var b = this
              , c = b.s.loop;
            a && b.$slide.length < 3 && (c = !1),
            b.lgBusy || (b.index > 0 ? (b.index--,
            b.$el.trigger("onBeforePrevSlide.lg", [b.index, a]),
            b.slide(b.index, a, !1, "prev")) : c ? (b.index = b.$items.length - 1,
            b.$el.trigger("onBeforePrevSlide.lg", [b.index, a]),
            b.slide(b.index, a, !1, "prev")) : b.s.slideEndAnimatoin && !a && (b.$outer.addClass("lg-left-end"),
            setTimeout(function() {
                b.$outer.removeClass("lg-left-end")
            }, 400)))
        }
        ,
        b.prototype.keyPress = function() {
            var b = this;
            this.$items.length > 1 && a(window).on("keyup.lg", function(a) {
                b.$items.length > 1 && (37 === a.keyCode && (a.preventDefault(),
                b.goToPrevSlide()),
                39 === a.keyCode && (a.preventDefault(),
                b.goToNextSlide()))
            }),
            a(window).on("keydown.lg", function(a) {
                !0 === b.s.escKey && 27 === a.keyCode && (a.preventDefault(),
                b.$outer.hasClass("lg-thumb-open") ? b.$outer.removeClass("lg-thumb-open") : b.destroy())
            })
        }
        ,
        b.prototype.arrow = function() {
            var a = this;
            this.$outer.find(".lg-prev").on("click.lg", function() {
                a.goToPrevSlide()
            }),
            this.$outer.find(".lg-next").on("click.lg", function() {
                a.goToNextSlide()
            })
        }
        ,
        b.prototype.arrowDisable = function(a) {
            !this.s.loop && this.s.hideControlOnEnd && (a + 1 < this.$slide.length ? this.$outer.find(".lg-next").removeAttr("disabled").removeClass("disabled") : this.$outer.find(".lg-next").attr("disabled", "disabled").addClass("disabled"),
            a > 0 ? this.$outer.find(".lg-prev").removeAttr("disabled").removeClass("disabled") : this.$outer.find(".lg-prev").attr("disabled", "disabled").addClass("disabled"))
        }
        ,
        b.prototype.setTranslate = function(a, b, c) {
            this.s.useLeft ? a.css("left", b) : a.css({
                transform: "translate3d(" + b + "px, " + c + "px, 0px)"
            })
        }
        ,
        b.prototype.touchMove = function(b, c) {
            var d = c - b;
            Math.abs(d) > 15 && (this.$outer.addClass("lg-dragging"),
            this.setTranslate(this.$slide.eq(this.index), d, 0),
            this.setTranslate(a(".lg-prev-slide"), -this.$slide.eq(this.index).width() + d, 0),
            this.setTranslate(a(".lg-next-slide"), this.$slide.eq(this.index).width() + d, 0))
        }
        ,
        b.prototype.touchEnd = function(a) {
            var b = this;
            "lg-slide" !== b.s.mode && b.$outer.addClass("lg-slide"),
            this.$slide.not(".lg-current, .lg-prev-slide, .lg-next-slide").css("opacity", "0"),
            setTimeout(function() {
                b.$outer.removeClass("lg-dragging"),
                a < 0 && Math.abs(a) > b.s.swipeThreshold ? b.goToNextSlide(!0) : a > 0 && Math.abs(a) > b.s.swipeThreshold ? b.goToPrevSlide(!0) : Math.abs(a) < 5 && b.$el.trigger("onSlideClick.lg"),
                b.$slide.removeAttr("style")
            }),
            setTimeout(function() {
                b.$outer.hasClass("lg-dragging") || "lg-slide" === b.s.mode || b.$outer.removeClass("lg-slide")
            }, b.s.speed + 100)
        }
        ,
        b.prototype.enableSwipe = function() {
            var a = this
              , b = 0
              , c = 0
              , d = !1;
            a.s.enableSwipe && a.doCss() && (a.$slide.on("touchstart.lg", function(c) {
                a.$outer.hasClass("lg-zoomed") || a.lgBusy || (c.preventDefault(),
                a.manageSwipeClass(),
                b = c.originalEvent.targetTouches[0].pageX)
            }),
            a.$slide.on("touchmove.lg", function(e) {
                a.$outer.hasClass("lg-zoomed") || (e.preventDefault(),
                c = e.originalEvent.targetTouches[0].pageX,
                a.touchMove(b, c),
                d = !0)
            }),
            a.$slide.on("touchend.lg", function() {
                a.$outer.hasClass("lg-zoomed") || (d ? (d = !1,
                a.touchEnd(c - b)) : a.$el.trigger("onSlideClick.lg"))
            }))
        }
        ,
        b.prototype.enableDrag = function() {
            var b = this
              , c = 0
              , d = 0
              , e = !1
              , f = !1;
            b.s.enableDrag && b.doCss() && (b.$slide.on("mousedown.lg", function(d) {
                b.$outer.hasClass("lg-zoomed") || b.lgBusy || a(d.target).text().trim() || (d.preventDefault(),
                b.manageSwipeClass(),
                c = d.pageX,
                e = !0,
                b.$outer.scrollLeft += 1,
                b.$outer.scrollLeft -= 1,
                b.$outer.removeClass("lg-grab").addClass("lg-grabbing"),
                b.$el.trigger("onDragstart.lg"))
            }),
            a(window).on("mousemove.lg", function(a) {
                e && (f = !0,
                d = a.pageX,
                b.touchMove(c, d),
                b.$el.trigger("onDragmove.lg"))
            }),
            a(window).on("mouseup.lg", function(g) {
                f ? (f = !1,
                b.touchEnd(d - c),
                b.$el.trigger("onDragend.lg")) : (a(g.target).hasClass("lg-object") || a(g.target).hasClass("lg-video-play")) && b.$el.trigger("onSlideClick.lg"),
                e && (e = !1,
                b.$outer.removeClass("lg-grabbing").addClass("lg-grab"))
            }))
        }
        ,
        b.prototype.manageSwipeClass = function() {
            var a = this.index + 1
              , b = this.index - 1;
            this.s.loop && this.$slide.length > 2 && (0 === this.index ? b = this.$slide.length - 1 : this.index === this.$slide.length - 1 && (a = 0)),
            this.$slide.removeClass("lg-next-slide lg-prev-slide"),
            b > -1 && this.$slide.eq(b).addClass("lg-prev-slide"),
            this.$slide.eq(a).addClass("lg-next-slide")
        }
        ,
        b.prototype.mousewheel = function() {
            var a = this;
            a.$outer.on("mousewheel.lg", function(b) {
                b.deltaY && (b.deltaY > 0 ? a.goToPrevSlide() : a.goToNextSlide(),
                b.preventDefault())
            })
        }
        ,
        b.prototype.closeGallery = function() {
            var b = this
              , c = !1;
            this.$outer.find(".lg-close").on("click.lg", function() {
                b.destroy()
            }),
            b.s.closable && (b.$outer.on("mousedown.lg", function(b) {
                c = !!(a(b.target).is(".lg-outer") || a(b.target).is(".lg-item ") || a(b.target).is(".lg-img-wrap"))
            }),
            b.$outer.on("mousemove.lg", function() {
                c = !1
            }),
            b.$outer.on("mouseup.lg", function(d) {
                (a(d.target).is(".lg-outer") || a(d.target).is(".lg-item ") || a(d.target).is(".lg-img-wrap") && c) && (b.$outer.hasClass("lg-dragging") || b.destroy())
            }))
        }
        ,
        b.prototype.destroy = function(b) {
            var c = this;
            b || (c.$el.trigger("onBeforeClose.lg"),
            a(window).scrollTop(c.prevScrollTop)),
            b && (c.s.dynamic || this.$items.off("click.lg click.lgcustom"),
            a.removeData(c.el, "lightGallery")),
            this.$el.off(".lg.tm"),
            a.each(a.fn.lightGallery.modules, function(a) {
                c.modules[a] && c.modules[a].destroy()
            }),
            this.lGalleryOn = !1,
            clearTimeout(c.hideBartimeout),
            this.hideBartimeout = !1,
            a(window).off(".lg"),
            a("body").removeClass("lg-on lg-from-hash"),
            c.$outer && c.$outer.removeClass("lg-visible"),
            a(".lg-backdrop").removeClass("in"),
            setTimeout(function() {
                c.$outer && c.$outer.remove(),
                a(".lg-backdrop").remove(),
                b || c.$el.trigger("onCloseAfter.lg")
            }, c.s.backdropDuration + 50)
        }
        ,
        a.fn.lightGallery = function(c) {
            return this.each(function() {
                if (a.data(this, "lightGallery"))
                    try {
                        a(this).data("lightGallery").init()
                    } catch (a) {
                        console.error("lightGallery has not initiated properly")
                    }
                else
                    a.data(this, "lightGallery", new b(this,c))
            })
        }
        ,
        a.fn.lightGallery.modules = {}
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = {
            autoplay: !1,
            pause: 5e3,
            progressBar: !0,
            fourceAutoplay: !1,
            autoplayControls: !0,
            appendAutoplayControlsTo: ".lg-toolbar"
        }
          , c = function(c) {
            return this.core = a(c).data("lightGallery"),
            this.$el = a(c),
            !(this.core.$items.length < 2) && (this.core.s = a.extend({}, b, this.core.s),
            this.interval = !1,
            this.fromAuto = !0,
            this.canceledOnTouch = !1,
            this.fourceAutoplayTemp = this.core.s.fourceAutoplay,
            this.core.doCss() || (this.core.s.progressBar = !1),
            this.init(),
            this)
        };
        c.prototype.init = function() {
            var a = this;
            a.core.s.autoplayControls && a.controls(),
            a.core.s.progressBar && a.core.$outer.find(".lg").append('<div class="lg-progress-bar"><div class="lg-progress"></div></div>'),
            a.progress(),
            a.core.s.autoplay && a.$el.one("onSlideItemLoad.lg.tm", function() {
                a.startlAuto()
            }),
            a.$el.on("onDragstart.lg.tm touchstart.lg.tm", function() {
                a.interval && (a.cancelAuto(),
                a.canceledOnTouch = !0)
            }),
            a.$el.on("onDragend.lg.tm touchend.lg.tm onSlideClick.lg.tm", function() {
                !a.interval && a.canceledOnTouch && (a.startlAuto(),
                a.canceledOnTouch = !1)
            })
        }
        ,
        c.prototype.progress = function() {
            var a, b, c = this;
            c.$el.on("onBeforeSlide.lg.tm", function() {
                c.core.s.progressBar && c.fromAuto && (a = c.core.$outer.find(".lg-progress-bar"),
                b = c.core.$outer.find(".lg-progress"),
                c.interval && (b.removeAttr("style"),
                a.removeClass("lg-start"),
                setTimeout(function() {
                    b.css("transition", "width " + (c.core.s.speed + c.core.s.pause) + "ms ease 0s"),
                    a.addClass("lg-start")
                }, 20))),
                c.fromAuto || c.core.s.fourceAutoplay || c.cancelAuto(),
                c.fromAuto = !1
            })
        }
        ,
        c.prototype.controls = function() {
            var b = this;
            a(this.core.s.appendAutoplayControlsTo).append('<span class="lg-autoplay-button lg-icon"></span>'),
            b.core.$outer.find(".lg-autoplay-button").on("click.lg", function() {
                a(b.core.$outer).hasClass("lg-show-autoplay") ? (b.cancelAuto(),
                b.core.s.fourceAutoplay = !1) : b.interval || (b.startlAuto(),
                b.core.s.fourceAutoplay = b.fourceAutoplayTemp)
            })
        }
        ,
        c.prototype.startlAuto = function() {
            var a = this;
            a.core.$outer.find(".lg-progress").css("transition", "width " + (a.core.s.speed + a.core.s.pause) + "ms ease 0s"),
            a.core.$outer.addClass("lg-show-autoplay"),
            a.core.$outer.find(".lg-progress-bar").addClass("lg-start"),
            a.interval = setInterval(function() {
                a.core.index + 1 < a.core.$items.length ? a.core.index++ : a.core.index = 0,
                a.fromAuto = !0,
                a.core.slide(a.core.index, !1, !1, "next")
            }, a.core.s.speed + a.core.s.pause)
        }
        ,
        c.prototype.cancelAuto = function() {
            clearInterval(this.interval),
            this.interval = !1,
            this.core.$outer.find(".lg-progress").removeAttr("style"),
            this.core.$outer.removeClass("lg-show-autoplay"),
            this.core.$outer.find(".lg-progress-bar").removeClass("lg-start")
        }
        ,
        c.prototype.destroy = function() {
            this.cancelAuto(),
            this.core.$outer.find(".lg-progress-bar").remove()
        }
        ,
        a.fn.lightGallery.modules.autoplay = c
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = {
            fullScreen: !0
        }
          , c = function(c) {
            return this.core = a(c).data("lightGallery"),
            this.$el = a(c),
            this.core.s = a.extend({}, b, this.core.s),
            this.init(),
            this
        };
        c.prototype.init = function() {
            var a = "";
            if (this.core.s.fullScreen) {
                if (!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled))
                    return;
                a = '<span class="lg-fullscreen lg-icon"></span>',
                this.core.$outer.find(".lg-toolbar").append(a),
                this.fullScreen()
            }
        }
        ,
        c.prototype.requestFullscreen = function() {
            var a = document.documentElement;
            a.requestFullscreen ? a.requestFullscreen() : a.msRequestFullscreen ? a.msRequestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.webkitRequestFullscreen && a.webkitRequestFullscreen()
        }
        ,
        c.prototype.exitFullscreen = function() {
            document.exitFullscreen ? document.exitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen()
        }
        ,
        c.prototype.fullScreen = function() {
            var b = this;
            a(document).on("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg", function() {
                b.core.$outer.toggleClass("lg-fullscreen-on")
            }),
            this.core.$outer.find(".lg-fullscreen").on("click.lg", function() {
                document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement ? b.exitFullscreen() : b.requestFullscreen()
            })
        }
        ,
        c.prototype.destroy = function() {
            this.exitFullscreen(),
            a(document).off("fullscreenchange.lg webkitfullscreenchange.lg mozfullscreenchange.lg MSFullscreenChange.lg")
        }
        ,
        a.fn.lightGallery.modules.fullscreen = c
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = {
            pager: !1
        }
          , c = function(c) {
            return this.core = a(c).data("lightGallery"),
            this.$el = a(c),
            this.core.s = a.extend({}, b, this.core.s),
            this.core.s.pager && this.core.$items.length > 1 && this.init(),
            this
        };
        c.prototype.init = function() {
            var b, c, d, e = this, f = "";
            if (e.core.$outer.find(".lg").append('<div class="lg-pager-outer"></div>'),
            e.core.s.dynamic)
                for (var g = 0; g < e.core.s.dynamicEl.length; g++)
                    f += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + e.core.s.dynamicEl[g].thumb + '" /></div></span>';
            else
                e.core.$items.each(function() {
                    e.core.s.exThumbImage ? f += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + a(this).attr(e.core.s.exThumbImage) + '" /></div></span>' : f += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + a(this).find("img").attr("src") + '" /></div></span>'
                });
            c = e.core.$outer.find(".lg-pager-outer"),
            c.html(f),
            b = e.core.$outer.find(".lg-pager-cont"),
            b.on("click.lg touchend.lg", function() {
                var b = a(this);
                e.core.index = b.index(),
                e.core.slide(e.core.index, !1, !0, !1)
            }),
            c.on("mouseover.lg", function() {
                clearTimeout(d),
                c.addClass("lg-pager-hover")
            }),
            c.on("mouseout.lg", function() {
                d = setTimeout(function() {
                    c.removeClass("lg-pager-hover")
                })
            }),
            e.core.$el.on("onBeforeSlide.lg.tm", function(a, c, d) {
                b.removeClass("lg-pager-active"),
                b.eq(d).addClass("lg-pager-active")
            })
        }
        ,
        c.prototype.destroy = function() {}
        ,
        a.fn.lightGallery.modules.pager = c
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = {
            thumbnail: !0,
            animateThumb: !0,
            currentPagerPosition: "middle",
            thumbWidth: 100,
            thumbHeight: "80px",
            thumbContHeight: 100,
            thumbMargin: 5,
            exThumbImage: !1,
            showThumbByDefault: !0,
            toogleThumb: !0,
            pullCaptionUp: !0,
            enableThumbDrag: !0,
            enableThumbSwipe: !0,
            swipeThreshold: 50,
            loadYoutubeThumbnail: !0,
            youtubeThumbSize: 1,
            loadVimeoThumbnail: !0,
            vimeoThumbSize: "thumbnail_small",
            loadDailymotionThumbnail: !0
        }
          , c = function(c) {
            return this.core = a(c).data("lightGallery"),
            this.core.s = a.extend({}, b, this.core.s),
            this.$el = a(c),
            this.$thumbOuter = null,
            this.thumbOuterWidth = 0,
            this.thumbTotalWidth = this.core.$items.length * (this.core.s.thumbWidth + this.core.s.thumbMargin),
            this.thumbIndex = this.core.index,
            this.core.s.animateThumb && (this.core.s.thumbHeight = "100%"),
            this.left = 0,
            this.init(),
            this
        };
        c.prototype.init = function() {
            var a = this;
            this.core.s.thumbnail && this.core.$items.length > 1 && (this.core.s.showThumbByDefault && setTimeout(function() {
                a.core.$outer.addClass("lg-thumb-open")
            }, 700),
            this.core.s.pullCaptionUp && this.core.$outer.addClass("lg-pull-caption-up"),
            this.build(),
            this.core.s.animateThumb && this.core.doCss() ? (this.core.s.enableThumbDrag && this.enableThumbDrag(),
            this.core.s.enableThumbSwipe && this.enableThumbSwipe(),
            this.thumbClickable = !1) : this.thumbClickable = !0,
            this.toogle(),
            this.thumbkeyPress())
        }
        ,
        c.prototype.build = function() {
            function b(a, b, c) {
                var g, h = d.core.isVideo(a, c) || {}, i = "";
                h.youtube || h.vimeo || h.dailymotion ? h.youtube ? g = d.core.s.loadYoutubeThumbnail ? "//img.youtube.com/vi/" + h.youtube[1] + "/" + d.core.s.youtubeThumbSize + ".jpg" : b : h.vimeo ? d.core.s.loadVimeoThumbnail ? (g = "//i.vimeocdn.com/video/error_" + f + ".jpg",
                i = h.vimeo[1]) : g = b : h.dailymotion && (g = d.core.s.loadDailymotionThumbnail ? "//www.dailymotion.com/thumbnail/video/" + h.dailymotion[1] : b) : g = b,
                e += '<div data-vimeo-id="' + i + '" class="lg-thumb-item" style="width:' + d.core.s.thumbWidth + "px; height: " + d.core.s.thumbHeight + "; margin-right: " + d.core.s.thumbMargin + 'px"><img src="' + g + '" /></div>',
                i = ""
            }
            var c, d = this, e = "", f = "", g = '<div class="lg-thumb-outer"><div class="lg-thumb lg-group"></div></div>';
            switch (this.core.s.vimeoThumbSize) {
            case "thumbnail_large":
                f = "640";
                break;
            case "thumbnail_medium":
                f = "200x150";
                break;
            case "thumbnail_small":
                f = "100x75"
            }
            if (d.core.$outer.addClass("lg-has-thumb"),
            d.core.$outer.find(".lg").append(g),
            d.$thumbOuter = d.core.$outer.find(".lg-thumb-outer"),
            d.thumbOuterWidth = d.$thumbOuter.width(),
            d.core.s.animateThumb && d.core.$outer.find(".lg-thumb").css({
                width: d.thumbTotalWidth + "px",
                position: "relative"
            }),
            this.core.s.animateThumb && d.$thumbOuter.css("height", d.core.s.thumbContHeight + "px"),
            d.core.s.dynamic)
                for (var h = 0; h < d.core.s.dynamicEl.length; h++)
                    b(d.core.s.dynamicEl[h].src, d.core.s.dynamicEl[h].thumb, h);
            else
                d.core.$items.each(function(c) {
                    d.core.s.exThumbImage ? b(a(this).attr("href") || a(this).attr("data-src"), a(this).attr(d.core.s.exThumbImage), c) : b(a(this).attr("href") || a(this).attr("data-src"), a(this).find("img").attr("src"), c)
                });
            d.core.$outer.find(".lg-thumb").html(e),
            c = d.core.$outer.find(".lg-thumb-item"),
            c.each(function() {
                var b = a(this)
                  , c = b.attr("data-vimeo-id");
                c && a.getJSON("//www.vimeo.com/api/v2/video/" + c + ".json?callback=?", {
                    format: "json"
                }, function(a) {
                    b.find("img").attr("src", a[0][d.core.s.vimeoThumbSize])
                })
            }),
            c.eq(d.core.index).addClass("active"),
            d.core.$el.on("onBeforeSlide.lg.tm", function() {
                c.removeClass("active"),
                c.eq(d.core.index).addClass("active")
            }),
            c.on("click.lg touchend.lg", function() {
                var b = a(this);
                setTimeout(function() {
                    (d.thumbClickable && !d.core.lgBusy || !d.core.doCss()) && (d.core.index = b.index(),
                    d.core.slide(d.core.index, !1, !0, !1))
                }, 50)
            }),
            d.core.$el.on("onBeforeSlide.lg.tm", function() {
                d.animateThumb(d.core.index)
            }),
            a(window).on("resize.lg.thumb orientationchange.lg.thumb", function() {
                setTimeout(function() {
                    d.animateThumb(d.core.index),
                    d.thumbOuterWidth = d.$thumbOuter.width()
                }, 200)
            })
        }
        ,
        c.prototype.setTranslate = function(a) {
            this.core.$outer.find(".lg-thumb").css({
                transform: "translate3d(-" + a + "px, 0px, 0px)"
            })
        }
        ,
        c.prototype.animateThumb = function(a) {
            var b = this.core.$outer.find(".lg-thumb");
            if (this.core.s.animateThumb) {
                var c;
                switch (this.core.s.currentPagerPosition) {
                case "left":
                    c = 0;
                    break;
                case "middle":
                    c = this.thumbOuterWidth / 2 - this.core.s.thumbWidth / 2;
                    break;
                case "right":
                    c = this.thumbOuterWidth - this.core.s.thumbWidth
                }
                this.left = (this.core.s.thumbWidth + this.core.s.thumbMargin) * a - 1 - c,
                this.left > this.thumbTotalWidth - this.thumbOuterWidth && (this.left = this.thumbTotalWidth - this.thumbOuterWidth),
                this.left < 0 && (this.left = 0),
                this.core.lGalleryOn ? (b.hasClass("on") || this.core.$outer.find(".lg-thumb").css("transition-duration", this.core.s.speed + "ms"),
                this.core.doCss() || b.animate({
                    left: -this.left + "px"
                }, this.core.s.speed)) : this.core.doCss() || b.css("left", -this.left + "px"),
                this.setTranslate(this.left)
            }
        }
        ,
        c.prototype.enableThumbDrag = function() {
            var b = this
              , c = 0
              , d = 0
              , e = !1
              , f = !1
              , g = 0;
            b.$thumbOuter.addClass("lg-grab"),
            b.core.$outer.find(".lg-thumb").on("mousedown.lg.thumb", function(a) {
                b.thumbTotalWidth > b.thumbOuterWidth && (a.preventDefault(),
                c = a.pageX,
                e = !0,
                b.core.$outer.scrollLeft += 1,
                b.core.$outer.scrollLeft -= 1,
                b.thumbClickable = !1,
                b.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"))
            }),
            a(window).on("mousemove.lg.thumb", function(a) {
                e && (g = b.left,
                f = !0,
                d = a.pageX,
                b.$thumbOuter.addClass("lg-dragging"),
                g -= d - c,
                g > b.thumbTotalWidth - b.thumbOuterWidth && (g = b.thumbTotalWidth - b.thumbOuterWidth),
                g < 0 && (g = 0),
                b.setTranslate(g))
            }),
            a(window).on("mouseup.lg.thumb", function() {
                f ? (f = !1,
                b.$thumbOuter.removeClass("lg-dragging"),
                b.left = g,
                Math.abs(d - c) < b.core.s.swipeThreshold && (b.thumbClickable = !0)) : b.thumbClickable = !0,
                e && (e = !1,
                b.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab"))
            })
        }
        ,
        c.prototype.enableThumbSwipe = function() {
            var a = this
              , b = 0
              , c = 0
              , d = !1
              , e = 0;
            a.core.$outer.find(".lg-thumb").on("touchstart.lg", function(c) {
                a.thumbTotalWidth > a.thumbOuterWidth && (c.preventDefault(),
                b = c.originalEvent.targetTouches[0].pageX,
                a.thumbClickable = !1)
            }),
            a.core.$outer.find(".lg-thumb").on("touchmove.lg", function(f) {
                a.thumbTotalWidth > a.thumbOuterWidth && (f.preventDefault(),
                c = f.originalEvent.targetTouches[0].pageX,
                d = !0,
                a.$thumbOuter.addClass("lg-dragging"),
                e = a.left,
                e -= c - b,
                e > a.thumbTotalWidth - a.thumbOuterWidth && (e = a.thumbTotalWidth - a.thumbOuterWidth),
                e < 0 && (e = 0),
                a.setTranslate(e))
            }),
            a.core.$outer.find(".lg-thumb").on("touchend.lg", function() {
                a.thumbTotalWidth > a.thumbOuterWidth && d ? (d = !1,
                a.$thumbOuter.removeClass("lg-dragging"),
                Math.abs(c - b) < a.core.s.swipeThreshold && (a.thumbClickable = !0),
                a.left = e) : a.thumbClickable = !0
            })
        }
        ,
        c.prototype.toogle = function() {
            var a = this;
            a.core.s.toogleThumb && (a.core.$outer.addClass("lg-can-toggle"),
            a.$thumbOuter.append('<span class="lg-toogle-thumb lg-icon"></span>'),
            a.core.$outer.find(".lg-toogle-thumb").on("click.lg", function() {
                a.core.$outer.toggleClass("lg-thumb-open")
            }))
        }
        ,
        c.prototype.thumbkeyPress = function() {
            var b = this;
            a(window).on("keydown.lg.thumb", function(a) {
                38 === a.keyCode ? (a.preventDefault(),
                b.core.$outer.addClass("lg-thumb-open")) : 40 === a.keyCode && (a.preventDefault(),
                b.core.$outer.removeClass("lg-thumb-open"))
            })
        }
        ,
        c.prototype.destroy = function() {
            this.core.s.thumbnail && this.core.$items.length > 1 && (a(window).off("resize.lg.thumb orientationchange.lg.thumb keydown.lg.thumb"),
            this.$thumbOuter.remove(),
            this.core.$outer.removeClass("lg-has-thumb"))
        }
        ,
        a.fn.lightGallery.modules.Thumbnail = c
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof module && module.exports ? module.exports = b(require("jquery")) : b(a.jQuery)
}(this, function(a) {
    !function() {
        "use strict";
        function b(a, b, c, d) {
            var e = this;
            if (e.core.$slide.eq(b).find(".lg-video").append(e.loadVideo(c, "lg-object", !0, b, d)),
            d)
                if (e.core.s.videojs)
                    try {
                        videojs(e.core.$slide.eq(b).find(".lg-html5").get(0), e.core.s.videojsOptions, function() {
                            !e.videoLoaded && e.core.s.autoplayFirstVideo && this.play()
                        })
                    } catch (a) {
                        console.error("Make sure you have included videojs")
                    }
                else
                    !e.videoLoaded && e.core.s.autoplayFirstVideo && e.core.$slide.eq(b).find(".lg-html5").get(0).play()
        }
        function c(a, b) {
            var c = this.core.$slide.eq(b).find(".lg-video-cont");
            c.hasClass("lg-has-iframe") || (c.css("max-width", this.core.s.videoMaxWidth),
            this.videoLoaded = !0)
        }
        function d(b, c, d) {
            var e = this
              , f = e.core.$slide.eq(c)
              , g = f.find(".lg-youtube").get(0)
              , h = f.find(".lg-vimeo").get(0)
              , i = f.find(".lg-dailymotion").get(0)
              , j = f.find(".lg-vk").get(0)
              , k = f.find(".lg-html5").get(0);
            if (g)
                g.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            else if (h)
                try {
                    $f(h).api("pause")
                } catch (a) {
                    console.error("Make sure you have included froogaloop2 js")
                }
            else if (i)
                i.contentWindow.postMessage("pause", "*");
            else if (k)
                if (e.core.s.videojs)
                    try {
                        videojs(k).pause()
                    } catch (a) {
                        console.error("Make sure you have included videojs")
                    }
                else
                    k.pause();
            j && a(j).attr("src", a(j).attr("src").replace("&autoplay", "&noplay"));
            var l;
            l = e.core.s.dynamic ? e.core.s.dynamicEl[d].src : e.core.$items.eq(d).attr("href") || e.core.$items.eq(d).attr("data-src");
            var m = e.core.isVideo(l, d) || {};
            (m.youtube || m.vimeo || m.dailymotion || m.vk) && e.core.$outer.addClass("lg-hide-download")
        }
        var e = {
            videoMaxWidth: "855px",
            autoplayFirstVideo: !0,
            youtubePlayerParams: !1,
            vimeoPlayerParams: !1,
            dailymotionPlayerParams: !1,
            vkPlayerParams: !1,
            videojs: !1,
            videojsOptions: {}
        }
          , f = function(b) {
            return this.core = a(b).data("lightGallery"),
            this.$el = a(b),
            this.core.s = a.extend({}, e, this.core.s),
            this.videoLoaded = !1,
            this.init(),
            this
        };
        f.prototype.init = function() {
            var e = this;
            e.core.$el.on("hasVideo.lg.tm", b.bind(this)),
            e.core.$el.on("onAferAppendSlide.lg.tm", c.bind(this)),
            e.core.doCss() && e.core.$items.length > 1 && (e.core.s.enableSwipe || e.core.s.enableDrag) ? e.core.$el.on("onSlideClick.lg.tm", function() {
                var a = e.core.$slide.eq(e.core.index);
                e.loadVideoOnclick(a)
            }) : e.core.$slide.on("click.lg", function() {
                e.loadVideoOnclick(a(this))
            }),
            e.core.$el.on("onBeforeSlide.lg.tm", d.bind(this)),
            e.core.$el.on("onAfterSlide.lg.tm", function(a, b) {
                e.core.$slide.eq(b).removeClass("lg-video-playing")
            }),
            e.core.s.autoplayFirstVideo && e.core.$el.on("onAferAppendSlide.lg.tm", function(a, b) {
                if (!e.core.lGalleryOn) {
                    var c = e.core.$slide.eq(b);
                    setTimeout(function() {
                        e.loadVideoOnclick(c)
                    }, 100)
                }
            })
        }
        ,
        f.prototype.loadVideo = function(b, c, d, e, f) {
            var g = ""
              , h = 1
              , i = ""
              , j = this.core.isVideo(b, e) || {};
            if (d && (h = this.videoLoaded ? 0 : this.core.s.autoplayFirstVideo ? 1 : 0),
            j.youtube)
                i = "?wmode=opaque&autoplay=" + h + "&enablejsapi=1",
                this.core.s.youtubePlayerParams && (i = i + "&" + a.param(this.core.s.youtubePlayerParams)),
                g = '<iframe class="lg-video-object lg-youtube ' + c + '" width="560" height="315" src="//www.youtube.com/embed/' + j.youtube[1] + i + '" frameborder="0" allowfullscreen></iframe>';
            else if (j.vimeo)
                i = "?autoplay=" + h + "&api=1",
                this.core.s.vimeoPlayerParams && (i = i + "&" + a.param(this.core.s.vimeoPlayerParams)),
                g = '<iframe class="lg-video-object lg-vimeo ' + c + '" width="560" height="315"  src="//player.vimeo.com/video/' + j.vimeo[1] + i + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
            else if (j.dailymotion)
                i = "?wmode=opaque&autoplay=" + h + "&api=postMessage",
                this.core.s.dailymotionPlayerParams && (i = i + "&" + a.param(this.core.s.dailymotionPlayerParams)),
                g = '<iframe class="lg-video-object lg-dailymotion ' + c + '" width="560" height="315" src="//www.dailymotion.com/embed/video/' + j.dailymotion[1] + i + '" frameborder="0" allowfullscreen></iframe>';
            else if (j.html5) {
                var k = f.substring(0, 1);
                "." !== k && "#" !== k || (f = a(f).html()),
                g = f
            } else
                j.vk && (i = "&autoplay=" + h,
                this.core.s.vkPlayerParams && (i = i + "&" + a.param(this.core.s.vkPlayerParams)),
                g = '<iframe class="lg-video-object lg-vk ' + c + '" width="560" height="315" src="//vk.com/video_ext.php?' + j.vk[1] + i + '" frameborder="0" allowfullscreen></iframe>');
            return g
        }
        ,
        f.prototype.loadVideoOnclick = function(a) {
            var b = this;
            if (a.find(".lg-object").hasClass("lg-has-poster") && a.find(".lg-object").is(":visible"))
                if (a.hasClass("lg-has-video")) {
                    var c = a.find(".lg-youtube").get(0)
                      , d = a.find(".lg-vimeo").get(0)
                      , e = a.find(".lg-dailymotion").get(0)
                      , f = a.find(".lg-html5").get(0);
                    if (c)
                        c.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                    else if (d)
                        try {
                            $f(d).api("play")
                        } catch (a) {
                            console.error("Make sure you have included froogaloop2 js")
                        }
                    else if (e)
                        e.contentWindow.postMessage("play", "*");
                    else if (f)
                        if (b.core.s.videojs)
                            try {
                                videojs(f).play()
                            } catch (a) {
                                console.error("Make sure you have included videojs")
                            }
                        else
                            f.play();
                    a.addClass("lg-video-playing")
                } else {
                    a.addClass("lg-video-playing lg-has-video");
                    var g, h, i = function(c, d) {
                        if (a.find(".lg-video").append(b.loadVideo(c, "", !1, b.core.index, d)),
                        d)
                            if (b.core.s.videojs)
                                try {
                                    videojs(b.core.$slide.eq(b.core.index).find(".lg-html5").get(0), b.core.s.videojsOptions, function() {
                                        this.play()
                                    })
                                } catch (a) {
                                    console.error("Make sure you have included videojs")
                                }
                            else
                                b.core.$slide.eq(b.core.index).find(".lg-html5").get(0).play()
                    };
                    b.core.s.dynamic ? (g = b.core.s.dynamicEl[b.core.index].src,
                    h = b.core.s.dynamicEl[b.core.index].html,
                    i(g, h)) : (g = b.core.$items.eq(b.core.index).attr("href") || b.core.$items.eq(b.core.index).attr("data-src"),
                    h = b.core.$items.eq(b.core.index).attr("data-html"),
                    i(g, h));
                    var j = a.find(".lg-object");
                    a.find(".lg-video").append(j),
                    a.find(".lg-video-object").hasClass("lg-html5") || (a.removeClass("lg-complete"),
                    a.find(".lg-video-object").on("load.lg error.lg", function() {
                        a.addClass("lg-complete")
                    }))
                }
        }
        ,
        f.prototype.destroy = function() {
            this.videoLoaded = !1
        }
        ,
        a.fn.lightGallery.modules.video = f
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = function() {
            var a = !1
              , b = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            return b && parseInt(b[2], 10) < 54 && (a = !0),
            a
        }
          , c = {
            scale: 1,
            zoom: !0,
            actualSize: !0,
            enableZoomAfter: 300,
            useLeftForZoom: b()
        }
          , d = function(b) {
            return this.core = a(b).data("lightGallery"),
            this.core.s = a.extend({}, c, this.core.s),
            this.core.s.zoom && this.core.doCss() && (this.init(),
            this.zoomabletimeout = !1,
            this.pageX = a(window).width() / 2,
            this.pageY = a(window).height() / 2 + a(window).scrollTop()),
            this
        };
        d.prototype.init = function() {
            var b = this
              , c = '<span id="lg-zoom-in" class="lg-icon"></span><span id="lg-zoom-out" class="lg-icon"></span>';
            b.core.s.actualSize && (c += '<span id="lg-actual-size" class="lg-icon"></span>'),
            b.core.s.useLeftForZoom ? b.core.$outer.addClass("lg-use-left-for-zoom") : b.core.$outer.addClass("lg-use-transition-for-zoom"),
            this.core.$outer.find(".lg-toolbar").append(c),
            b.core.$el.on("onSlideItemLoad.lg.tm.zoom", function(c, d, e) {
                var f = b.core.s.enableZoomAfter + e;
                a("body").hasClass("lg-from-hash") && e ? f = 0 : a("body").removeClass("lg-from-hash"),
                b.zoomabletimeout = setTimeout(function() {
                    b.core.$slide.eq(d).addClass("lg-zoomable")
                }, f + 30)
            });
            var d = 1
              , e = function(c) {
                var d, e, f = b.core.$outer.find(".lg-current .lg-image"), g = (a(window).width() - f.prop("offsetWidth")) / 2, h = (a(window).height() - f.prop("offsetHeight")) / 2 + a(window).scrollTop();
                d = b.pageX - g,
                e = b.pageY - h;
                var i = (c - 1) * d
                  , j = (c - 1) * e;
                f.css("transform", "scale3d(" + c + ", " + c + ", 1)").attr("data-scale", c),
                b.core.s.useLeftForZoom ? f.parent().css({
                    left: -i + "px",
                    top: -j + "px"
                }).attr("data-x", i).attr("data-y", j) : f.parent().css("transform", "translate3d(-" + i + "px, -" + j + "px, 0)").attr("data-x", i).attr("data-y", j)
            }
              , f = function() {
                d > 1 ? b.core.$outer.addClass("lg-zoomed") : b.resetZoom(),
                d < 1 && (d = 1),
                e(d)
            }
              , g = function(c, e, g, h) {
                var i, j = e.prop("offsetWidth");
                i = b.core.s.dynamic ? b.core.s.dynamicEl[g].width || e[0].naturalWidth || j : b.core.$items.eq(g).attr("data-width") || e[0].naturalWidth || j;
                var k;
                b.core.$outer.hasClass("lg-zoomed") ? d = 1 : i > j && (k = i / j,
                d = k || 2),
                h ? (b.pageX = a(window).width() / 2,
                b.pageY = a(window).height() / 2 + a(window).scrollTop()) : (b.pageX = c.pageX || c.originalEvent.targetTouches[0].pageX,
                b.pageY = c.pageY || c.originalEvent.targetTouches[0].pageY),
                f(),
                setTimeout(function() {
                    b.core.$outer.removeClass("lg-grabbing").addClass("lg-grab")
                }, 10)
            }
              , h = !1;
            b.core.$el.on("onAferAppendSlide.lg.tm.zoom", function(a, c) {
                var d = b.core.$slide.eq(c).find(".lg-image");
                d.on("dblclick", function(a) {
                    g(a, d, c)
                }),
                d.on("touchstart", function(a) {
                    h ? (clearTimeout(h),
                    h = null,
                    g(a, d, c)) : h = setTimeout(function() {
                        h = null
                    }, 300),
                    a.preventDefault()
                })
            }),
            a(window).on("resize.lg.zoom scroll.lg.zoom orientationchange.lg.zoom", function() {
                b.pageX = a(window).width() / 2,
                b.pageY = a(window).height() / 2 + a(window).scrollTop(),
                e(d)
            }),
            a("#lg-zoom-out").on("click.lg", function() {
                b.core.$outer.find(".lg-current .lg-image").length && (d -= b.core.s.scale,
                f())
            }),
            a("#lg-zoom-in").on("click.lg", function() {
                b.core.$outer.find(".lg-current .lg-image").length && (d += b.core.s.scale,
                f())
            }),
            a("#lg-actual-size").on("click.lg", function(a) {
                g(a, b.core.$slide.eq(b.core.index).find(".lg-image"), b.core.index, !0)
            }),
            b.core.$el.on("onBeforeSlide.lg.tm", function() {
                d = 1,
                b.resetZoom()
            }),
            b.zoomDrag(),
            b.zoomSwipe()
        }
        ,
        d.prototype.resetZoom = function() {
            this.core.$outer.removeClass("lg-zoomed"),
            this.core.$slide.find(".lg-img-wrap").removeAttr("style data-x data-y"),
            this.core.$slide.find(".lg-image").removeAttr("style data-scale"),
            this.pageX = a(window).width() / 2,
            this.pageY = a(window).height() / 2 + a(window).scrollTop()
        }
        ,
        d.prototype.zoomSwipe = function() {
            var a = this
              , b = {}
              , c = {}
              , d = !1
              , e = !1
              , f = !1;
            a.core.$slide.on("touchstart.lg", function(c) {
                if (a.core.$outer.hasClass("lg-zoomed")) {
                    var d = a.core.$slide.eq(a.core.index).find(".lg-object");
                    f = d.prop("offsetHeight") * d.attr("data-scale") > a.core.$outer.find(".lg").height(),
                    e = d.prop("offsetWidth") * d.attr("data-scale") > a.core.$outer.find(".lg").width(),
                    (e || f) && (c.preventDefault(),
                    b = {
                        x: c.originalEvent.targetTouches[0].pageX,
                        y: c.originalEvent.targetTouches[0].pageY
                    })
                }
            }),
            a.core.$slide.on("touchmove.lg", function(g) {
                if (a.core.$outer.hasClass("lg-zoomed")) {
                    var h, i, j = a.core.$slide.eq(a.core.index).find(".lg-img-wrap");
                    g.preventDefault(),
                    d = !0,
                    c = {
                        x: g.originalEvent.targetTouches[0].pageX,
                        y: g.originalEvent.targetTouches[0].pageY
                    },
                    a.core.$outer.addClass("lg-zoom-dragging"),
                    i = f ? -Math.abs(j.attr("data-y")) + (c.y - b.y) : -Math.abs(j.attr("data-y")),
                    h = e ? -Math.abs(j.attr("data-x")) + (c.x - b.x) : -Math.abs(j.attr("data-x")),
                    (Math.abs(c.x - b.x) > 15 || Math.abs(c.y - b.y) > 15) && (a.core.s.useLeftForZoom ? j.css({
                        left: h + "px",
                        top: i + "px"
                    }) : j.css("transform", "translate3d(" + h + "px, " + i + "px, 0)"))
                }
            }),
            a.core.$slide.on("touchend.lg", function() {
                a.core.$outer.hasClass("lg-zoomed") && d && (d = !1,
                a.core.$outer.removeClass("lg-zoom-dragging"),
                a.touchendZoom(b, c, e, f))
            })
        }
        ,
        d.prototype.zoomDrag = function() {
            var b = this
              , c = {}
              , d = {}
              , e = !1
              , f = !1
              , g = !1
              , h = !1;
            b.core.$slide.on("mousedown.lg.zoom", function(d) {
                var f = b.core.$slide.eq(b.core.index).find(".lg-object");
                h = f.prop("offsetHeight") * f.attr("data-scale") > b.core.$outer.find(".lg").height(),
                g = f.prop("offsetWidth") * f.attr("data-scale") > b.core.$outer.find(".lg").width(),
                b.core.$outer.hasClass("lg-zoomed") && a(d.target).hasClass("lg-object") && (g || h) && (d.preventDefault(),
                c = {
                    x: d.pageX,
                    y: d.pageY
                },
                e = !0,
                b.core.$outer.scrollLeft += 1,
                b.core.$outer.scrollLeft -= 1,
                b.core.$outer.removeClass("lg-grab").addClass("lg-grabbing"))
            }),
            a(window).on("mousemove.lg.zoom", function(a) {
                if (e) {
                    var i, j, k = b.core.$slide.eq(b.core.index).find(".lg-img-wrap");
                    f = !0,
                    d = {
                        x: a.pageX,
                        y: a.pageY
                    },
                    b.core.$outer.addClass("lg-zoom-dragging"),
                    j = h ? -Math.abs(k.attr("data-y")) + (d.y - c.y) : -Math.abs(k.attr("data-y")),
                    i = g ? -Math.abs(k.attr("data-x")) + (d.x - c.x) : -Math.abs(k.attr("data-x")),
                    b.core.s.useLeftForZoom ? k.css({
                        left: i + "px",
                        top: j + "px"
                    }) : k.css("transform", "translate3d(" + i + "px, " + j + "px, 0)")
                }
            }),
            a(window).on("mouseup.lg.zoom", function(a) {
                e && (e = !1,
                b.core.$outer.removeClass("lg-zoom-dragging"),
                !f || c.x === d.x && c.y === d.y || (d = {
                    x: a.pageX,
                    y: a.pageY
                },
                b.touchendZoom(c, d, g, h)),
                f = !1),
                b.core.$outer.removeClass("lg-grabbing").addClass("lg-grab")
            })
        }
        ,
        d.prototype.touchendZoom = function(a, b, c, d) {
            var e = this
              , f = e.core.$slide.eq(e.core.index).find(".lg-img-wrap")
              , g = e.core.$slide.eq(e.core.index).find(".lg-object")
              , h = -Math.abs(f.attr("data-x")) + (b.x - a.x)
              , i = -Math.abs(f.attr("data-y")) + (b.y - a.y)
              , j = (e.core.$outer.find(".lg").height() - g.prop("offsetHeight")) / 2
              , k = Math.abs(g.prop("offsetHeight") * Math.abs(g.attr("data-scale")) - e.core.$outer.find(".lg").height() + j)
              , l = (e.core.$outer.find(".lg").width() - g.prop("offsetWidth")) / 2
              , m = Math.abs(g.prop("offsetWidth") * Math.abs(g.attr("data-scale")) - e.core.$outer.find(".lg").width() + l);
            (Math.abs(b.x - a.x) > 15 || Math.abs(b.y - a.y) > 15) && (d && (i <= -k ? i = -k : i >= -j && (i = -j)),
            c && (h <= -m ? h = -m : h >= -l && (h = -l)),
            d ? f.attr("data-y", Math.abs(i)) : i = -Math.abs(f.attr("data-y")),
            c ? f.attr("data-x", Math.abs(h)) : h = -Math.abs(f.attr("data-x")),
            e.core.s.useLeftForZoom ? f.css({
                left: h + "px",
                top: i + "px"
            }) : f.css("transform", "translate3d(" + h + "px, " + i + "px, 0)"))
        }
        ,
        d.prototype.destroy = function() {
            var b = this;
            b.core.$el.off(".lg.zoom"),
            a(window).off(".lg.zoom"),
            b.core.$slide.off(".lg.zoom"),
            b.core.$el.off(".lg.tm.zoom"),
            b.resetZoom(),
            clearTimeout(b.zoomabletimeout),
            b.zoomabletimeout = !1
        }
        ,
        a.fn.lightGallery.modules.zoom = d
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = {
            hash: !0
        }
          , c = function(c) {
            return this.core = a(c).data("lightGallery"),
            this.core.s = a.extend({}, b, this.core.s),
            this.core.s.hash && (this.oldHash = window.location.hash,
            this.init()),
            this
        };
        c.prototype.init = function() {
            var b, c = this;
            c.core.$el.on("onAfterSlide.lg.tm", function(a, b, d) {
                history.replaceState ? history.replaceState(null, null, window.location.pathname + window.location.search + "#lg=" + c.core.s.galleryId + "&slide=" + d) : window.location.hash = "lg=" + c.core.s.galleryId + "&slide=" + d
            }),
            a(window).on("hashchange.lg.hash", function() {
                b = window.location.hash;
                var a = parseInt(b.split("&slide=")[1], 10);
                b.indexOf("lg=" + c.core.s.galleryId) > -1 ? c.core.slide(a, !1, !1) : c.core.lGalleryOn && c.core.destroy()
            })
        }
        ,
        c.prototype.destroy = function() {
            this.core.s.hash && (this.oldHash && this.oldHash.indexOf("lg=" + this.core.s.galleryId) < 0 ? history.replaceState ? history.replaceState(null, null, this.oldHash) : window.location.hash = this.oldHash : history.replaceState ? history.replaceState(null, document.title, window.location.pathname + window.location.search) : window.location.hash = "",
            this.core.$el.off(".lg.hash"))
        }
        ,
        a.fn.lightGallery.modules.hash = c
    }()
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], function(a) {
        return b(a)
    }) : "object" == typeof exports ? module.exports = b(require("jquery")) : b(jQuery)
}(0, function(a) {
    !function() {
        "use strict";
        var b = {
            share: !0,
            facebook: !0,
            facebookDropdownText: "Facebook",
            twitter: !0,
            twitterDropdownText: "Twitter",
            googlePlus: !0,
            googlePlusDropdownText: "GooglePlus",
            pinterest: !0,
            pinterestDropdownText: "Pinterest"
        }
          , c = function(c) {
            return this.core = a(c).data("lightGallery"),
            this.core.s = a.extend({}, b, this.core.s),
            this.core.s.share && this.init(),
            this
        };
        c.prototype.init = function() {
            var b = this
              , c = '<span id="lg-share" class="lg-icon"><ul class="lg-dropdown" style="position: absolute;">';
            c += b.core.s.facebook ? '<li><a id="lg-share-facebook" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.facebookDropdownText + "</span></a></li>" : "",
            c += b.core.s.twitter ? '<li><a id="lg-share-twitter" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.twitterDropdownText + "</span></a></li>" : "",
            c += b.core.s.googlePlus ? '<li><a id="lg-share-googleplus" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.googlePlusDropdownText + "</span></a></li>" : "",
            c += b.core.s.pinterest ? '<li><a id="lg-share-pinterest" target="_blank"><span class="lg-icon"></span><span class="lg-dropdown-text">' + this.core.s.pinterestDropdownText + "</span></a></li>" : "",
            c += "</ul></span>",
            this.core.$outer.find(".lg-toolbar").append(c),
            this.core.$outer.find(".lg").append('<div id="lg-dropdown-overlay"></div>'),
            a("#lg-share").on("click.lg", function() {
                b.core.$outer.toggleClass("lg-dropdown-active")
            }),
            a("#lg-dropdown-overlay").on("click.lg", function() {
                b.core.$outer.removeClass("lg-dropdown-active")
            }),
            b.core.$el.on("onAfterSlide.lg.tm", function(c, d, e) {
                setTimeout(function() {
                    a("#lg-share-facebook").attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(b.getSahreProps(e, "facebookShareUrl") || window.location.href)),
                    a("#lg-share-twitter").attr("href", "https://twitter.com/intent/tweet?text=" + b.getSahreProps(e, "tweetText") + "&url=" + encodeURIComponent(b.getSahreProps(e, "twitterShareUrl") || window.location.href)),
                    a("#lg-share-googleplus").attr("href", "https://plus.google.com/share?url=" + encodeURIComponent(b.getSahreProps(e, "googleplusShareUrl") || window.location.href)),
                    a("#lg-share-pinterest").attr("href", "http://www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(b.getSahreProps(e, "pinterestShareUrl") || window.location.href) + "&media=" + encodeURIComponent(b.getSahreProps(e, "src")) + "&description=" + b.getSahreProps(e, "pinterestText"))
                }, 100)
            })
        }
        ,
        c.prototype.getSahreProps = function(a, b) {
            var c = "";
            if (this.core.s.dynamic)
                c = this.core.s.dynamicEl[a][b];
            else {
                var d = this.core.$items.eq(a).attr("href")
                  , e = this.core.$items.eq(a).data(b);
                c = "src" === b ? d || e : e
            }
            return c
        }
        ,
        c.prototype.destroy = function() {}
        ,
        a.fn.lightGallery.modules.share = c
    }()
});

/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(e, t) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? module.exports = t() : e.EvEmitter = t()
}("undefined" != typeof window ? window : this, function() {
    function e() {}
    var t = e.prototype;
    return t.on = function(e, t) {
        if (e && t) {
            var i = this._events = this._events || {}
              , n = i[e] = i[e] || [];
            return n.indexOf(t) == -1 && n.push(t),
            this
        }
    }
    ,
    t.once = function(e, t) {
        if (e && t) {
            this.on(e, t);
            var i = this._onceEvents = this._onceEvents || {}
              , n = i[e] = i[e] || {};
            return n[t] = !0,
            this
        }
    }
    ,
    t.off = function(e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
            var n = i.indexOf(t);
            return n != -1 && i.splice(n, 1),
            this
        }
    }
    ,
    t.emitEvent = function(e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
            i = i.slice(0),
            t = t || [];
            for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                var r = i[o]
                  , s = n && n[r];
                s && (this.off(e, r),
                delete n[r]),
                r.apply(this, t)
            }
            return this
        }
    }
    ,
    t.allOff = function() {
        delete this._events,
        delete this._onceEvents
    }
    ,
    e
}),
function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function(i) {
        return t(e, i)
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("ev-emitter")) : e.imagesLoaded = t(e, e.EvEmitter)
}("undefined" != typeof window ? window : this, function(e, t) {
    function i(e, t) {
        for (var i in t)
            e[i] = t[i];
        return e
    }
    function n(e) {
        if (Array.isArray(e))
            return e;
        var t = "object" == typeof e && "number" == typeof e.length;
        return t ? d.call(e) : [e]
    }
    function o(e, t, r) {
        if (!(this instanceof o))
            return new o(e,t,r);
        var s = e;
        return "string" == typeof e && (s = document.querySelectorAll(e)),
        s ? (this.elements = n(s),
        this.options = i({}, this.options),
        "function" == typeof t ? r = t : i(this.options, t),
        r && this.on("always", r),
        this.getImages(),
        h && (this.jqDeferred = new h.Deferred),
        void setTimeout(this.check.bind(this))) : void a.error("Bad element for imagesLoaded " + (s || e))
    }
    function r(e) {
        this.img = e
    }
    function s(e, t) {
        this.url = e,
        this.element = t,
        this.img = new Image
    }
    var h = e.jQuery
      , a = e.console
      , d = Array.prototype.slice;
    o.prototype = Object.create(t.prototype),
    o.prototype.options = {},
    o.prototype.getImages = function() {
        this.images = [],
        this.elements.forEach(this.addElementImages, this)
    }
    ,
    o.prototype.addElementImages = function(e) {
        "IMG" == e.nodeName && this.addImage(e),
        this.options.background === !0 && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && u[t]) {
            for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                var o = i[n];
                this.addImage(o)
            }
            if ("string" == typeof this.options.background) {
                var r = e.querySelectorAll(this.options.background);
                for (n = 0; n < r.length; n++) {
                    var s = r[n];
                    this.addElementBackgroundImages(s)
                }
            }
        }
    }
    ;
    var u = {
        1: !0,
        9: !0,
        11: !0
    };
    return o.prototype.addElementBackgroundImages = function(e) {
        var t = getComputedStyle(e);
        if (t)
            for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
                var o = n && n[2];
                o && this.addBackground(o, e),
                n = i.exec(t.backgroundImage)
            }
    }
    ,
    o.prototype.addImage = function(e) {
        var t = new r(e);
        this.images.push(t)
    }
    ,
    o.prototype.addBackground = function(e, t) {
        var i = new s(e,t);
        this.images.push(i)
    }
    ,
    o.prototype.check = function() {
        function e(e, i, n) {
            setTimeout(function() {
                t.progress(e, i, n)
            })
        }
        var t = this;
        return this.progressedCount = 0,
        this.hasAnyBroken = !1,
        this.images.length ? void this.images.forEach(function(t) {
            t.once("progress", e),
            t.check()
        }) : void this.complete()
    }
    ,
    o.prototype.progress = function(e, t, i) {
        this.progressedCount++,
        this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded,
        this.emitEvent("progress", [this, e, t]),
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
        this.progressedCount == this.images.length && this.complete(),
        this.options.debug && a && a.log("progress: " + i, e, t)
    }
    ,
    o.prototype.complete = function() {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0,
        this.emitEvent(e, [this]),
        this.emitEvent("always", [this]),
        this.jqDeferred) {
            var t = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[t](this)
        }
    }
    ,
    r.prototype = Object.create(t.prototype),
    r.prototype.check = function() {
        var e = this.getIsImageComplete();
        return e ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image,
        this.proxyImage.addEventListener("load", this),
        this.proxyImage.addEventListener("error", this),
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        void (this.proxyImage.src = this.img.src))
    }
    ,
    r.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth
    }
    ,
    r.prototype.confirm = function(e, t) {
        this.isLoaded = e,
        this.emitEvent("progress", [this, this.img, t])
    }
    ,
    r.prototype.handleEvent = function(e) {
        var t = "on" + e.type;
        this[t] && this[t](e)
    }
    ,
    r.prototype.onload = function() {
        this.confirm(!0, "onload"),
        this.unbindEvents()
    }
    ,
    r.prototype.onerror = function() {
        this.confirm(!1, "onerror"),
        this.unbindEvents()
    }
    ,
    r.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this),
        this.proxyImage.removeEventListener("error", this),
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this)
    }
    ,
    s.prototype = Object.create(r.prototype),
    s.prototype.check = function() {
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        this.img.src = this.url;
        var e = this.getIsImageComplete();
        e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
        this.unbindEvents())
    }
    ,
    s.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this)
    }
    ,
    s.prototype.confirm = function(e, t) {
        this.isLoaded = e,
        this.emitEvent("progress", [this, this.element, t])
    }
    ,
    o.makeJQueryPlugin = function(t) {
        t = t || e.jQuery,
        t && (h = t,
        h.fn.imagesLoaded = function(e, t) {
            var i = new o(this,e,t);
            return i.jqDeferred.promise(h(this))
        }
        )
    }
    ,
    o.makeJQueryPlugin(),
    o
});

/*!
 * Isotope PACKAGED v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */

!function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function(t, e) {
    "use strict";
    function i(i, s, a) {
        function u(t, e, o) {
            var n, s = "$()." + i + '("' + e + '")';
            return t.each(function(t, u) {
                var h = a.data(u, i);
                if (!h)
                    return void r(i + " not initialized. Cannot call methods, i.e. " + s);
                var d = h[e];
                if (!d || "_" == e.charAt(0))
                    return void r(s + " is not a valid method");
                var l = d.apply(h, o);
                n = void 0 === n ? l : n
            }),
            void 0 !== n ? n : t
        }
        function h(t, e) {
            t.each(function(t, o) {
                var n = a.data(o, i);
                n ? (n.option(e),
                n._init()) : (n = new s(o,e),
                a.data(o, i, n))
            })
        }
        a = a || e || t.jQuery,
        a && (s.prototype.option || (s.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }
        ),
        a.fn[i] = function(t) {
            if ("string" == typeof t) {
                var e = n.call(arguments, 1);
                return u(this, t, e)
            }
            return h(this, t),
            this
        }
        ,
        o(a))
    }
    function o(t) {
        !t || t && t.bridget || (t.bridget = i)
    }
    var n = Array.prototype.slice
      , s = t.console
      , r = "undefined" == typeof s ? function() {}
    : function(t) {
        s.error(t)
    }
    ;
    return o(e || t.jQuery),
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {}
              , o = i[t] = i[t] || [];
            return o.indexOf(e) == -1 && o.push(e),
            this
        }
    }
    ,
    e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {}
              , o = i[t] = i[t] || {};
            return o[e] = !0,
            this
        }
    }
    ,
    e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var o = i.indexOf(e);
            return o != -1 && i.splice(o, 1),
            this
        }
    }
    ,
    e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0),
            e = e || [];
            for (var o = this._onceEvents && this._onceEvents[t], n = 0; n < i.length; n++) {
                var s = i[n]
                  , r = o && o[s];
                r && (this.off(t, s),
                delete o[s]),
                s.apply(this, e)
            }
            return this
        }
    }
    ,
    e.allOff = function() {
        delete this._events,
        delete this._onceEvents
    }
    ,
    t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";
    function t(t) {
        var e = parseFloat(t)
          , i = t.indexOf("%") == -1 && !isNaN(e);
        return i && e
    }
    function e() {}
    function i() {
        for (var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, e = 0; e < h; e++) {
            var i = u[e];
            t[i] = 0
        }
        return t
    }
    function o(t) {
        var e = getComputedStyle(t);
        return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),
        e
    }
    function n() {
        if (!d) {
            d = !0;
            var e = document.createElement("div");
            e.style.width = "200px",
            e.style.padding = "1px 2px 3px 4px",
            e.style.borderStyle = "solid",
            e.style.borderWidth = "1px 2px 3px 4px",
            e.style.boxSizing = "border-box";
            var i = document.body || document.documentElement;
            i.appendChild(e);
            var n = o(e);
            r = 200 == Math.round(t(n.width)),
            s.isBoxSizeOuter = r,
            i.removeChild(e)
        }
    }
    function s(e) {
        if (n(),
        "string" == typeof e && (e = document.querySelector(e)),
        e && "object" == typeof e && e.nodeType) {
            var s = o(e);
            if ("none" == s.display)
                return i();
            var a = {};
            a.width = e.offsetWidth,
            a.height = e.offsetHeight;
            for (var d = a.isBorderBox = "border-box" == s.boxSizing, l = 0; l < h; l++) {
                var f = u[l]
                  , c = s[f]
                  , m = parseFloat(c);
                a[f] = isNaN(m) ? 0 : m
            }
            var p = a.paddingLeft + a.paddingRight
              , y = a.paddingTop + a.paddingBottom
              , g = a.marginLeft + a.marginRight
              , v = a.marginTop + a.marginBottom
              , _ = a.borderLeftWidth + a.borderRightWidth
              , z = a.borderTopWidth + a.borderBottomWidth
              , I = d && r
              , x = t(s.width);
            x !== !1 && (a.width = x + (I ? 0 : p + _));
            var S = t(s.height);
            return S !== !1 && (a.height = S + (I ? 0 : y + z)),
            a.innerWidth = a.width - (p + _),
            a.innerHeight = a.height - (y + z),
            a.outerWidth = a.width + g,
            a.outerHeight = a.height + v,
            a
        }
    }
    var r, a = "undefined" == typeof console ? e : function(t) {
        console.error(t)
    }
    , u = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], h = u.length, d = !1;
    return s
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches)
            return "matches";
        if (t.matchesSelector)
            return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var o = e[i]
              , n = o + "MatchesSelector";
            if (t[n])
                return n
        }
    }();
    return function(e, i) {
        return e[t](i)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function(t, e) {
    var i = {};
    i.extend = function(t, e) {
        for (var i in e)
            t[i] = e[i];
        return t
    }
    ,
    i.modulo = function(t, e) {
        return (t % e + e) % e
    }
    ;
    var o = Array.prototype.slice;
    i.makeArray = function(t) {
        if (Array.isArray(t))
            return t;
        if (null === t || void 0 === t)
            return [];
        var e = "object" == typeof t && "number" == typeof t.length;
        return e ? o.call(t) : [t]
    }
    ,
    i.removeFrom = function(t, e) {
        var i = t.indexOf(e);
        i != -1 && t.splice(i, 1)
    }
    ,
    i.getParent = function(t, i) {
        for (; t.parentNode && t != document.body; )
            if (t = t.parentNode,
            e(t, i))
                return t
    }
    ,
    i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }
    ,
    i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    i.filterFindElements = function(t, o) {
        t = i.makeArray(t);
        var n = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement) {
                if (!o)
                    return void n.push(t);
                e(t, o) && n.push(t);
                for (var i = t.querySelectorAll(o), s = 0; s < i.length; s++)
                    n.push(i[s])
            }
        }),
        n
    }
    ,
    i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var o = t.prototype[e]
          , n = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[n];
            clearTimeout(t);
            var e = arguments
              , s = this;
            this[n] = setTimeout(function() {
                o.apply(s, e),
                delete s[n]
            }, i)
        }
    }
    ,
    i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }
    ,
    i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    }
    ;
    var n = t.console;
    return i.htmlInit = function(e, o) {
        i.docReady(function() {
            var s = i.toDashed(o)
              , r = "data-" + s
              , a = document.querySelectorAll("[" + r + "]")
              , u = document.querySelectorAll(".js-" + s)
              , h = i.makeArray(a).concat(i.makeArray(u))
              , d = r + "-options"
              , l = t.jQuery;
            h.forEach(function(t) {
                var i, s = t.getAttribute(r) || t.getAttribute(d);
                try {
                    i = s && JSON.parse(s)
                } catch (a) {
                    return void (n && n.error("Error parsing " + r + " on " + t.className + ": " + a))
                }
                var u = new e(t,i);
                l && l.data(t, o, u)
            })
        })
    }
    ,
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {},
    t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function(t, e) {
    "use strict";
    function i(t) {
        for (var e in t)
            return !1;
        return e = null,
        !0
    }
    function o(t, e) {
        t && (this.element = t,
        this.layout = e,
        this.position = {
            x: 0,
            y: 0
        },
        this._create())
    }
    function n(t) {
        return t.replace(/([A-Z])/g, function(t) {
            return "-" + t.toLowerCase()
        })
    }
    var s = document.documentElement.style
      , r = "string" == typeof s.transition ? "transition" : "WebkitTransition"
      , a = "string" == typeof s.transform ? "transform" : "WebkitTransform"
      , u = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend"
    }[r]
      , h = {
        transform: a,
        transition: r,
        transitionDuration: r + "Duration",
        transitionProperty: r + "Property",
        transitionDelay: r + "Delay"
    }
      , d = o.prototype = Object.create(t.prototype);
    d.constructor = o,
    d._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        },
        this.css({
            position: "absolute"
        })
    }
    ,
    d.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    d.getSize = function() {
        this.size = e(this.element)
    }
    ,
    d.css = function(t) {
        var e = this.element.style;
        for (var i in t) {
            var o = h[i] || i;
            e[o] = t[i]
        }
    }
    ,
    d.getPosition = function() {
        var t = getComputedStyle(this.element)
          , e = this.layout._getOption("originLeft")
          , i = this.layout._getOption("originTop")
          , o = t[e ? "left" : "right"]
          , n = t[i ? "top" : "bottom"]
          , s = parseFloat(o)
          , r = parseFloat(n)
          , a = this.layout.size;
        o.indexOf("%") != -1 && (s = s / 100 * a.width),
        n.indexOf("%") != -1 && (r = r / 100 * a.height),
        s = isNaN(s) ? 0 : s,
        r = isNaN(r) ? 0 : r,
        s -= e ? a.paddingLeft : a.paddingRight,
        r -= i ? a.paddingTop : a.paddingBottom,
        this.position.x = s,
        this.position.y = r
    }
    ,
    d.layoutPosition = function() {
        var t = this.layout.size
          , e = {}
          , i = this.layout._getOption("originLeft")
          , o = this.layout._getOption("originTop")
          , n = i ? "paddingLeft" : "paddingRight"
          , s = i ? "left" : "right"
          , r = i ? "right" : "left"
          , a = this.position.x + t[n];
        e[s] = this.getXValue(a),
        e[r] = "";
        var u = o ? "paddingTop" : "paddingBottom"
          , h = o ? "top" : "bottom"
          , d = o ? "bottom" : "top"
          , l = this.position.y + t[u];
        e[h] = this.getYValue(l),
        e[d] = "",
        this.css(e),
        this.emitEvent("layout", [this])
    }
    ,
    d.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }
    ,
    d.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }
    ,
    d._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x
          , o = this.position.y
          , n = t == this.position.x && e == this.position.y;
        if (this.setPosition(t, e),
        n && !this.isTransitioning)
            return void this.layoutPosition();
        var s = t - i
          , r = e - o
          , a = {};
        a.transform = this.getTranslate(s, r),
        this.transition({
            to: a,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: !0
        })
    }
    ,
    d.getTranslate = function(t, e) {
        var i = this.layout._getOption("originLeft")
          , o = this.layout._getOption("originTop");
        return t = i ? t : -t,
        e = o ? e : -e,
        "translate3d(" + t + "px, " + e + "px, 0)"
    }
    ,
    d.goTo = function(t, e) {
        this.setPosition(t, e),
        this.layoutPosition()
    }
    ,
    d.moveTo = d._transitionTo,
    d.setPosition = function(t, e) {
        this.position.x = parseFloat(t),
        this.position.y = parseFloat(e)
    }
    ,
    d._nonTransition = function(t) {
        this.css(t.to),
        t.isCleaning && this._removeStyles(t.to);
        for (var e in t.onTransitionEnd)
            t.onTransitionEnd[e].call(this)
    }
    ,
    d.transition = function(t) {
        if (!parseFloat(this.layout.options.transitionDuration))
            return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd)
            e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to)
            e.ingProperties[i] = !0,
            t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
            this.css(t.from);
            var o = this.element.offsetHeight;
            o = null
        }
        this.enableTransition(t.to),
        this.css(t.to),
        this.isTransitioning = !0
    }
    ;
    var l = "opacity," + n(a);
    d.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t,
            this.css({
                transitionProperty: l,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }),
            this.element.addEventListener(u, this, !1)
        }
    }
    ,
    d.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t)
    }
    ,
    d.onotransitionend = function(t) {
        this.ontransitionend(t)
    }
    ;
    var f = {
        "-webkit-transform": "transform"
    };
    d.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn
              , o = f[t.propertyName] || t.propertyName;
            if (delete e.ingProperties[o],
            i(e.ingProperties) && this.disableTransition(),
            o in e.clean && (this.element.style[t.propertyName] = "",
            delete e.clean[o]),
            o in e.onEnd) {
                var n = e.onEnd[o];
                n.call(this),
                delete e.onEnd[o]
            }
            this.emitEvent("transitionEnd", [this])
        }
    }
    ,
    d.disableTransition = function() {
        this.removeTransitionStyles(),
        this.element.removeEventListener(u, this, !1),
        this.isTransitioning = !1
    }
    ,
    d._removeStyles = function(t) {
        var e = {};
        for (var i in t)
            e[i] = "";
        this.css(e)
    }
    ;
    var c = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return d.removeTransitionStyles = function() {
        this.css(c)
    }
    ,
    d.stagger = function(t) {
        t = isNaN(t) ? 0 : t,
        this.staggerDelay = t + "ms"
    }
    ,
    d.removeElem = function() {
        this.element.parentNode.removeChild(this.element),
        this.css({
            display: ""
        }),
        this.emitEvent("remove", [this])
    }
    ,
    d.remove = function() {
        return r && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }),
        void this.hide()) : void this.removeElem()
    }
    ,
    d.reveal = function() {
        delete this.isHidden,
        this.css({
            display: ""
        });
        var t = this.layout.options
          , e = {}
          , i = this.getHideRevealTransitionEndProperty("visibleStyle");
        e[i] = this.onRevealTransitionEnd,
        this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }
    ,
    d.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }
    ,
    d.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity)
            return "opacity";
        for (var i in e)
            return i
    }
    ,
    d.hide = function() {
        this.isHidden = !0,
        this.css({
            display: ""
        });
        var t = this.layout.options
          , e = {}
          , i = this.getHideRevealTransitionEndProperty("hiddenStyle");
        e[i] = this.onHideTransitionEnd,
        this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }
    ,
    d.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }),
        this.emitEvent("hide"))
    }
    ,
    d.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }
    ,
    o
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(i, o, n, s) {
        return e(t, i, o, n, s)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item)
}(window, function(t, e, i, o, n) {
    "use strict";
    function s(t, e) {
        var i = o.getQueryElement(t);
        if (!i)
            return void (u && u.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
        this.element = i,
        h && (this.$element = h(this.element)),
        this.options = o.extend({}, this.constructor.defaults),
        this.option(e);
        var n = ++l;
        this.element.outlayerGUID = n,
        f[n] = this,
        this._create();
        var s = this._getOption("initLayout");
        s && this.layout()
    }
    function r(t) {
        function e() {
            t.apply(this, arguments)
        }
        return e.prototype = Object.create(t.prototype),
        e.prototype.constructor = e,
        e
    }
    function a(t) {
        if ("number" == typeof t)
            return t;
        var e = t.match(/(^\d*\.?\d*)(\w*)/)
          , i = e && e[1]
          , o = e && e[2];
        if (!i.length)
            return 0;
        i = parseFloat(i);
        var n = m[o] || 1;
        return i * n
    }
    var u = t.console
      , h = t.jQuery
      , d = function() {}
      , l = 0
      , f = {};
    s.namespace = "outlayer",
    s.Item = n,
    s.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var c = s.prototype;
    o.extend(c, e.prototype),
    c.option = function(t) {
        o.extend(this.options, t)
    }
    ,
    c._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }
    ,
    s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    },
    c._create = function() {
        this.reloadItems(),
        this.stamps = [],
        this.stamp(this.options.stamp),
        o.extend(this.element.style, this.options.containerStyle);
        var t = this._getOption("resize");
        t && this.bindResize()
    }
    ,
    c.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }
    ,
    c._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, o = [], n = 0; n < e.length; n++) {
            var s = e[n]
              , r = new i(s,this);
            o.push(r)
        }
        return o
    }
    ,
    c._filterFindItemElements = function(t) {
        return o.filterFindElements(t, this.options.itemSelector)
    }
    ,
    c.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element
        })
    }
    ,
    c.layout = function() {
        this._resetLayout(),
        this._manageStamps();
        var t = this._getOption("layoutInstant")
          , e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e),
        this._isLayoutInited = !0
    }
    ,
    c._init = c.layout,
    c._resetLayout = function() {
        this.getSize()
    }
    ,
    c.getSize = function() {
        this.size = i(this.element)
    }
    ,
    c._getMeasurement = function(t, e) {
        var o, n = this.options[t];
        n ? ("string" == typeof n ? o = this.element.querySelector(n) : n instanceof HTMLElement && (o = n),
        this[t] = o ? i(o)[e] : n) : this[t] = 0
    }
    ,
    c.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t),
        this._layoutItems(t, e),
        this._postLayout()
    }
    ,
    c._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored
        })
    }
    ,
    c._layoutItems = function(t, e) {
        if (this._emitCompleteOnItems("layout", t),
        t && t.length) {
            var i = [];
            t.forEach(function(t) {
                var o = this._getItemLayoutPosition(t);
                o.item = t,
                o.isInstant = e || t.isLayoutInstant,
                i.push(o)
            }, this),
            this._processLayoutQueue(i)
        }
    }
    ,
    c._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }
    ,
    c._processLayoutQueue = function(t) {
        this.updateStagger(),
        t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }
    ,
    c.updateStagger = function() {
        var t = this.options.stagger;
        return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t),
        this.stagger)
    }
    ,
    c._positionItem = function(t, e, i, o, n) {
        o ? t.goTo(e, i) : (t.stagger(n * this.stagger),
        t.moveTo(e, i))
    }
    ,
    c._postLayout = function() {
        this.resizeContainer()
    }
    ,
    c.resizeContainer = function() {
        var t = this._getOption("resizeContainer");
        if (t) {
            var e = this._getContainerSize();
            e && (this._setContainerMeasure(e.width, !0),
            this._setContainerMeasure(e.height, !1))
        }
    }
    ,
    c._getContainerSize = d,
    c._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth),
            t = Math.max(t, 0),
            this.element.style[e ? "width" : "height"] = t + "px"
        }
    }
    ,
    c._emitCompleteOnItems = function(t, e) {
        function i() {
            n.dispatchEvent(t + "Complete", null, [e])
        }
        function o() {
            r++,
            r == s && i()
        }
        var n = this
          , s = e.length;
        if (!e || !s)
            return void i();
        var r = 0;
        e.forEach(function(e) {
            e.once(t, o)
        })
    }
    ,
    c.dispatchEvent = function(t, e, i) {
        var o = e ? [e].concat(i) : i;
        if (this.emitEvent(t, o),
        h)
            if (this.$element = this.$element || h(this.element),
            e) {
                var n = h.Event(e);
                n.type = t,
                this.$element.trigger(n, i)
            } else
                this.$element.trigger(t, i)
    }
    ,
    c.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }
    ,
    c.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }
    ,
    c.stamp = function(t) {
        t = this._find(t),
        t && (this.stamps = this.stamps.concat(t),
        t.forEach(this.ignore, this))
    }
    ,
    c.unstamp = function(t) {
        t = this._find(t),
        t && t.forEach(function(t) {
            o.removeFrom(this.stamps, t),
            this.unignore(t)
        }, this)
    }
    ,
    c._find = function(t) {
        if (t)
            return "string" == typeof t && (t = this.element.querySelectorAll(t)),
            t = o.makeArray(t)
    }
    ,
    c._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(),
        this.stamps.forEach(this._manageStamp, this))
    }
    ,
    c._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect()
          , e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }
    ,
    c._manageStamp = d,
    c._getElementOffset = function(t) {
        var e = t.getBoundingClientRect()
          , o = this._boundingRect
          , n = i(t)
          , s = {
            left: e.left - o.left - n.marginLeft,
            top: e.top - o.top - n.marginTop,
            right: o.right - e.right - n.marginRight,
            bottom: o.bottom - e.bottom - n.marginBottom
        };
        return s
    }
    ,
    c.handleEvent = o.handleEvent,
    c.bindResize = function() {
        t.addEventListener("resize", this),
        this.isResizeBound = !0
    }
    ,
    c.unbindResize = function() {
        t.removeEventListener("resize", this),
        this.isResizeBound = !1
    }
    ,
    c.onresize = function() {
        this.resize()
    }
    ,
    o.debounceMethod(s, "onresize", 100),
    c.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }
    ,
    c.needsResizeLayout = function() {
        var t = i(this.element)
          , e = this.size && t;
        return e && t.innerWidth !== this.size.innerWidth
    }
    ,
    c.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)),
        e
    }
    ,
    c.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0),
        this.reveal(e))
    }
    ,
    c.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i)
        }
    }
    ,
    c.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t),
        t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e),
                t.reveal()
            })
        }
    }
    ,
    c.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t),
        t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e),
                t.hide()
            })
        }
    }
    ,
    c.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e)
    }
    ,
    c.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e)
    }
    ,
    c.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t)
                return i
        }
    }
    ,
    c.getItems = function(t) {
        t = o.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var i = this.getItem(t);
            i && e.push(i)
        }, this),
        e
    }
    ,
    c.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e),
        e && e.length && e.forEach(function(t) {
            t.remove(),
            o.removeFrom(this.items, t)
        }, this)
    }
    ,
    c.destroy = function() {
        var t = this.element.style;
        t.height = "",
        t.position = "",
        t.width = "",
        this.items.forEach(function(t) {
            t.destroy()
        }),
        this.unbindResize();
        var e = this.element.outlayerGUID;
        delete f[e],
        delete this.element.outlayerGUID,
        h && h.removeData(this.element, this.constructor.namespace)
    }
    ,
    s.data = function(t) {
        t = o.getQueryElement(t);
        var e = t && t.outlayerGUID;
        return e && f[e]
    }
    ,
    s.create = function(t, e) {
        var i = r(s);
        return i.defaults = o.extend({}, s.defaults),
        o.extend(i.defaults, e),
        i.compatOptions = o.extend({}, s.compatOptions),
        i.namespace = t,
        i.data = s.data,
        i.Item = r(n),
        o.htmlInit(i, t),
        h && h.bridget && h.bridget(t, i),
        i
    }
    ;
    var m = {
        ms: 1,
        s: 1e3
    };
    return s.Item = n,
    s
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/item", ["outlayer/outlayer"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer")) : (t.Isotope = t.Isotope || {},
    t.Isotope.Item = e(t.Outlayer))
}(window, function(t) {
    "use strict";
    function e() {
        t.Item.apply(this, arguments)
    }
    var i = e.prototype = Object.create(t.Item.prototype)
      , o = i._create;
    i._create = function() {
        this.id = this.layout.itemGUID++,
        o.call(this),
        this.sortData = {}
    }
    ,
    i.updateSortData = function() {
        if (!this.isIgnored) {
            this.sortData.id = this.id,
            this.sortData["original-order"] = this.id,
            this.sortData.random = Math.random();
            var t = this.layout.options.getSortData
              , e = this.layout._sorters;
            for (var i in t) {
                var o = e[i];
                this.sortData[i] = o(this.element, this)
            }
        }
    }
    ;
    var n = i.destroy;
    return i.destroy = function() {
        n.apply(this, arguments),
        this.css({
            display: ""
        })
    }
    ,
    e
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-mode", ["get-size/get-size", "outlayer/outlayer"], e) : "object" == typeof module && module.exports ? module.exports = e(require("get-size"), require("outlayer")) : (t.Isotope = t.Isotope || {},
    t.Isotope.LayoutMode = e(t.getSize, t.Outlayer))
}(window, function(t, e) {
    "use strict";
    function i(t) {
        this.isotope = t,
        t && (this.options = t.options[this.namespace],
        this.element = t.element,
        this.items = t.filteredItems,
        this.size = t.size)
    }
    var o = i.prototype
      , n = ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"];
    return n.forEach(function(t) {
        o[t] = function() {
            return e.prototype[t].apply(this.isotope, arguments)
        }
    }),
    o.needsVerticalResizeLayout = function() {
        var e = t(this.isotope.element)
          , i = this.isotope.size && e;
        return i && e.innerHeight != this.isotope.size.innerHeight
    }
    ,
    o._getMeasurement = function() {
        this.isotope._getMeasurement.apply(this, arguments)
    }
    ,
    o.getColumnWidth = function() {
        this.getSegmentSize("column", "Width")
    }
    ,
    o.getRowHeight = function() {
        this.getSegmentSize("row", "Height")
    }
    ,
    o.getSegmentSize = function(t, e) {
        var i = t + e
          , o = "outer" + e;
        if (this._getMeasurement(i, o),
        !this[i]) {
            var n = this.getFirstItemSize();
            this[i] = n && n[o] || this.isotope.size["inner" + e]
        }
    }
    ,
    o.getFirstItemSize = function() {
        var e = this.isotope.filteredItems[0];
        return e && e.element && t(e.element)
    }
    ,
    o.layout = function() {
        this.isotope.layout.apply(this.isotope, arguments)
    }
    ,
    o.getSize = function() {
        this.isotope.getSize(),
        this.size = this.isotope.size
    }
    ,
    i.modes = {},
    i.create = function(t, e) {
        function n() {
            i.apply(this, arguments)
        }
        return n.prototype = Object.create(o),
        n.prototype.constructor = n,
        e && (n.options = e),
        n.prototype.namespace = t,
        i.modes[t] = n,
        n
    }
    ,
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("masonry-layout/masonry", ["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function(t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var o = i.prototype;
    return o._resetLayout = function() {
        this.getSize(),
        this._getMeasurement("columnWidth", "outerWidth"),
        this._getMeasurement("gutter", "outerWidth"),
        this.measureColumns(),
        this.colYs = [];
        for (var t = 0; t < this.cols; t++)
            this.colYs.push(0);
        this.maxY = 0,
        this.horizontalColIndex = 0
    }
    ,
    o.measureColumns = function() {
        if (this.getContainerWidth(),
        !this.columnWidth) {
            var t = this.items[0]
              , i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth
        }
        var o = this.columnWidth += this.gutter
          , n = this.containerWidth + this.gutter
          , s = n / o
          , r = o - n % o
          , a = r && r < 1 ? "round" : "floor";
        s = Math[a](s),
        this.cols = Math.max(s, 1)
    }
    ,
    o.getContainerWidth = function() {
        var t = this._getOption("fitWidth")
          , i = t ? this.element.parentNode : this.element
          , o = e(i);
        this.containerWidth = o && o.innerWidth
    }
    ,
    o._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth
          , i = e && e < 1 ? "round" : "ceil"
          , o = Math[i](t.size.outerWidth / this.columnWidth);
        o = Math.min(o, this.cols);
        for (var n = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", s = this[n](o, t), r = {
            x: this.columnWidth * s.col,
            y: s.y
        }, a = s.y + t.size.outerHeight, u = o + s.col, h = s.col; h < u; h++)
            this.colYs[h] = a;
        return r
    }
    ,
    o._getTopColPosition = function(t) {
        var e = this._getTopColGroup(t)
          , i = Math.min.apply(Math, e);
        return {
            col: e.indexOf(i),
            y: i
        }
    }
    ,
    o._getTopColGroup = function(t) {
        if (t < 2)
            return this.colYs;
        for (var e = [], i = this.cols + 1 - t, o = 0; o < i; o++)
            e[o] = this._getColGroupY(o, t);
        return e
    }
    ,
    o._getColGroupY = function(t, e) {
        if (e < 2)
            return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i)
    }
    ,
    o._getHorizontalColPosition = function(t, e) {
        var i = this.horizontalColIndex % this.cols
          , o = t > 1 && i + t > this.cols;
        i = o ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = n ? i + t : this.horizontalColIndex,
        {
            col: i,
            y: this._getColGroupY(i, t)
        }
    }
    ,
    o._manageStamp = function(t) {
        var i = e(t)
          , o = this._getElementOffset(t)
          , n = this._getOption("originLeft")
          , s = n ? o.left : o.right
          , r = s + i.outerWidth
          , a = Math.floor(s / this.columnWidth);
        a = Math.max(0, a);
        var u = Math.floor(r / this.columnWidth);
        u -= r % this.columnWidth ? 0 : 1,
        u = Math.min(this.cols - 1, u);
        for (var h = this._getOption("originTop"), d = (h ? o.top : o.bottom) + i.outerHeight, l = a; l <= u; l++)
            this.colYs[l] = Math.max(d, this.colYs[l])
    }
    ,
    o._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()),
        t
    }
    ,
    o._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; )
            t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }
    ,
    o.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(),
        t != this.containerWidth
    }
    ,
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/masonry", ["../layout-mode", "masonry-layout/masonry"], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode"), require("masonry-layout")) : e(t.Isotope.LayoutMode, t.Masonry)
}(window, function(t, e) {
    "use strict";
    var i = t.create("masonry")
      , o = i.prototype
      , n = {
        _getElementOffset: !0,
        layout: !0,
        _getMeasurement: !0
    };
    for (var s in e.prototype)
        n[s] || (o[s] = e.prototype[s]);
    var r = o.measureColumns;
    o.measureColumns = function() {
        this.items = this.isotope.filteredItems,
        r.call(this)
    }
    ;
    var a = o._getOption;
    return o._getOption = function(t) {
        return "fitWidth" == t ? void 0 !== this.options.isFitWidth ? this.options.isFitWidth : this.options.fitWidth : a.apply(this.isotope, arguments)
    }
    ,
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/fit-rows", ["../layout-mode"], e) : "object" == typeof exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode)
}(window, function(t) {
    "use strict";
    var e = t.create("fitRows")
      , i = e.prototype;
    return i._resetLayout = function() {
        this.x = 0,
        this.y = 0,
        this.maxY = 0,
        this._getMeasurement("gutter", "outerWidth")
    }
    ,
    i._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth + this.gutter
          , i = this.isotope.size.innerWidth + this.gutter;
        0 !== this.x && e + this.x > i && (this.x = 0,
        this.y = this.maxY);
        var o = {
            x: this.x,
            y: this.y
        };
        return this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight),
        this.x += e,
        o
    }
    ,
    i._getContainerSize = function() {
        return {
            height: this.maxY
        }
    }
    ,
    e
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/vertical", ["../layout-mode"], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode)
}(window, function(t) {
    "use strict";
    var e = t.create("vertical", {
        horizontalAlignment: 0
    })
      , i = e.prototype;
    return i._resetLayout = function() {
        this.y = 0
    }
    ,
    i._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = (this.isotope.size.innerWidth - t.size.outerWidth) * this.options.horizontalAlignment
          , i = this.y;
        return this.y += t.size.outerHeight,
        {
            x: e,
            y: i
        }
    }
    ,
    i._getContainerSize = function() {
        return {
            height: this.y
        }
    }
    ,
    e
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size", "desandro-matches-selector/matches-selector", "fizzy-ui-utils/utils", "isotope-layout/js/item", "isotope-layout/js/layout-mode", "isotope-layout/js/layout-modes/masonry", "isotope-layout/js/layout-modes/fit-rows", "isotope-layout/js/layout-modes/vertical"], function(i, o, n, s, r, a) {
        return e(t, i, o, n, s, r, a)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("outlayer"), require("get-size"), require("desandro-matches-selector"), require("fizzy-ui-utils"), require("isotope-layout/js/item"), require("isotope-layout/js/layout-mode"), require("isotope-layout/js/layout-modes/masonry"), require("isotope-layout/js/layout-modes/fit-rows"), require("isotope-layout/js/layout-modes/vertical")) : t.Isotope = e(t, t.Outlayer, t.getSize, t.matchesSelector, t.fizzyUIUtils, t.Isotope.Item, t.Isotope.LayoutMode)
}(window, function(t, e, i, o, n, s, r) {
    function a(t, e) {
        return function(i, o) {
            for (var n = 0; n < t.length; n++) {
                var s = t[n]
                  , r = i.sortData[s]
                  , a = o.sortData[s];
                if (r > a || r < a) {
                    var u = void 0 !== e[s] ? e[s] : e
                      , h = u ? 1 : -1;
                    return (r > a ? 1 : -1) * h
                }
            }
            return 0
        }
    }
    var u = t.jQuery
      , h = String.prototype.trim ? function(t) {
        return t.trim()
    }
    : function(t) {
        return t.replace(/^\s+|\s+$/g, "")
    }
      , d = e.create("isotope", {
        layoutMode: "masonry",
        isJQueryFiltering: !0,
        sortAscending: !0
    });
    d.Item = s,
    d.LayoutMode = r;
    var l = d.prototype;
    l._create = function() {
        this.itemGUID = 0,
        this._sorters = {},
        this._getSorters(),
        e.prototype._create.call(this),
        this.modes = {},
        this.filteredItems = this.items,
        this.sortHistory = ["original-order"];
        for (var t in r.modes)
            this._initLayoutMode(t)
    }
    ,
    l.reloadItems = function() {
        this.itemGUID = 0,
        e.prototype.reloadItems.call(this)
    }
    ,
    l._itemize = function() {
        for (var t = e.prototype._itemize.apply(this, arguments), i = 0; i < t.length; i++) {
            var o = t[i];
            o.id = this.itemGUID++
        }
        return this._updateItemsSortData(t),
        t
    }
    ,
    l._initLayoutMode = function(t) {
        var e = r.modes[t]
          , i = this.options[t] || {};
        this.options[t] = e.options ? n.extend(e.options, i) : i,
        this.modes[t] = new e(this)
    }
    ,
    l.layout = function() {
        return !this._isLayoutInited && this._getOption("initLayout") ? void this.arrange() : void this._layout()
    }
    ,
    l._layout = function() {
        var t = this._getIsInstant();
        this._resetLayout(),
        this._manageStamps(),
        this.layoutItems(this.filteredItems, t),
        this._isLayoutInited = !0
    }
    ,
    l.arrange = function(t) {
        this.option(t),
        this._getIsInstant();
        var e = this._filter(this.items);
        this.filteredItems = e.matches,
        this._bindArrangeComplete(),
        this._isInstant ? this._noTransition(this._hideReveal, [e]) : this._hideReveal(e),
        this._sort(),
        this._layout()
    }
    ,
    l._init = l.arrange,
    l._hideReveal = function(t) {
        this.reveal(t.needReveal),
        this.hide(t.needHide)
    }
    ,
    l._getIsInstant = function() {
        var t = this._getOption("layoutInstant")
          , e = void 0 !== t ? t : !this._isLayoutInited;
        return this._isInstant = e,
        e
    }
    ,
    l._bindArrangeComplete = function() {
        function t() {
            e && i && o && n.dispatchEvent("arrangeComplete", null, [n.filteredItems])
        }
        var e, i, o, n = this;
        this.once("layoutComplete", function() {
            e = !0,
            t()
        }),
        this.once("hideComplete", function() {
            i = !0,
            t()
        }),
        this.once("revealComplete", function() {
            o = !0,
            t()
        })
    }
    ,
    l._filter = function(t) {
        var e = this.options.filter;
        e = e || "*";
        for (var i = [], o = [], n = [], s = this._getFilterTest(e), r = 0; r < t.length; r++) {
            var a = t[r];
            if (!a.isIgnored) {
                var u = s(a);
                u && i.push(a),
                u && a.isHidden ? o.push(a) : u || a.isHidden || n.push(a)
            }
        }
        return {
            matches: i,
            needReveal: o,
            needHide: n
        }
    }
    ,
    l._getFilterTest = function(t) {
        return u && this.options.isJQueryFiltering ? function(e) {
            return u(e.element).is(t);
        }
        : "function" == typeof t ? function(e) {
            return t(e.element)
        }
        : function(e) {
            return o(e.element, t)
        }
    }
    ,
    l.updateSortData = function(t) {
        var e;
        t ? (t = n.makeArray(t),
        e = this.getItems(t)) : e = this.items,
        this._getSorters(),
        this._updateItemsSortData(e)
    }
    ,
    l._getSorters = function() {
        var t = this.options.getSortData;
        for (var e in t) {
            var i = t[e];
            this._sorters[e] = f(i)
        }
    }
    ,
    l._updateItemsSortData = function(t) {
        for (var e = t && t.length, i = 0; e && i < e; i++) {
            var o = t[i];
            o.updateSortData()
        }
    }
    ;
    var f = function() {
        function t(t) {
            if ("string" != typeof t)
                return t;
            var i = h(t).split(" ")
              , o = i[0]
              , n = o.match(/^\[(.+)\]$/)
              , s = n && n[1]
              , r = e(s, o)
              , a = d.sortDataParsers[i[1]];
            return t = a ? function(t) {
                return t && a(r(t))
            }
            : function(t) {
                return t && r(t)
            }
        }
        function e(t, e) {
            return t ? function(e) {
                return e.getAttribute(t)
            }
            : function(t) {
                var i = t.querySelector(e);
                return i && i.textContent
            }
        }
        return t
    }();
    d.sortDataParsers = {
        parseInt: function(t) {
            return parseInt(t, 10)
        },
        parseFloat: function(t) {
            return parseFloat(t)
        }
    },
    l._sort = function() {
        if (this.options.sortBy) {
            var t = n.makeArray(this.options.sortBy);
            this._getIsSameSortBy(t) || (this.sortHistory = t.concat(this.sortHistory));
            var e = a(this.sortHistory, this.options.sortAscending);
            this.filteredItems.sort(e)
        }
    }
    ,
    l._getIsSameSortBy = function(t) {
        for (var e = 0; e < t.length; e++)
            if (t[e] != this.sortHistory[e])
                return !1;
        return !0
    }
    ,
    l._mode = function() {
        var t = this.options.layoutMode
          , e = this.modes[t];
        if (!e)
            throw new Error("No layout mode: " + t);
        return e.options = this.options[t],
        e
    }
    ,
    l._resetLayout = function() {
        e.prototype._resetLayout.call(this),
        this._mode()._resetLayout()
    }
    ,
    l._getItemLayoutPosition = function(t) {
        return this._mode()._getItemLayoutPosition(t)
    }
    ,
    l._manageStamp = function(t) {
        this._mode()._manageStamp(t)
    }
    ,
    l._getContainerSize = function() {
        return this._mode()._getContainerSize()
    }
    ,
    l.needsResizeLayout = function() {
        return this._mode().needsResizeLayout()
    }
    ,
    l.appended = function(t) {
        var e = this.addItems(t);
        if (e.length) {
            var i = this._filterRevealAdded(e);
            this.filteredItems = this.filteredItems.concat(i)
        }
    }
    ,
    l.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            this._resetLayout(),
            this._manageStamps();
            var i = this._filterRevealAdded(e);
            this.layoutItems(this.filteredItems),
            this.filteredItems = i.concat(this.filteredItems),
            this.items = e.concat(this.items)
        }
    }
    ,
    l._filterRevealAdded = function(t) {
        var e = this._filter(t);
        return this.hide(e.needHide),
        this.reveal(e.matches),
        this.layoutItems(e.matches, !0),
        e.matches
    }
    ,
    l.insert = function(t) {
        var e = this.addItems(t);
        if (e.length) {
            var i, o, n = e.length;
            for (i = 0; i < n; i++)
                o = e[i],
                this.element.appendChild(o.element);
            var s = this._filter(e).matches;
            for (i = 0; i < n; i++)
                e[i].isLayoutInstant = !0;
            for (this.arrange(),
            i = 0; i < n; i++)
                delete e[i].isLayoutInstant;
            this.reveal(s)
        }
    }
    ;
    var c = l.remove;
    return l.remove = function(t) {
        t = n.makeArray(t);
        var e = this.getItems(t);
        c.call(this, t);
        for (var i = e && e.length, o = 0; i && o < i; o++) {
            var s = e[o];
            n.removeFrom(this.filteredItems, s)
        }
    }
    ,
    l.shuffle = function() {
        for (var t = 0; t < this.items.length; t++) {
            var e = this.items[t];
            e.sortData.random = Math.random()
        }
        this.options.sortBy = "random",
        this._sort(),
        this._layout()
    }
    ,
    l._noTransition = function(t, e) {
        var i = this.options.transitionDuration;
        this.options.transitionDuration = 0;
        var o = t.apply(this, e);
        return this.options.transitionDuration = i,
        o
    }
    ,
    l.getFilteredItemElements = function() {
        return this.filteredItems.map(function(t) {
            return t.element
        })
    }
    ,
    d
});

/*! Nestoria Slider - v1.0.13 - 2015-07-16
* http://lokku.github.io/jquery-nstslider/
* Copyright (c) 2015 Lokku Ltd.; Licensed MIT */
!function(a) {
    var b, c, d, e, f, g, h, i, j, k = {
        setNakedBarDelta: function(a, b) {
            if ("stickToSides" === a)
                j = {
                    toEndWidth: b,
                    toBeginLeft: 0,
                    toBeginWidth: b
                };
            else {
                if ("middle" !== a)
                    throw new Error("unknown position of setNakedBarDelta: " + a);
                j = {
                    toEndWidth: b / 2,
                    toBeginLeft: b / 2,
                    toBeginWidth: b / 2
                }
            }
        },
        getSliderValuesAtPositionPx: function(a, b) {
            var c, d, e = this, f = e.data("pixel_to_value_mapping");
            if ("undefined" != typeof f)
                c = f(a),
                d = f(b);
            else {
                var g = k.getSliderWidthPx.call(e) - e.data("left_grip_width");
                c = k.inverse_rangemap_0_to_n.call(e, a, g),
                d = k.inverse_rangemap_0_to_n.call(e, b, g)
            }
            return [c, d]
        },
        validateAndMoveGripsToPx: function(a, b) {
            var c = this
              , d = k.getSliderWidthPx.call(c) - c.data("left_grip_width");
            if (d >= b && a >= 0 && d >= a && (!c.data("has_right_grip") || b >= a)) {
                var e = c.data("cur_min")
                  , f = c.data("cur_max");
                k.set_position_from_px.call(c, a, b),
                k.refresh_grips_style.call(c),
                k.notify_changed_implicit.call(c, "drag_move", e, f)
            }
            return c
        },
        updateAriaAttributes: function() {
            var a = this
              , b = a.data("settings")
              , c = a.find(b.left_grip_selector);
            if (a.data("has_right_grip")) {
                var d = a.find(b.right_grip_selector);
                c.attr("aria-valuemin", a.data("range_min")).attr("aria-valuenow", l.get_current_min_value.call(a)).attr("aria-valuemax", l.get_current_max_value.call(a)),
                d.attr("aria-valuemin", l.get_current_min_value.call(a)).attr("aria-valuenow", l.get_current_max_value.call(a)).attr("aria-valuemax", a.data("range_max"))
            } else
                c.attr("aria-valuemin", a.data("range_min")).attr("aria-valuenow", l.get_current_min_value.call(a)).attr("aria-valuemax", a.data("range_max"));
            return a
        },
        getSliderWidthPx: function() {
            var a = this;
            return Math.round(a.width())
        },
        getGripPositionPx: function(a) {
            return parseInt(a.css("left").replace("px", ""), 10)
        },
        getLeftGripPositionPx: function() {
            var a = this
              , b = a.data("settings")
              , c = a.find(b.left_grip_selector);
            return k.getGripPositionPx.call(a, c)
        },
        getRightGripPositionPx: function() {
            var a = this
              , b = a.data("settings");
            if (a.data("has_right_grip"))
                return k.getGripPositionPx.call(a, a.find(b.right_grip_selector));
            var c = k.getSliderWidthPx.call(a) - a.data("left_grip_width");
            return k.rangemap_0_to_n.call(a, a.data("cur_max"), c)
        },
        getLeftGripWidth: function() {
            var a = this
              , b = a.data("settings")
              , c = a.find(b.left_grip_selector);
            return Math.round(c.outerWidth())
        },
        getRightGripWidth: function() {
            var a = this
              , b = a.data("settings")
              , c = a.find(b.right_grip_selector);
            return Math.round(c.outerWidth())
        },
        binarySearchValueToPxCompareFunc: function(b, c, d) {
            return b === c[d] ? 0 : b < c[d] && 0 === d ? 0 : c[d - 1] <= b && b < c[d] ? 0 : b > c[d] ? 1 : b <= c[d - 1] ? -1 : void a.error("cannot compare s: " + b + " with a[" + d + "]. a is: " + c.join(","))
        },
        binarySearch: function(a, b, c, d) {
            for (var e, f, g = 0, h = a.length - 1; h >= g; ) {
                e = (g + h) / 2 | 0,
                f = c(a, e);
                var i = d(b, a, e);
                if (i > 0)
                    g = e + 1;
                else {
                    if (!(0 > i))
                        return e;
                    h = e - 1
                }
            }
            return -1
        },
        haveLimits: function() {
            var a = this
              , b = a.data("lower-limit")
              , c = a.data("upper-limit")
              , d = !1;
            return "undefined" != typeof b && "undefined" != typeof c && (d = !0),
            d
        },
        refresh_grips_style: function() {
            var a = this
              , b = a.data("settings");
            if ("undefined" != typeof b.highlight) {
                var c = a.data("highlightedRangeMin");
                if ("undefined" != typeof c) {
                    var d = a.find(b.left_grip_selector)
                      , e = a.find(b.right_grip_selector)
                      , f = a.data("highlightedRangeMax")
                      , g = a.data("cur_min")
                      , h = a.data("cur_max")
                      , i = b.highlight.grip_class;
                    c > g || g > f ? d.removeClass(i) : d.addClass(i),
                    c > h || h > f ? e.removeClass(i) : e.addClass(i)
                }
            }
        },
        set_position_from_val: function(a, b) {
            var c = this
              , d = c.data("range_min")
              , e = c.data("range_max");
            d > a && (a = d),
            a > e && (a = e),
            c.data("has_right_grip") ? (b > e && (b = e),
            d > b && (b = d)) : b = c.data("cur_max");
            var f = l.value_to_px.call(c, a)
              , g = l.value_to_px.call(c, b);
            return k.set_handles_at_px.call(c, f, g),
            c.data("cur_min", a),
            c.data("has_right_grip") && c.data("cur_max", b),
            c
        },
        set_position_from_px: function(a, b) {
            var c = this;
            k.set_handles_at_px.call(c, a, b);
            var d = k.getSliderValuesAtPositionPx.call(c, a, b)
              , e = d[0]
              , f = d[1];
            return c.data("cur_min", e),
            c.data("has_right_grip") && c.data("cur_max", f),
            c
        },
        set_handles_at_px: function(a, b) {
            var c = this
              , d = c.data("settings")
              , e = d.left_grip_selector
              , f = d.right_grip_selector
              , g = d.value_bar_selector
              , h = c.data("left_grip_width");
            return c.find(e).css("left", a + "px"),
            c.find(f).css("left", b + "px"),
            c.data("has_right_grip") ? c.find(g).css("left", a + "px").css("width", b - a + h + "px") : (j || k.populateNakedBarDeltas.call(c, a, b, h),
            b > a ? c.find(g).css("left", a + "px").css("width", b - a + j.toEndWidth + "px") : c.find(g).css("left", b + j.toBeginLeft + "px").css("width", a - b + j.toBeginWidth + "px")),
            c
        },
        drag_start_func_touch: function(a, b, c, e, f) {
            var g = this
              , h = a.originalEvent
              , i = h.touches[0]
              , j = i.pageY
              , l = i.pageX
              , m = Math.abs(g.offset().top - j)
              , n = g.offset().left
              , o = n - l
              , p = l - (n + g.width());
            m > b.touch_tolerance_value_bar_y || o > b.touch_tolerance_value_bar_x || p > b.touch_tolerance_value_bar_x || (h.preventDefault(),
            d = i.pageX,
            k.drag_start_func.call(g, i, b, c, e, f))
        },
        drag_start_func: function(d, f, g, h, i) {
            var j = this;
            if (j.find(f.left_grip_selector + "," + f.value_bar_selector + "," + f.right_grip_selector).removeClass(f.animating_css_class),
            l.is_enabled.call(j)) {
                var m = a(d.target)
                  , n = !1;
                if ("object" == typeof f.highlight && (n = m.is(f.highlight.panel_selector)),
                i !== !1 || m.is(f.left_grip_selector) || m.is(f.right_grip_selector) || m.is(f.value_bar_selector) || n || m.is(j)) {
                    b = j;
                    var o, p, q, r, s, t, u = k.getGripPositionPx.call(j, g), v = k.getSliderWidthPx.call(j) - j.data("left_grip_width"), w = g.offset().left, x = k.getRightGripPositionPx.call(j);
                    p = Math.round(d.pageX) - j.data("left_grip_width") / 2,
                    q = Math.abs(w - p),
                    s = p - w,
                    j.data("has_right_grip") ? (o = h.offset().left,
                    r = Math.abs(o - p),
                    t = p - o) : (r = 2 * q,
                    t = 2 * s),
                    f.user_drag_start_callback.call(j, d),
                    q === r ? w > p ? (u += s,
                    e = !0) : (x += t,
                    e = !1) : r > q ? (u += s,
                    e = !0) : (x += t,
                    e = !1),
                    j.data("has_right_grip") ? x > v && (x = v) : u > v && (u = v),
                    0 > u && (u = 0),
                    c = !0;
                    var y = j.data("cur_min")
                      , z = j.data("cur_max");
                    k.set_position_from_px.call(j, u, x),
                    k.refresh_grips_style.call(j),
                    k.notify_changed_implicit.call(j, "drag_start", y, z),
                    "[object Touch]" !== Object.prototype.toString.apply(d) && d.preventDefault()
                }
            }
        },
        drag_move_func_touch: function(a) {
            if (c === !0) {
                var b = a.originalEvent;
                b.preventDefault();
                var d = b.touches[0];
                k.drag_move_func(d)
            }
        },
        drag_move_func: function(a) {
            if (c) {
                var f = b
                  , g = f.data("settings")
                  , h = k.getSliderWidthPx.call(f) - f.data("left_grip_width")
                  , i = k.getLeftGripPositionPx.call(f)
                  , j = k.getRightGripPositionPx.call(f)
                  , l = Math.round(a.pageX)
                  , m = l - d
                  , n = f.data("left_grip_width") / 2
                  , o = f.offset().left + f.data("left_grip_width") - n
                  , p = o + h;
                g.crossable_handles === !1 && f.data("has_right_grip") && (e ? p = o + j : o += i);
                var q = 0
                  , r = 0;
                o > l && (q = 1,
                r = 0),
                l > p && (r = 1,
                q = 0),
                g.crossable_handles === !0 && f.data("has_right_grip") && (e ? h >= j && i + m > j && (e = !1,
                i = j) : i >= 0 && i > j + m && (e = !0,
                j = i));
                var s = i
                  , t = j;
                (m > 0 && !q || 0 > m && !r) && (e ? s += m : t += m),
                k.validateAndMoveGripsToPx.call(f, s, t),
                d = l,
                "[object Touch]" !== Object.prototype.toString.apply(a) && a.preventDefault()
            }
        },
        drag_end_func_touch: function(a) {
            var b = a.originalEvent;
            b.preventDefault();
            var c = b.touches[0];
            k.drag_end_func(c)
        },
        drag_end_func: function() {
            var a = b;
            if ("undefined" != typeof a) {
                c = !1,
                d = void 0,
                k.notify_mouse_up_implicit.call(a, e),
                b = void 0;
                var f = a.data("settings");
                a.find(f.left_grip_selector + "," + f.value_bar_selector + "," + f.right_grip_selector).addClass(f.animating_css_class)
            }
        },
        get_rounding_for_value: function(a) {
            var b = this
              , c = b.data("rounding")
              , d = b.data("rounding_ranges");
            if ("object" == typeof d) {
                var e = k.binarySearch.call(b, d, a, function(a, b) {
                    return a[b].range
                }, function(a, b, c) {
                    return a < b[c].range ? c > 0 ? a >= b[c - 1].range ? 0 : -1 : 0 : 1
                });
                if (c = 1,
                e > -1)
                    c = parseInt(d[e].value, 10);
                else {
                    var f = d.length - 1;
                    a >= d[f].range && (c = d[f].value)
                }
            }
            return c
        },
        notify_mouse_up_implicit: function(a) {
            var b = this
              , c = l.get_current_min_value.call(b)
              , d = l.get_current_max_value.call(b)
              , e = !1;
            (b.data("beforestart_min") !== c || b.data("beforestart_max") !== d) && (e = !0,
            b.data("beforestart_min", c),
            b.data("beforestart_max", d));
            var f = b.data("settings");
            return f.user_mouseup_callback.call(b, l.get_current_min_value.call(b), l.get_current_max_value.call(b), a, e),
            b
        },
        notify_changed_implicit: function(a, b, c) {
            var d = this
              , e = !1;
            ("init" === a || "refresh" === a) && (e = !0);
            var f = l.get_current_min_value.call(d)
              , g = l.get_current_max_value.call(d);
            return e || (b = l.round_value_according_to_rounding.call(d, b),
            c = l.round_value_according_to_rounding.call(d, c)),
            (e || f !== b || g !== c) && (k.notify_changed_explicit.call(d, a, b, c, f, g),
            e = 1),
            e
        },
        notify_changed_explicit: function(a, b, c, d, e) {
            var f = this
              , g = f.data("settings");
            return f.data("aria_enabled") && k.updateAriaAttributes.call(f),
            g.value_changed_callback.call(f, a, d, e, b, c),
            f
        },
        validate_params: function(b) {
            var c = this
              , d = c.data("range_min")
              , e = c.data("range_max")
              , f = c.data("cur_min")
              , g = c.data("lower-limit")
              , h = c.data("upper-limit")
              , i = k.haveLimits.call(c);
            "undefined" == typeof d && a.error("the data-range_min attribute was not defined"),
            "undefined" == typeof e && a.error("the data-range_max attribute was not defined"),
            "undefined" == typeof f && a.error("the data-cur_min attribute must be defined"),
            d > e && a.error("Invalid input parameter. must be min < max"),
            i && g > h && a.error("Invalid data-lower-limit or data-upper-limit"),
            0 === c.find(b.left_grip_selector).length && a.error("Cannot find element pointed by left_grip_selector: " + b.left_grip_selector),
            "undefined" != typeof b.right_grip_selector && 0 === c.find(b.right_grip_selector).length && a.error("Cannot find element pointed by right_grip_selector: " + b.right_grip_selector),
            "undefined" != typeof b.value_bar_selector && 0 === c.find(b.value_bar_selector).length && a.error("Cannot find element pointed by value_bar_selector" + b.value_bar_selector)
        },
        rangemap_0_to_n: function(a, b) {
            var c = this
              , d = c.data("range_min")
              , e = c.data("range_max");
            return d >= a ? 0 : a >= e ? b : Math.floor((b * a - b * d) / (e - d))
        },
        inverse_rangemap_0_to_n: function(a, b) {
            var c = this
              , d = c.data("range_min")
              , e = c.data("range_max");
            if (0 >= a)
                return d;
            if (a >= b)
                return e;
            var f = (e - d) * a / b;
            return f + d
        }
    }, l = {
        teardown: function() {
            var b = this;
            return b.removeData(),
            a(document).unbind("mousemove.nstSlider").unbind("mouseup.nstSlider"),
            b.parent().unbind("mousedown.nstSlider").unbind("touchstart.nstSlider").unbind("touchmove.nstSlider").unbind("touchend.nstSlider"),
            b.unbind("keydown.nstSlider").unbind("keyup.nstSlider"),
            b
        },
        init: function(b) {
            var c = a.extend({
                animating_css_class: "nst-animating",
                touch_tolerance_value_bar_y: 30,
                touch_tolerance_value_bar_x: 15,
                left_grip_selector: ".nst-slider-grip-left",
                right_grip_selector: void 0,
                highlight: void 0,
                rounding: void 0,
                value_bar_selector: void 0,
                crossable_handles: !0,
                value_changed_callback: function() {},
                user_mouseup_callback: function() {},
                user_drag_start_callback: function() {}
            }, b)
              , d = a(document);
            return d.unbind("mouseup.nstSlider"),
            d.unbind("mousemove.nstSlider"),
            d.bind("mousemove.nstSlider", k.drag_move_func),
            d.bind("mouseup.nstSlider", k.drag_end_func),
            this.each(function() {
                var b = a(this)
                  , d = b.parent();
                b.data("enabled", !0);
                var j = b.data("range_min")
                  , m = b.data("range_max")
                  , n = b.data("cur_min")
                  , o = b.data("cur_max");
                "undefined" == typeof o && (o = n),
                "" === j && (j = 0),
                "" === m && (m = 0),
                "" === n && (n = 0),
                "" === o && (o = 0),
                b.data("range_min", j),
                b.data("range_max", m),
                b.data("cur_min", n),
                b.data("cur_max", o),
                k.validate_params.call(b, c),
                b.data("settings", c),
                "undefined" != typeof c.rounding ? l.set_rounding.call(b, c.rounding) : "undefined" != typeof b.data("rounding") ? l.set_rounding.call(b, b.data("rounding")) : l.set_rounding.call(b, 1);
                var p = b.find(c.left_grip_selector)[0]
                  , q = a(p)
                  , r = a(b.find(c.right_grip_selector)[0]);
                "undefined" == typeof q.attr("tabindex") && q.attr("tabindex", 0);
                var s = !1;
                b.find(c.right_grip_selector).length > 0 && (s = !0,
                "undefined" == typeof r.attr("tabindex") && r.attr("tabindex", 0)),
                b.data("has_right_grip", s),
                b.data("aria_enabled") === !0 && (q.attr("role", "slider").attr("aria-disabled", "false"),
                s && r.attr("role", "slider").attr("aria-disabled", "false")),
                b.bind("keyup.nstSlider", function(a) {
                    if (b.data("enabled")) {
                        switch (a.which) {
                        case 37:
                        case 38:
                        case 39:
                        case 40:
                            if (f === h) {
                                var c, d, j, m = k.getSliderWidthPx.call(b);
                                if (0 > g - i) {
                                    for (d = i; m >= d; d++)
                                        if (c = l.round_value_according_to_rounding.call(b, k.getSliderValuesAtPositionPx.call(b, d, d)[1]),
                                        c !== h) {
                                            j = d;
                                            break
                                        }
                                } else
                                    for (d = i; d >= 0; d--)
                                        if (c = l.round_value_according_to_rounding.call(b, k.getSliderValuesAtPositionPx.call(b, d, d)[1]),
                                        c !== h) {
                                            j = d;
                                            break
                                        }
                                e ? k.validateAndMoveGripsToPx.call(b, j, k.getRightGripPositionPx.call(b)) : k.validateAndMoveGripsToPx.call(b, k.getLeftGripPositionPx.call(b), j),
                                k.notify_mouse_up_implicit.call(b, e)
                            }
                        }
                        f = void 0,
                        g = void 0,
                        h = void 0,
                        i = void 0
                    }
                }),
                b.bind("keydown.nstSlider", function(a) {
                    if (b.data("enabled")) {
                        var c = function(a, c) {
                            var d = k.getLeftGripPositionPx.call(b)
                              , j = k.getRightGripPositionPx.call(b);
                            switch ("undefined" == typeof f && (g = e ? d : j,
                            f = e ? l.get_current_min_value.call(b) : l.get_current_max_value.call(b)),
                            c.which) {
                            case 37:
                            case 40:
                                e ? d-- : j--,
                                c.preventDefault();
                                break;
                            case 38:
                            case 39:
                                e ? d++ : j++,
                                c.preventDefault()
                            }
                            i = e ? d : j,
                            k.validateAndMoveGripsToPx.call(b, d, j),
                            h = e ? l.get_current_min_value.call(b) : l.get_current_max_value.call(b)
                        };
                        s && b.find(":focus").is(r) ? (e = !1,
                        c.call(b, r, a)) : (e = !0,
                        c.call(b, q, a))
                    }
                });
                var t = k.getLeftGripWidth.call(b)
                  , u = s ? k.getRightGripWidth.call(b) : t;
                if (b.data("left_grip_width", t),
                b.data("right_grip_width", u),
                b.data("value_bar_selector", c.value_bar_selector),
                !s) {
                    var v = o === m || o === j;
                    k.setNakedBarDelta.call(b, v ? "stickToSides" : "middle", t)
                }
                j === m || n === o ? l.set_range.call(b, j, m) : k.set_position_from_val.call(b, b.data("cur_min"), b.data("cur_max")),
                k.notify_changed_implicit.call(b, "init"),
                b.data("beforestart_min", l.get_current_min_value.call(b)),
                b.data("beforestart_max", l.get_current_max_value.call(b)),
                b.bind("mousedown.nstSlider", function(a) {
                    k.drag_start_func.call(b, a, c, q, r, !1)
                }),
                d.bind("touchstart.nstSlider", function(a) {
                    k.drag_start_func_touch.call(b, a, c, q, r, !0)
                }),
                d.bind("touchend.nstSlider", function(a) {
                    k.drag_end_func_touch.call(b, a)
                }),
                d.bind("touchmove.nstSlider", function(a) {
                    k.drag_move_func_touch.call(b, a)
                });
                var w = b.data("histogram");
                "undefined" != typeof w && l.set_step_histogram.call(b, w)
            })
        },
        get_range_min: function() {
            var a = this;
            return a.data("range_min")
        },
        get_range_max: function() {
            var a = this;
            return a.data("range_max")
        },
        get_current_min_value: function() {
            var b, c = a(this), d = l.get_range_min.call(c), e = l.get_range_max.call(c), f = c.data("cur_min");
            if (b = d >= f ? d : l.round_value_according_to_rounding.call(c, f),
            k.haveLimits.call(c)) {
                if (d >= b)
                    return c.data("lower-limit");
                if (b >= e)
                    return c.data("upper-limit")
            } else {
                if (d >= b)
                    return d;
                if (b >= e)
                    return e
            }
            return b
        },
        get_current_max_value: function() {
            var b, c = a(this), d = l.get_range_min.call(c), e = l.get_range_max.call(c), f = c.data("cur_max");
            if (b = f >= e ? e : l.round_value_according_to_rounding.call(c, f),
            k.haveLimits.call(c)) {
                if (b >= e)
                    return c.data("upper-limit");
                if (d >= b)
                    return c.data("lower-limit")
            } else {
                if (b >= e)
                    return e;
                if (d >= b)
                    return d
            }
            return b
        },
        is_handle_to_left_extreme: function() {
            var a = this;
            return k.haveLimits.call(a) ? a.data("lower-limit") === l.get_current_min_value.call(a) : l.get_range_min.call(a) === l.get_current_min_value.call(a)
        },
        is_handle_to_right_extreme: function() {
            var a = this;
            return k.haveLimits.call(a) ? a.data("upper-limit") === l.get_current_max_value.call(a) : l.get_range_max.call(a) === l.get_current_max_value.call(a)
        },
        refresh: function() {
            var a = this
              , b = a.data("last_step_histogram");
            "undefined" != typeof b && l.set_step_histogram.call(a, b),
            k.set_position_from_val.call(a, l.get_current_min_value.call(a), l.get_current_max_value.call(a));
            var c = a.data("highlightedRangeMin");
            if ("number" == typeof c) {
                var d = a.data("highlightedRangeMax");
                l.highlight_range.call(a, c, d)
            }
            return k.notify_changed_implicit.call(a, "refresh"),
            a
        },
        disable: function() {
            var a = this
              , b = a.data("settings");
            return a.data("enabled", !1).find(b.left_grip_selector).attr("aria-disabled", "true").end().find(b.right_grip_selector).attr("aria-disabled", "true"),
            a
        },
        enable: function() {
            var a = this
              , b = a.data("settings");
            return a.data("enabled", !0).find(b.left_grip_selector).attr("aria-disabled", "false").end().find(b.right_grip_selector).attr("aria-disabled", "false"),
            a
        },
        is_enabled: function() {
            var a = this;
            return a.data("enabled")
        },
        set_position: function(a, b) {
            var c = this
              , d = c.data("cur_min")
              , e = c.data("cur_max");
            a > b ? k.set_position_from_val.call(c, b, a) : k.set_position_from_val.call(c, a, b),
            k.refresh_grips_style.call(c),
            k.notify_changed_implicit.call(c, "set_position", d, e),
            c.data("beforestart_min", a),
            c.data("beforestart_max", b)
        },
        set_step_histogram: function(b) {
            var c = this;
            c.data("last_step_histogram", b),
            "undefined" == typeof b && (a.error("got an undefined histogram in set_step_histogram"),
            k.unset_step_histogram.call(c));
            var d = k.getSliderWidthPx.call(c) - c.data("left_grip_width")
              , e = b.length;
            if (!(0 >= d)) {
                var f, g = 0;
                for (f = 0; e > f; f++)
                    g += b[f];
                if (0 === g)
                    return l.unset_step_histogram.call(c),
                    c;
                var h = parseFloat(g) / d;
                for (f = 0; e > f; f++)
                    b[f] = b[f] / h;
                var i = [b[0]];
                for (f = 1; e > f; f++) {
                    var j = i[f - 1] + b[f];
                    i.push(j)
                }
                i.push(d);
                for (var m = [c.data("range_min")], n = 0, o = m[0], p = 0; d >= n; ) {
                    var q = parseInt(i.shift(), 10)
                      , r = k.inverse_rangemap_0_to_n.call(c, p + 1, e + 1);
                    p++;
                    var s = q - n
                      , t = r - o;
                    for (f = n; q > f; f++) {
                        var u = o + t * (f - n + 1) / s;
                        m.push(u),
                        n++,
                        o = u
                    }
                    if (n === d)
                        break
                }
                m[m.length - 1] = c.data("range_max");
                var v = function(a) {
                    return m[parseInt(a, 10)]
                }
                  , w = function(a) {
                    var b = k.binarySearch.call(c, m, a, function(a, b) {
                        return a[b]
                    }, k.binarySearchValueToPxCompareFunc);
                    return m[b] === a ? b : Math.abs(m[b - 1] - a) < Math.abs(m[b] - a) ? b - 1 : b
                };
                return c.data("pixel_to_value_mapping", v),
                c.data("value_to_pixel_mapping", w),
                c
            }
        },
        unset_step_histogram: function() {
            var a = this;
            return a.removeData("pixel_to_value_mapping"),
            a.removeData("value_to_pixel_mapping"),
            a.removeData("last_step_histogram"),
            a
        },
        set_range: function(a, b) {
            var c = this
              , d = l.get_current_min_value.call(c)
              , e = l.get_current_max_value.call(c);
            return c.data("range_min", a),
            c.data("range_max", b),
            k.set_position_from_val.call(c, d, e),
            k.notify_changed_implicit.call(c, "set_range", d, e),
            c
        },
        highlight_range: function(b, c) {
            var d = this
              , e = d.data("settings");
            "undefined" == typeof e.highlight && a.error('you cannot call highlight_range if you haven\' specified the "highlight" parameter in construction!'),
            b || (b = 0),
            c || (c = 0);
            var f = l.value_to_px.call(d, b)
              , g = l.value_to_px.call(d, c)
              , h = g - f + d.data("left_grip_width")
              , i = d.find(e.highlight.panel_selector);
            return i.css("left", f + "px"),
            i.css("width", h + "px"),
            d.data("highlightedRangeMin", b),
            d.data("highlightedRangeMax", c),
            k.refresh_grips_style.call(d),
            d
        },
        set_rounding: function(b) {
            var c = this;
            "string" == typeof b && b.indexOf("{") > -1 && (b = a.parseJSON(b)),
            c.data("rounding", b);
            var d = [];
            if ("object" == typeof b) {
                var e;
                for (e in b)
                    if (b.hasOwnProperty(e)) {
                        var f = b[e];
                        d.push({
                            range: f,
                            value: e
                        })
                    }
                d.sort(function(a, b) {
                    return a.range - b.range
                }),
                c.data("rounding_ranges", d)
            } else
                c.removeData("rounding_ranges");
            return c
        },
        get_rounding: function() {
            var a = this;
            return a.data("rounding")
        },
        round_value_according_to_rounding: function(b) {
            var c = this
              , d = k.get_rounding_for_value.call(c, b);
            if (d > 0) {
                var e = b / d
                  , f = parseInt(e, 10)
                  , g = e - f;
                g > .5 && f++;
                var h = f * d;
                return h
            }
            return a.error("rounding must be > 0, got " + d + " instead"),
            b
        },
        value_to_px: function(a) {
            var b = this
              , c = b.data("value_to_pixel_mapping");
            if ("undefined" != typeof c)
                return c(a);
            var d = k.getSliderWidthPx.call(b) - b.data("left_grip_width");
            return k.rangemap_0_to_n.call(b, a, d)
        }
    }, m = "nstSlider";
    a.fn[m] = function(b) {
        if (l[b]) {
            if (this.data("initialized") === !0)
                return l[b].apply(this, Array.prototype.slice.call(arguments, 1));
            throw new Error("method " + b + " called on an uninitialized instance of " + m)
        }
        return "object" != typeof b && b ? void a.error("Cannot call method " + b) : (this.data("initialized", !0),
        l.init.apply(this, arguments))
    }
}(jQuery);

/*  jQuery Nice Select - v1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */
!function(e) {
    e.fn.niceSelect = function(t) {
        function s(t) {
            t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class") || "").addClass(t.attr("disabled") ? "disabled" : "").attr("tabindex", t.attr("disabled") ? null : "0").html('<span class="current"></span><ul class="list"></ul>'));
            var s = t.next()
              , n = t.find("option")
              , i = t.find("option:selected");
            s.find(".current").html(i.data("display") || i.text()),
            n.each(function(t) {
                var n = e(this)
                  , i = n.data("display");
                s.find("ul").append(e("<li></li>").attr("data-value", n.val()).attr("data-display", i || null).addClass("option" + (n.is(":selected") ? " selected" : "") + (n.is(":disabled") ? " disabled" : "")).html(n.text()))
            })
        }
        if ("string" == typeof t)
            return "update" == t ? this.each(function() {
                var t = e(this)
                  , n = e(this).next(".nice-select")
                  , i = n.hasClass("open");
                n.length && (n.remove(),
                s(t),
                i && t.next().trigger("click"))
            }) : "destroy" == t ? (this.each(function() {
                var t = e(this)
                  , s = e(this).next(".nice-select");
                s.length && (s.remove(),
                t.css("display", ""))
            }),
            0 == e(".nice-select").length && e(document).off(".nice_select")) : console.log('Method "' + t + '" does not exist.'),
            this;
        this.hide(),
        this.each(function() {
            var t = e(this);
            t.next().hasClass("nice-select") || s(t)
        }),
        e(document).off(".nice_select"),
        e(document).on("click.nice_select", ".nice-select", function(t) {
            var s = e(this);
            e(".nice-select").not(s).removeClass("open"),
            s.toggleClass("open"),
            s.hasClass("open") ? (s.find(".option"),
            s.find(".focus").removeClass("focus"),
            s.find(".selected").addClass("focus")) : s.focus()
        }),
        e(document).on("click.nice_select", function(t) {
            0 === e(t.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option")
        }),
        e(document).on("click.nice_select", ".nice-select .option:not(.disabled)", function(t) {
            var s = e(this)
              , n = s.closest(".nice-select");
            n.find(".selected").removeClass("selected"),
            s.addClass("selected");
            var i = s.data("display") || s.text();
            n.find(".current").text(i),
            n.prev("select").val(s.data("value")).trigger("change")
        }),
        e(document).on("keydown.nice_select", ".nice-select", function(t) {
            var s = e(this)
              , n = e(s.find(".focus") || s.find(".list .option.selected"));
            if (32 == t.keyCode || 13 == t.keyCode)
                return s.hasClass("open") ? n.trigger("click") : s.trigger("click"),
                !1;
            if (40 == t.keyCode) {
                if (s.hasClass("open")) {
                    var i = n.nextAll(".option:not(.disabled)").first();
                    i.length > 0 && (s.find(".focus").removeClass("focus"),
                    i.addClass("focus"))
                } else
                    s.trigger("click");
                return !1
            }
            if (38 == t.keyCode) {
                if (s.hasClass("open")) {
                    var l = n.prevAll(".option:not(.disabled)").first();
                    l.length > 0 && (s.find(".focus").removeClass("focus"),
                    l.addClass("focus"))
                } else
                    s.trigger("click");
                return !1
            }
            if (27 == t.keyCode)
                s.hasClass("open") && s.trigger("click");
            else if (9 == t.keyCode && s.hasClass("open"))
                return !1
        });
        var n = document.createElement("a").style;
        return n.cssText = "pointer-events:auto",
        "auto" !== n.pointerEvents && e("html").addClass("no-csspointerevents"),
        this
    }
}(jQuery);

/*
 *	jQuery elevateZoom 3.0.3
 *	Demo's and documentation:
 *	www.elevateweb.co.uk/image-zoom
 *
 *	Copyright (c) 2012 Andrew Eades
 *	www.elevateweb.co.uk
 *
 *	Dual licensed under the GPL and MIT licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */
"function" != typeof Object.create && (Object.create = function(o) {
    function e() {}
    return e.prototype = o,
    new e
}
),
function(o, e, i, t) {
    var n = {
        init: function(e, i) {
            var t = this;
            t.elem = i,
            t.$elem = o(i),
            t.imageSrc = t.$elem.data("zoom-image") ? t.$elem.data("zoom-image") : t.$elem.attr("src"),
            t.options = o.extend({}, o.fn.elevateZoom.options, e),
            t.options.tint && (t.options.lensColour = "none",
            t.options.lensOpacity = "1"),
            "inner" == t.options.zoomType && (t.options.showLens = !1),
            t.$elem.parent().removeAttr("title").removeAttr("alt"),
            t.zoomImage = t.imageSrc,
            t.refresh(1),
            o("#" + t.options.gallery + " a").click(function(e) {
                return t.options.galleryActiveClass && (o("#" + t.options.gallery + " a").removeClass(t.options.galleryActiveClass),
                o(this).addClass(t.options.galleryActiveClass)),
                e.preventDefault(),
                o(this).data("zoom-image") ? t.zoomImagePre = o(this).data("zoom-image") : t.zoomImagePre = o(this).data("image"),
                t.swaptheimage(o(this).data("image"), t.zoomImagePre),
                !1
            })
        },
        refresh: function(o) {
            var e = this;
            setTimeout(function() {
                e.fetch(e.imageSrc)
            }, o || e.options.refresh)
        },
        fetch: function(o) {
            var e = this
              , i = new Image;
            i.onload = function() {
                e.largeWidth = i.width,
                e.largeHeight = i.height,
                e.startZoom(),
                e.currentImage = e.imageSrc,
                e.options.onZoomedImageLoaded(e.$elem)
            }
            ,
            i.src = o
        },
        startZoom: function() {
            var e = this;
            if (e.nzWidth = e.$elem.width(),
            e.nzHeight = e.$elem.height(),
            e.isWindowActive = !1,
            e.isLensActive = !1,
            e.isTintActive = !1,
            e.overWindow = !1,
            e.options.imageCrossfade && (e.zoomWrap = e.$elem.wrap('<div style="height:' + e.nzHeight + "px;width:" + e.nzWidth + 'px;" class="zoomWrapper" />'),
            e.$elem.css("position", "absolute")),
            e.zoomLock = 1,
            e.scrollingLock = !1,
            e.changeBgSize = !1,
            e.currentZoomLevel = e.options.zoomLevel,
            e.nzOffset = e.$elem.offset(),
            e.widthRatio = e.largeWidth / e.currentZoomLevel / e.nzWidth,
            e.heightRatio = e.largeHeight / e.currentZoomLevel / e.nzHeight,
            "window" == e.options.zoomType && (e.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " + String(e.options.zoomWindowBgColour) + ";width: " + String(e.options.zoomWindowWidth) + "px;height: " + String(e.options.zoomWindowHeight) + "px;float: left;background-size: " + e.largeWidth / e.currentZoomLevel + "px " + e.largeHeight / e.currentZoomLevel + "px;display: none;z-index:100;border: " + String(e.options.borderSize) + "px solid " + e.options.borderColour + ";background-repeat: no-repeat;position: absolute;"),
            "inner" == e.options.zoomType) {
                var i = e.$elem.css("border-left-width");
                e.zoomWindowStyle = "overflow: hidden;margin-left: " + String(i) + ";margin-top: " + String(i) + ";background-position: 0px 0px;width: " + String(e.nzWidth) + "px;height: " + String(e.nzHeight) + "px;px;float: left;display: none;cursor:" + e.options.cursor + ";px solid " + e.options.borderColour + ";background-repeat: no-repeat;position: absolute;"
            }
            "window" == e.options.zoomType && (e.nzHeight < e.options.zoomWindowWidth / e.widthRatio ? lensHeight = e.nzHeight : lensHeight = String(e.options.zoomWindowHeight / e.heightRatio),
            e.largeWidth < e.options.zoomWindowWidth ? lensWidth = e.nzWidth : lensWidth = e.options.zoomWindowWidth / e.widthRatio,
            e.lensStyle = "background-position: 0px 0px;width: " + String(e.options.zoomWindowWidth / e.widthRatio) + "px;height: " + String(e.options.zoomWindowHeight / e.heightRatio) + "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" + e.options.lensOpacity + ";filter: alpha(opacity = " + 100 * e.options.lensOpacity + "); zoom:1;width:" + lensWidth + "px;height:" + lensHeight + "px;background-color:" + e.options.lensColour + ";cursor:" + e.options.cursor + ";border: " + e.options.lensBorderSize + "px solid " + e.options.lensBorderColour + ";background-repeat: no-repeat;position: absolute;"),
            e.tintStyle = "display: block;position: absolute;background-color: " + e.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + e.nzWidth + "px;height: " + e.nzHeight + "px;",
            e.lensRound = "",
            "lens" == e.options.zoomType && (e.lensStyle = "background-position: 0px 0px;float: left;display: none;border: " + String(e.options.borderSize) + "px solid " + e.options.borderColour + ";width:" + String(e.options.lensSize) + "px;height:" + String(e.options.lensSize) + "px;background-repeat: no-repeat;position: absolute;"),
            "round" == e.options.lensShape && (e.lensRound = "border-top-left-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;border-top-right-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;border-bottom-left-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;border-bottom-right-radius: " + String(e.options.lensSize / 2 + e.options.borderSize) + "px;"),
            e.zoomContainer = o('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' + e.nzOffset.left + "px;top:" + e.nzOffset.top + "px;height:" + e.nzHeight + "px;width:" + e.nzWidth + 'px;"></div>'),
            o("body").append(e.zoomContainer),
            e.options.containLensZoom && "lens" == e.options.zoomType && e.zoomContainer.css("overflow", "hidden"),
            "inner" != e.options.zoomType && (e.zoomLens = o("<div class='zoomLens' style='" + e.lensStyle + e.lensRound + "'>&nbsp;</div>").appendTo(e.zoomContainer).click(function() {
                e.$elem.trigger("click")
            }),
            e.options.tint && (e.tintContainer = o("<div/>").addClass("tintContainer"),
            e.zoomTint = o("<div class='zoomTint' style='" + e.tintStyle + "'></div>"),
            e.zoomLens.wrap(e.tintContainer),
            e.zoomTintcss = e.zoomLens.after(e.zoomTint),
            e.zoomTintImage = o('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + e.nzWidth + "px; height: " + e.nzHeight + 'px;" src="' + e.imageSrc + '">').appendTo(e.zoomLens).click(function() {
                e.$elem.trigger("click")
            }))),
            isNaN(e.options.zoomWindowPosition) ? e.zoomWindow = o("<div style='z-index:999;left:" + e.windowOffsetLeft + "px;top:" + e.windowOffsetTop + "px;" + e.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function() {
                e.$elem.trigger("click")
            }) : e.zoomWindow = o("<div style='z-index:999;left:" + e.windowOffsetLeft + "px;top:" + e.windowOffsetTop + "px;" + e.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(e.zoomContainer).click(function() {
                e.$elem.trigger("click")
            }),
            e.zoomWindowContainer = o("<div/>").addClass("zoomWindowContainer").css("width", e.options.zoomWindowWidth),
            e.zoomWindow.wrap(e.zoomWindowContainer),
            "lens" == e.options.zoomType && e.zoomLens.css({
                backgroundImage: "url('" + e.imageSrc + "')"
            }),
            "window" == e.options.zoomType && e.zoomWindow.css({
                backgroundImage: "url('" + e.imageSrc + "')"
            }),
            "inner" == e.options.zoomType && e.zoomWindow.css({
                backgroundImage: "url('" + e.imageSrc + "')"
            }),
            e.$elem.bind("touchmove", function(o) {
                o.preventDefault();
                var i = o.originalEvent.touches[0] || o.originalEvent.changedTouches[0];
                e.setPosition(i)
            }),
            e.zoomContainer.bind("touchmove", function(o) {
                "inner" == e.options.zoomType && e.showHideWindow("show"),
                o.preventDefault();
                var i = o.originalEvent.touches[0] || o.originalEvent.changedTouches[0];
                e.setPosition(i)
            }),
            e.zoomContainer.bind("touchend", function(o) {
                e.showHideWindow("hide"),
                e.options.showLens && e.showHideLens("hide"),
                e.options.tint && "inner" != e.options.zoomType && e.showHideTint("hide")
            }),
            e.$elem.bind("touchend", function(o) {
                e.showHideWindow("hide"),
                e.options.showLens && e.showHideLens("hide"),
                e.options.tint && "inner" != e.options.zoomType && e.showHideTint("hide")
            }),
            e.options.showLens && (e.zoomLens.bind("touchmove", function(o) {
                o.preventDefault();
                var i = o.originalEvent.touches[0] || o.originalEvent.changedTouches[0];
                e.setPosition(i)
            }),
            e.zoomLens.bind("touchend", function(o) {
                e.showHideWindow("hide"),
                e.options.showLens && e.showHideLens("hide"),
                e.options.tint && "inner" != e.options.zoomType && e.showHideTint("hide")
            })),
            e.$elem.bind("mousemove", function(o) {
                0 == e.overWindow && e.setElements("show"),
                e.lastX === o.clientX && e.lastY === o.clientY || (e.setPosition(o),
                e.currentLoc = o),
                e.lastX = o.clientX,
                e.lastY = o.clientY
            }),
            e.zoomContainer.bind("mousemove", function(o) {
                0 == e.overWindow && e.setElements("show"),
                e.lastX === o.clientX && e.lastY === o.clientY || (e.setPosition(o),
                e.currentLoc = o),
                e.lastX = o.clientX,
                e.lastY = o.clientY
            }),
            "inner" != e.options.zoomType && e.zoomLens.bind("mousemove", function(o) {
                e.lastX === o.clientX && e.lastY === o.clientY || (e.setPosition(o),
                e.currentLoc = o),
                e.lastX = o.clientX,
                e.lastY = o.clientY
            }),
            e.options.tint && "inner" != e.options.zoomType && e.zoomTint.bind("mousemove", function(o) {
                e.lastX === o.clientX && e.lastY === o.clientY || (e.setPosition(o),
                e.currentLoc = o),
                e.lastX = o.clientX,
                e.lastY = o.clientY
            }),
            "inner" == e.options.zoomType && e.zoomWindow.bind("mousemove", function(o) {
                e.lastX === o.clientX && e.lastY === o.clientY || (e.setPosition(o),
                e.currentLoc = o),
                e.lastX = o.clientX,
                e.lastY = o.clientY
            }),
            e.zoomContainer.add(e.$elem).mouseenter(function() {
                0 == e.overWindow && e.setElements("show")
            }).mouseleave(function() {
                e.scrollLock || (e.setElements("hide"),
                e.options.onDestroy(e.$elem))
            }),
            "inner" != e.options.zoomType && e.zoomWindow.mouseenter(function() {
                e.overWindow = !0,
                e.setElements("hide")
            }).mouseleave(function() {
                e.overWindow = !1
            }),
            1 != e.options.zoomLevel,
            e.options.minZoomLevel ? e.minZoomLevel = e.options.minZoomLevel : e.minZoomLevel = 2 * e.options.scrollZoomIncrement,
            e.options.scrollZoom && e.zoomContainer.add(e.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function(i) {
                e.scrollLock = !0,
                clearTimeout(o.data(this, "timer")),
                o.data(this, "timer", setTimeout(function() {
                    e.scrollLock = !1
                }, 250));
                var t = i.originalEvent.wheelDelta || i.originalEvent.detail * -1;
                return i.stopImmediatePropagation(),
                i.stopPropagation(),
                i.preventDefault(),
                t / 120 > 0 ? e.currentZoomLevel >= e.minZoomLevel && e.changeZoomLevel(e.currentZoomLevel - e.options.scrollZoomIncrement) : e.options.maxZoomLevel ? e.currentZoomLevel <= e.options.maxZoomLevel && e.changeZoomLevel(parseFloat(e.currentZoomLevel) + e.options.scrollZoomIncrement) : e.changeZoomLevel(parseFloat(e.currentZoomLevel) + e.options.scrollZoomIncrement),
                !1
            })
        },
        setElements: function(o) {
            var e = this;
            return !!e.options.zoomEnabled && ("show" == o && e.isWindowSet && ("inner" == e.options.zoomType && e.showHideWindow("show"),
            "window" == e.options.zoomType && e.showHideWindow("show"),
            e.options.showLens && e.showHideLens("show"),
            e.options.tint && "inner" != e.options.zoomType && e.showHideTint("show")),
            void ("hide" == o && ("window" == e.options.zoomType && e.showHideWindow("hide"),
            e.options.tint || e.showHideWindow("hide"),
            e.options.showLens && e.showHideLens("hide"),
            e.options.tint && e.showHideTint("hide"))))
        },
        setPosition: function(o) {
            var e = this;
            return !!e.options.zoomEnabled && (e.nzHeight = e.$elem.height(),
            e.nzWidth = e.$elem.width(),
            e.nzOffset = e.$elem.offset(),
            e.options.tint && "inner" != e.options.zoomType && (e.zoomTint.css({
                top: 0
            }),
            e.zoomTint.css({
                left: 0
            })),
            e.options.responsive && !e.options.scrollZoom && e.options.showLens && (e.nzHeight < e.options.zoomWindowWidth / e.widthRatio ? lensHeight = e.nzHeight : lensHeight = String(e.options.zoomWindowHeight / e.heightRatio),
            e.largeWidth < e.options.zoomWindowWidth ? lensWidth = e.nzWidth : lensWidth = e.options.zoomWindowWidth / e.widthRatio,
            e.widthRatio = e.largeWidth / e.nzWidth,
            e.heightRatio = e.largeHeight / e.nzHeight,
            "lens" != e.options.zoomType && (e.nzHeight < e.options.zoomWindowWidth / e.widthRatio ? lensHeight = e.nzHeight : lensHeight = String(e.options.zoomWindowHeight / e.heightRatio),
            e.nzWidth < e.options.zoomWindowHeight / e.heightRatio ? lensWidth = e.nzWidth : lensWidth = String(e.options.zoomWindowWidth / e.widthRatio),
            e.zoomLens.css("width", lensWidth),
            e.zoomLens.css("height", lensHeight),
            e.options.tint && (e.zoomTintImage.css("width", e.nzWidth),
            e.zoomTintImage.css("height", e.nzHeight))),
            "lens" == e.options.zoomType && e.zoomLens.css({
                width: String(e.options.lensSize) + "px",
                height: String(e.options.lensSize) + "px"
            })),
            e.zoomContainer.css({
                top: e.nzOffset.top
            }),
            e.zoomContainer.css({
                left: e.nzOffset.left
            }),
            e.mouseLeft = parseInt(o.pageX - e.nzOffset.left),
            e.mouseTop = parseInt(o.pageY - e.nzOffset.top),
            "window" == e.options.zoomType && (e.Etoppos = e.mouseTop < e.zoomLens.height() / 2,
            e.Eboppos = e.mouseTop > e.nzHeight - e.zoomLens.height() / 2 - 2 * e.options.lensBorderSize,
            e.Eloppos = e.mouseLeft < 0 + e.zoomLens.width() / 2,
            e.Eroppos = e.mouseLeft > e.nzWidth - e.zoomLens.width() / 2 - 2 * e.options.lensBorderSize),
            "inner" == e.options.zoomType && (e.Etoppos = e.mouseTop < e.nzHeight / 2 / e.heightRatio,
            e.Eboppos = e.mouseTop > e.nzHeight - e.nzHeight / 2 / e.heightRatio,
            e.Eloppos = e.mouseLeft < 0 + e.nzWidth / 2 / e.widthRatio,
            e.Eroppos = e.mouseLeft > e.nzWidth - e.nzWidth / 2 / e.widthRatio - 2 * e.options.lensBorderSize),
            e.mouseLeft < 0 || e.mouseTop < 0 || e.mouseLeft > e.nzWidth || e.mouseTop > e.nzHeight ? void e.setElements("hide") : (e.options.showLens && (e.lensLeftPos = String(Math.floor(e.mouseLeft - e.zoomLens.width() / 2)),
            e.lensTopPos = String(Math.floor(e.mouseTop - e.zoomLens.height() / 2))),
            e.Etoppos && (e.lensTopPos = 0),
            e.Eloppos && (e.windowLeftPos = 0,
            e.lensLeftPos = 0,
            e.tintpos = 0),
            "window" == e.options.zoomType && (e.Eboppos && (e.lensTopPos = Math.max(e.nzHeight - e.zoomLens.height() - 2 * e.options.lensBorderSize, 0)),
            e.Eroppos && (e.lensLeftPos = e.nzWidth - e.zoomLens.width() - 2 * e.options.lensBorderSize)),
            "inner" == e.options.zoomType && (e.Eboppos && (e.lensTopPos = Math.max(e.nzHeight - 2 * e.options.lensBorderSize, 0)),
            e.Eroppos && (e.lensLeftPos = e.nzWidth - e.nzWidth - 2 * e.options.lensBorderSize)),
            "lens" == e.options.zoomType && (e.windowLeftPos = String(((o.pageX - e.nzOffset.left) * e.widthRatio - e.zoomLens.width() / 2) * -1),
            e.windowTopPos = String(((o.pageY - e.nzOffset.top) * e.heightRatio - e.zoomLens.height() / 2) * -1),
            e.zoomLens.css({
                backgroundPosition: e.windowLeftPos + "px " + e.windowTopPos + "px"
            }),
            e.changeBgSize && (e.nzHeight > e.nzWidth ? ("lens" == e.options.zoomType && e.zoomLens.css({
                "background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"
            }),
            e.zoomWindow.css({
                "background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"
            })) : ("lens" == e.options.zoomType && e.zoomLens.css({
                "background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"
            }),
            e.zoomWindow.css({
                "background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"
            })),
            e.changeBgSize = !1),
            e.setWindowPostition(o)),
            e.options.tint && "inner" != e.options.zoomType && e.setTintPosition(o),
            "window" == e.options.zoomType && e.setWindowPostition(o),
            "inner" == e.options.zoomType && e.setWindowPostition(o),
            e.options.showLens && (e.fullwidth && "lens" != e.options.zoomType && (e.lensLeftPos = 0),
            e.zoomLens.css({
                left: e.lensLeftPos + "px",
                top: e.lensTopPos + "px"
            })),
            void 0))
        },
        showHideWindow: function(o) {
            var e = this;
            "show" == o && (e.isWindowActive || (e.options.zoomWindowFadeIn ? e.zoomWindow.stop(!0, !0, !1).fadeIn(e.options.zoomWindowFadeIn) : e.zoomWindow.show(),
            e.isWindowActive = !0)),
            "hide" == o && e.isWindowActive && (e.options.zoomWindowFadeOut ? e.zoomWindow.stop(!0, !0).fadeOut(e.options.zoomWindowFadeOut, function() {
                e.loop && (clearInterval(e.loop),
                e.loop = !1)
            }) : e.zoomWindow.hide(),
            e.isWindowActive = !1)
        },
        showHideLens: function(o) {
            var e = this;
            "show" == o && (e.isLensActive || (e.options.lensFadeIn ? e.zoomLens.stop(!0, !0, !1).fadeIn(e.options.lensFadeIn) : e.zoomLens.show(),
            e.isLensActive = !0)),
            "hide" == o && e.isLensActive && (e.options.lensFadeOut ? e.zoomLens.stop(!0, !0).fadeOut(e.options.lensFadeOut) : e.zoomLens.hide(),
            e.isLensActive = !1)
        },
        showHideTint: function(o) {
            var e = this;
            "show" == o && (e.isTintActive || (e.options.zoomTintFadeIn ? e.zoomTint.css({
                opacity: e.options.tintOpacity
            }).animate().stop(!0, !0).fadeIn("slow") : (e.zoomTint.css({
                opacity: e.options.tintOpacity
            }).animate(),
            e.zoomTint.show()),
            e.isTintActive = !0)),
            "hide" == o && e.isTintActive && (e.options.zoomTintFadeOut ? e.zoomTint.stop(!0, !0).fadeOut(e.options.zoomTintFadeOut) : e.zoomTint.hide(),
            e.isTintActive = !1)
        },
        setLensPostition: function(o) {},
        setWindowPostition: function(e) {
            var i = this;
            if (isNaN(i.options.zoomWindowPosition))
                i.externalContainer = o("#" + i.options.zoomWindowPosition),
                i.externalContainerWidth = i.externalContainer.width(),
                i.externalContainerHeight = i.externalContainer.height(),
                i.externalContainerOffset = i.externalContainer.offset(),
                i.windowOffsetTop = i.externalContainerOffset.top,
                i.windowOffsetLeft = i.externalContainerOffset.left;
            else
                switch (i.options.zoomWindowPosition) {
                case 1:
                    i.windowOffsetTop = i.options.zoomWindowOffety,
                    i.windowOffsetLeft = +i.nzWidth;
                    break;
                case 2:
                    i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = (i.options.zoomWindowHeight / 2 - i.nzHeight / 2) * -1,
                    i.windowOffsetLeft = i.nzWidth);
                    break;
                case 3:
                    i.windowOffsetTop = i.nzHeight - i.zoomWindow.height() - 2 * i.options.borderSize,
                    i.windowOffsetLeft = i.nzWidth;
                    break;
                case 4:
                    i.windowOffsetTop = i.nzHeight,
                    i.windowOffsetLeft = i.nzWidth;
                    break;
                case 5:
                    i.windowOffsetTop = i.nzHeight,
                    i.windowOffsetLeft = i.nzWidth - i.zoomWindow.width() - 2 * i.options.borderSize;
                    break;
                case 6:
                    i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = i.nzHeight,
                    i.windowOffsetLeft = (i.options.zoomWindowWidth / 2 - i.nzWidth / 2 + 2 * i.options.borderSize) * -1);
                    break;
                case 7:
                    i.windowOffsetTop = i.nzHeight,
                    i.windowOffsetLeft = 0;
                    break;
                case 8:
                    i.windowOffsetTop = i.nzHeight,
                    i.windowOffsetLeft = (i.zoomWindow.width() + 2 * i.options.borderSize) * -1;
                    break;
                case 9:
                    i.windowOffsetTop = i.nzHeight - i.zoomWindow.height() - 2 * i.options.borderSize,
                    i.windowOffsetLeft = (i.zoomWindow.width() + 2 * i.options.borderSize) * -1;
                    break;
                case 10:
                    i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = (i.options.zoomWindowHeight / 2 - i.nzHeight / 2) * -1,
                    i.windowOffsetLeft = (i.zoomWindow.width() + 2 * i.options.borderSize) * -1);
                    break;
                case 11:
                    i.windowOffsetTop = i.options.zoomWindowOffety,
                    i.windowOffsetLeft = (i.zoomWindow.width() + 2 * i.options.borderSize) * -1;
                    break;
                case 12:
                    i.windowOffsetTop = (i.zoomWindow.height() + 2 * i.options.borderSize) * -1,
                    i.windowOffsetLeft = (i.zoomWindow.width() + 2 * i.options.borderSize) * -1;
                    break;
                case 13:
                    i.windowOffsetTop = (i.zoomWindow.height() + 2 * i.options.borderSize) * -1,
                    i.windowOffsetLeft = 0;
                    break;
                case 14:
                    i.options.zoomWindowHeight > i.nzHeight && (i.windowOffsetTop = (i.zoomWindow.height() + 2 * i.options.borderSize) * -1,
                    i.windowOffsetLeft = (i.options.zoomWindowWidth / 2 - i.nzWidth / 2 + 2 * i.options.borderSize) * -1);
                    break;
                case 15:
                    i.windowOffsetTop = (i.zoomWindow.height() + 2 * i.options.borderSize) * -1,
                    i.windowOffsetLeft = i.nzWidth - i.zoomWindow.width() - 2 * i.options.borderSize;
                    break;
                case 16:
                    i.windowOffsetTop = (i.zoomWindow.height() + 2 * i.options.borderSize) * -1,
                    i.windowOffsetLeft = i.nzWidth;
                    break;
                default:
                    i.windowOffsetTop = i.options.zoomWindowOffety,
                    i.windowOffsetLeft = i.nzWidth
                }
            i.isWindowSet = !0,
            i.windowOffsetTop = i.windowOffsetTop + i.options.zoomWindowOffety,
            i.windowOffsetLeft = i.windowOffsetLeft + i.options.zoomWindowOffetx,
            i.zoomWindow.css({
                top: i.windowOffsetTop
            }),
            i.zoomWindow.css({
                left: i.windowOffsetLeft
            }),
            "inner" == i.options.zoomType && (i.zoomWindow.css({
                top: 0
            }),
            i.zoomWindow.css({
                left: 0
            })),
            i.windowLeftPos = String(((e.pageX - i.nzOffset.left) * i.widthRatio - i.zoomWindow.width() / 2) * -1),
            i.windowTopPos = String(((e.pageY - i.nzOffset.top) * i.heightRatio - i.zoomWindow.height() / 2) * -1),
            i.Etoppos && (i.windowTopPos = 0),
            i.Eloppos && (i.windowLeftPos = 0),
            i.Eboppos && (i.windowTopPos = (i.largeHeight / i.currentZoomLevel - i.zoomWindow.height()) * -1),
            i.Eroppos && (i.windowLeftPos = (i.largeWidth / i.currentZoomLevel - i.zoomWindow.width()) * -1),
            i.fullheight && (i.windowTopPos = 0),
            i.fullwidth && (i.windowLeftPos = 0),
            "window" != i.options.zoomType && "inner" != i.options.zoomType || (1 == i.zoomLock && (i.widthRatio <= 1 && (i.windowLeftPos = 0),
            i.heightRatio <= 1 && (i.windowTopPos = 0)),
            "window" == i.options.zoomType && (i.largeHeight < i.options.zoomWindowHeight && (i.windowTopPos = 0),
            i.largeWidth < i.options.zoomWindowWidth && (i.windowLeftPos = 0)),
            i.options.easing ? (i.xp || (i.xp = 0),
            i.yp || (i.yp = 0),
            i.loop || (i.loop = setInterval(function() {
                i.xp += (i.windowLeftPos - i.xp) / i.options.easingAmount,
                i.yp += (i.windowTopPos - i.yp) / i.options.easingAmount,
                i.scrollingLock ? (clearInterval(i.loop),
                i.xp = i.windowLeftPos,
                i.yp = i.windowTopPos,
                i.xp = ((e.pageX - i.nzOffset.left) * i.widthRatio - i.zoomWindow.width() / 2) * -1,
                i.yp = ((e.pageY - i.nzOffset.top) * i.heightRatio - i.zoomWindow.height() / 2) * -1,
                i.changeBgSize && (i.nzHeight > i.nzWidth ? ("lens" == i.options.zoomType && i.zoomLens.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                }),
                i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                })) : ("lens" != i.options.zoomType && i.zoomLens.css({
                    "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvalueheight + "px"
                }),
                i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                })),
                i.changeBgSize = !1),
                i.zoomWindow.css({
                    backgroundPosition: i.windowLeftPos + "px " + i.windowTopPos + "px"
                }),
                i.scrollingLock = !1,
                i.loop = !1) : Math.round(Math.abs(i.xp - i.windowLeftPos) + Math.abs(i.yp - i.windowTopPos)) < 1 ? (clearInterval(i.loop),
                i.zoomWindow.css({
                    backgroundPosition: i.windowLeftPos + "px " + i.windowTopPos + "px"
                }),
                i.loop = !1) : (i.changeBgSize && (i.nzHeight > i.nzWidth ? ("lens" == i.options.zoomType && i.zoomLens.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                }),
                i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
                })) : ("lens" != i.options.zoomType && i.zoomLens.css({
                    "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                }),
                i.zoomWindow.css({
                    "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
                })),
                i.changeBgSize = !1),
                i.zoomWindow.css({
                    backgroundPosition: i.xp + "px " + i.yp + "px"
                }))
            }, 16))) : (i.changeBgSize && (i.nzHeight > i.nzWidth ? ("lens" == i.options.zoomType && i.zoomLens.css({
                "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
            }),
            i.zoomWindow.css({
                "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
            })) : ("lens" == i.options.zoomType && i.zoomLens.css({
                "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
            }),
            i.largeHeight / i.newvaluewidth < i.options.zoomWindowHeight ? i.zoomWindow.css({
                "background-size": i.largeWidth / i.newvaluewidth + "px " + i.largeHeight / i.newvaluewidth + "px"
            }) : i.zoomWindow.css({
                "background-size": i.largeWidth / i.newvalueheight + "px " + i.largeHeight / i.newvalueheight + "px"
            })),
            i.changeBgSize = !1),
            i.zoomWindow.css({
                backgroundPosition: i.windowLeftPos + "px " + i.windowTopPos + "px"
            })))
        },
        setTintPosition: function(o) {
            var e = this;
            e.nzOffset = e.$elem.offset(),
            e.tintpos = String((o.pageX - e.nzOffset.left - e.zoomLens.width() / 2) * -1),
            e.tintposy = String((o.pageY - e.nzOffset.top - e.zoomLens.height() / 2) * -1),
            e.Etoppos && (e.tintposy = 0),
            e.Eloppos && (e.tintpos = 0),
            e.Eboppos && (e.tintposy = (e.nzHeight - e.zoomLens.height() - 2 * e.options.lensBorderSize) * -1),
            e.Eroppos && (e.tintpos = (e.nzWidth - e.zoomLens.width() - 2 * e.options.lensBorderSize) * -1),
            e.options.tint && (e.fullheight && (e.tintposy = 0),
            e.fullwidth && (e.tintpos = 0),
            e.zoomTintImage.css({
                left: e.tintpos + "px"
            }),
            e.zoomTintImage.css({
                top: e.tintposy + "px"
            }))
        },
        swaptheimage: function(e, i) {
            var t = this
              , n = new Image;
            t.options.loadingIcon && (t.spinner = o("<div style=\"background: url('" + t.options.loadingIcon + "') no-repeat center;height:" + t.nzHeight + "px;width:" + t.nzWidth + 'px;z-index: 2000;position: absolute; background-position: center center;"></div>'),
            t.$elem.after(t.spinner)),
            t.options.onImageSwap(t.$elem),
            n.onload = function() {
                t.largeWidth = n.width,
                t.largeHeight = n.height,
                t.zoomImage = i,
                t.zoomWindow.css({
                    "background-size": t.largeWidth + "px " + t.largeHeight + "px"
                }),
                t.swapAction(e, i)
            }
            ,
            n.src = i
        },
        swapAction: function(e, i) {
            var t = this
              , n = new Image;
            if (n.onload = function() {
                t.nzHeight = n.height,
                t.nzWidth = n.width,
                t.options.onImageSwapComplete(t.$elem),
                t.doneCallback()
            }
            ,
            n.src = e,
            t.currentZoomLevel = t.options.zoomLevel,
            t.options.maxZoomLevel = !1,
            "lens" == t.options.zoomType && t.zoomLens.css({
                backgroundImage: "url('" + i + "')"
            }),
            "window" == t.options.zoomType && t.zoomWindow.css({
                backgroundImage: "url('" + i + "')"
            }),
            "inner" == t.options.zoomType && t.zoomWindow.css({
                backgroundImage: "url('" + i + "')"
            }),
            t.currentImage = i,
            t.options.imageCrossfade) {
                var s = t.$elem
                  , h = s.clone();
                if (t.$elem.attr("src", e),
                t.$elem.after(h),
                h.stop(!0).fadeOut(t.options.imageCrossfade, function() {
                    o(this).remove()
                }),
                t.$elem.width("auto").removeAttr("width"),
                t.$elem.height("auto").removeAttr("height"),
                s.fadeIn(t.options.imageCrossfade),
                t.options.tint && "inner" != t.options.zoomType) {
                    var a = t.zoomTintImage
                      , d = a.clone();
                    t.zoomTintImage.attr("src", i),
                    t.zoomTintImage.after(d),
                    d.stop(!0).fadeOut(t.options.imageCrossfade, function() {
                        o(this).remove()
                    }),
                    a.fadeIn(t.options.imageCrossfade),
                    t.zoomTint.css({
                        height: t.$elem.height()
                    }),
                    t.zoomTint.css({
                        width: t.$elem.width()
                    })
                }
                t.zoomContainer.css("height", t.$elem.height()),
                t.zoomContainer.css("width", t.$elem.width()),
                "inner" == t.options.zoomType && (t.options.constrainType || (t.zoomWrap.parent().css("height", t.$elem.height()),
                t.zoomWrap.parent().css("width", t.$elem.width()),
                t.zoomWindow.css("height", t.$elem.height()),
                t.zoomWindow.css("width", t.$elem.width()))),
                t.options.imageCrossfade && (t.zoomWrap.css("height", t.$elem.height()),
                t.zoomWrap.css("width", t.$elem.width()))
            } else
                t.$elem.attr("src", e),
                t.options.tint && (t.zoomTintImage.attr("src", i),
                t.zoomTintImage.attr("height", t.$elem.height()),
                t.zoomTintImage.css({
                    height: t.$elem.height()
                }),
                t.zoomTint.css({
                    height: t.$elem.height()
                })),
                t.zoomContainer.css("height", t.$elem.height()),
                t.zoomContainer.css("width", t.$elem.width()),
                t.options.imageCrossfade && (t.zoomWrap.css("height", t.$elem.height()),
                t.zoomWrap.css("width", t.$elem.width()));
            t.options.constrainType && ("height" == t.options.constrainType && (t.zoomContainer.css("height", t.options.constrainSize),
            t.zoomContainer.css("width", "auto"),
            t.options.imageCrossfade ? (t.zoomWrap.css("height", t.options.constrainSize),
            t.zoomWrap.css("width", "auto"),
            t.constwidth = t.zoomWrap.width()) : (t.$elem.css("height", t.options.constrainSize),
            t.$elem.css("width", "auto"),
            t.constwidth = t.$elem.width()),
            "inner" == t.options.zoomType && (t.zoomWrap.parent().css("height", t.options.constrainSize),
            t.zoomWrap.parent().css("width", t.constwidth),
            t.zoomWindow.css("height", t.options.constrainSize),
            t.zoomWindow.css("width", t.constwidth)),
            t.options.tint && (t.tintContainer.css("height", t.options.constrainSize),
            t.tintContainer.css("width", t.constwidth),
            t.zoomTint.css("height", t.options.constrainSize),
            t.zoomTint.css("width", t.constwidth),
            t.zoomTintImage.css("height", t.options.constrainSize),
            t.zoomTintImage.css("width", t.constwidth))),
            "width" == t.options.constrainType && (t.zoomContainer.css("height", "auto"),
            t.zoomContainer.css("width", t.options.constrainSize),
            t.options.imageCrossfade ? (t.zoomWrap.css("height", "auto"),
            t.zoomWrap.css("width", t.options.constrainSize),
            t.constheight = t.zoomWrap.height()) : (t.$elem.css("height", "auto"),
            t.$elem.css("width", t.options.constrainSize),
            t.constheight = t.$elem.height()),
            "inner" == t.options.zoomType && (t.zoomWrap.parent().css("height", t.constheight),
            t.zoomWrap.parent().css("width", t.options.constrainSize),
            t.zoomWindow.css("height", t.constheight),
            t.zoomWindow.css("width", t.options.constrainSize)),
            t.options.tint && (t.tintContainer.css("height", t.constheight),
            t.tintContainer.css("width", t.options.constrainSize),
            t.zoomTint.css("height", t.constheight),
            t.zoomTint.css("width", t.options.constrainSize),
            t.zoomTintImage.css("height", t.constheight),
            t.zoomTintImage.css("width", t.options.constrainSize))))
        },
        doneCallback: function() {
            var o = this;
            o.options.loadingIcon && o.spinner.hide(),
            o.nzOffset = o.$elem.offset(),
            o.nzWidth = o.$elem.width(),
            o.nzHeight = o.$elem.height(),
            o.currentZoomLevel = o.options.zoomLevel,
            o.widthRatio = o.largeWidth / o.nzWidth,
            o.heightRatio = o.largeHeight / o.nzHeight,
            "window" == o.options.zoomType && (o.nzHeight < o.options.zoomWindowWidth / o.widthRatio ? lensHeight = o.nzHeight : lensHeight = String(o.options.zoomWindowHeight / o.heightRatio),
            o.options.zoomWindowWidth < o.options.zoomWindowWidth ? lensWidth = o.nzWidth : lensWidth = o.options.zoomWindowWidth / o.widthRatio,
            o.zoomLens && (o.zoomLens.css("width", lensWidth),
            o.zoomLens.css("height", lensHeight)))
        },
        getCurrentImage: function() {
            var o = this;
            return o.zoomImage
        },
        getGalleryList: function() {
            var e = this;
            return e.gallerylist = [],
            e.options.gallery ? o("#" + e.options.gallery + " a").each(function() {
                var i = "";
                o(this).data("zoom-image") ? i = o(this).data("zoom-image") : o(this).data("image") && (i = o(this).data("image")),
                i == e.zoomImage ? e.gallerylist.unshift({
                    href: "" + i,
                    title: o(this).find("img").attr("title")
                }) : e.gallerylist.push({
                    href: "" + i,
                    title: o(this).find("img").attr("title")
                })
            }) : e.gallerylist.push({
                href: "" + e.zoomImage,
                title: o(this).find("img").attr("title")
            }),
            e.gallerylist
        },
        changeZoomLevel: function(o) {
            var e = this;
            e.scrollingLock = !0,
            e.newvalue = parseFloat(o).toFixed(2),
            newvalue = parseFloat(o).toFixed(2),
            maxheightnewvalue = e.largeHeight / (e.options.zoomWindowHeight / e.nzHeight * e.nzHeight),
            maxwidthtnewvalue = e.largeWidth / (e.options.zoomWindowWidth / e.nzWidth * e.nzWidth),
            "inner" != e.options.zoomType && (maxheightnewvalue <= newvalue ? (e.heightRatio = e.largeHeight / maxheightnewvalue / e.nzHeight,
            e.newvalueheight = maxheightnewvalue,
            e.fullheight = !0) : (e.heightRatio = e.largeHeight / newvalue / e.nzHeight,
            e.newvalueheight = newvalue,
            e.fullheight = !1),
            maxwidthtnewvalue <= newvalue ? (e.widthRatio = e.largeWidth / maxwidthtnewvalue / e.nzWidth,
            e.newvaluewidth = maxwidthtnewvalue,
            e.fullwidth = !0) : (e.widthRatio = e.largeWidth / newvalue / e.nzWidth,
            e.newvaluewidth = newvalue,
            e.fullwidth = !1),
            "lens" == e.options.zoomType && (maxheightnewvalue <= newvalue ? (e.fullwidth = !0,
            e.newvaluewidth = maxheightnewvalue) : (e.widthRatio = e.largeWidth / newvalue / e.nzWidth,
            e.newvaluewidth = newvalue,
            e.fullwidth = !1))),
            "inner" == e.options.zoomType && (maxheightnewvalue = parseFloat(e.largeHeight / e.nzHeight).toFixed(2),
            maxwidthtnewvalue = parseFloat(e.largeWidth / e.nzWidth).toFixed(2),
            newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue),
            newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue),
            maxheightnewvalue <= newvalue ? (e.heightRatio = e.largeHeight / newvalue / e.nzHeight,
            newvalue > maxheightnewvalue ? e.newvalueheight = maxheightnewvalue : e.newvalueheight = newvalue,
            e.fullheight = !0) : (e.heightRatio = e.largeHeight / newvalue / e.nzHeight,
            newvalue > maxheightnewvalue ? e.newvalueheight = maxheightnewvalue : e.newvalueheight = newvalue,
            e.fullheight = !1),
            maxwidthtnewvalue <= newvalue ? (e.widthRatio = e.largeWidth / newvalue / e.nzWidth,
            newvalue > maxwidthtnewvalue ? e.newvaluewidth = maxwidthtnewvalue : e.newvaluewidth = newvalue,
            e.fullwidth = !0) : (e.widthRatio = e.largeWidth / newvalue / e.nzWidth,
            e.newvaluewidth = newvalue,
            e.fullwidth = !1)),
            scrcontinue = !1,
            "inner" == e.options.zoomType && (e.nzWidth >= e.nzHeight && (e.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1,
            e.fullheight = !0,
            e.fullwidth = !0)),
            e.nzHeight > e.nzWidth && (e.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1,
            e.fullheight = !0,
            e.fullwidth = !0))),
            "inner" != e.options.zoomType && (scrcontinue = !0),
            scrcontinue && (e.zoomLock = 0,
            e.changeZoom = !0,
            e.options.zoomWindowHeight / e.heightRatio <= e.nzHeight && (e.currentZoomLevel = e.newvalueheight,
            "lens" != e.options.zoomType && "inner" != e.options.zoomType && (e.changeBgSize = !0,
            e.zoomLens.css({
                height: String(e.options.zoomWindowHeight / e.heightRatio) + "px"
            })),
            "lens" != e.options.zoomType && "inner" != e.options.zoomType || (e.changeBgSize = !0)),
            e.options.zoomWindowWidth / e.widthRatio <= e.nzWidth && ("inner" != e.options.zoomType && e.newvaluewidth > e.newvalueheight && (e.currentZoomLevel = e.newvaluewidth),
            "lens" != e.options.zoomType && "inner" != e.options.zoomType && (e.changeBgSize = !0,
            e.zoomLens.css({
                width: String(e.options.zoomWindowWidth / e.widthRatio) + "px"
            })),
            "lens" != e.options.zoomType && "inner" != e.options.zoomType || (e.changeBgSize = !0)),
            "inner" == e.options.zoomType && (e.changeBgSize = !0,
            e.nzWidth > e.nzHeight && (e.currentZoomLevel = e.newvaluewidth),
            e.nzHeight > e.nzWidth && (e.currentZoomLevel = e.newvaluewidth))),
            e.setPosition(e.currentLoc)
        },
        closeAll: function() {
            self.zoomWindow && self.zoomWindow.hide(),
            self.zoomLens && self.zoomLens.hide(),
            self.zoomTint && self.zoomTint.hide()
        },
        changeState: function(o) {
            var e = this;
            "enable" == o && (e.options.zoomEnabled = !0),
            "disable" == o && (e.options.zoomEnabled = !1)
        }
    };
    o.fn.elevateZoom = function(e) {
        return this.each(function() {
            var i = Object.create(n);
            i.init(e, this),
            o.data(this, "elevateZoom", i)
        })
    }
    ,
    o.fn.elevateZoom.options = {
        zoomActivation: "hover",
        zoomEnabled: !0,
        preloading: 1,
        zoomLevel: 1,
        scrollZoom: !1,
        scrollZoomIncrement: .1,
        minZoomLevel: !1,
        maxZoomLevel: !1,
        easing: !1,
        easingAmount: 12,
        lensSize: 200,
        zoomWindowWidth: 400,
        zoomWindowHeight: 400,
        zoomWindowOffetx: 0,
        zoomWindowOffety: 0,
        zoomWindowPosition: 1,
        zoomWindowBgColour: "#fff",
        lensFadeIn: !1,
        lensFadeOut: !1,
        debug: !1,
        zoomWindowFadeIn: !1,
        zoomWindowFadeOut: !1,
        zoomWindowAlwaysShow: !1,
        zoomTintFadeIn: !1,
        zoomTintFadeOut: !1,
        borderSize: 4,
        showLens: !0,
        borderColour: "#888",
        lensBorderSize: 1,
        lensBorderColour: "#000",
        lensShape: "square",
        zoomType: "window",
        containLensZoom: !1,
        lensColour: "white",
        lensOpacity: .4,
        lenszoom: !1,
        tint: !1,
        tintColour: "#333",
        tintOpacity: .4,
        gallery: !1,
        galleryActiveClass: "zoomGalleryActive",
        imageCrossfade: !1,
        constrainType: !1,
        constrainSize: !1,
        loadingIcon: !1,
        cursor: "default",
        responsive: !0,
        onComplete: o.noop,
        onDestroy: function() {},
        onZoomedImageLoaded: function() {},
        onImageSwap: o.noop,
        onImageSwapComplete: o.noop
    }
}(jQuery, window, document);

/*!
 * scrollup v2.4.1
 * Url: http://markgoodyear.com/labs/scrollup/
 * Copyright (c) Mark Goodyear — @markgdyr — http://markgoodyear.com
 * License: MIT
 */
!function(l, o, e) {
    "use strict";
    l.fn.scrollUp = function(o) {
        l.data(e.body, "scrollUp") || (l.data(e.body, "scrollUp", !0),
        l.fn.scrollUp.init(o))
    }
    ,
    l.fn.scrollUp.init = function(r) {
        var s, t, c, i, n, a, d, p = l.fn.scrollUp.settings = l.extend({}, l.fn.scrollUp.defaults, r), f = !1;
        switch (d = p.scrollTrigger ? l(p.scrollTrigger) : l("<a/>", {
            id: p.scrollName,
            href: "#top"
        }),
        p.scrollTitle && d.attr("title", p.scrollTitle),
        d.appendTo("body"),
        p.scrollImg || p.scrollTrigger || d.html(p.scrollText),
        d.css({
            display: "none",
            position: "fixed",
            zIndex: p.zIndex
        }),
        p.activeOverlay && l("<div/>", {
            id: p.scrollName + "-active"
        }).css({
            position: "absolute",
            top: p.scrollDistance + "px",
            width: "100%",
            borderTop: "1px dotted" + p.activeOverlay,
            zIndex: p.zIndex
        }).appendTo("body"),
        p.animation) {
        case "fade":
            s = "fadeIn",
            t = "fadeOut",
            c = p.animationSpeed;
            break;
        case "slide":
            s = "slideDown",
            t = "slideUp",
            c = p.animationSpeed;
            break;
        default:
            s = "show",
            t = "hide",
            c = 0
        }
        i = "top" === p.scrollFrom ? p.scrollDistance : l(e).height() - l(o).height() - p.scrollDistance,
        n = l(o).scroll(function() {
            l(o).scrollTop() > i ? f || (d[s](c),
            f = !0) : f && (d[t](c),
            f = !1)
        }),
        p.scrollTarget ? "number" == typeof p.scrollTarget ? a = p.scrollTarget : "string" == typeof p.scrollTarget && (a = Math.floor(l(p.scrollTarget).offset().top)) : a = 0,
        d.click(function(o) {
            o.preventDefault(),
            l("html, body").animate({
                scrollTop: a
            }, p.scrollSpeed, p.easingType)
        })
    }
    ,
    l.fn.scrollUp.defaults = {
        scrollName: "scrollUp",
        scrollDistance: 300,
        scrollFrom: "top",
        scrollSpeed: 300,
        easingType: "linear",
        animation: "fade",
        animationSpeed: 200,
        scrollTrigger: !1,
        scrollTarget: !1,
        scrollText: "Scroll to top",
        scrollTitle: !1,
        scrollImg: !1,
        activeOverlay: !1,
        zIndex: 2147483647
    },
    l.fn.scrollUp.destroy = function(r) {
        l.removeData(e.body, "scrollUp"),
        l("#" + l.fn.scrollUp.settings.scrollName).remove(),
        l("#" + l.fn.scrollUp.settings.scrollName + "-active").remove(),
        l.fn.jquery.split(".")[1] >= 7 ? l(o).off("scroll", r) : l(o).unbind("scroll", r)
    }
    ,
    l.scrollUp = l.fn.scrollUp
}(jQuery, window, document);

/*!
 * Name    : Just Another Parallax [Jarallax]
 * Version : 1.10.6
 * Author  : nK <https://nkdev.info>
 * GitHub  : https://github.com/nk-o/jarallax
 */
!function(o) {
    var n = {};
    function i(e) {
        if (n[e])
            return n[e].exports;
        var t = n[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return o[e].call(t.exports, t, t.exports, i),
        t.l = !0,
        t.exports
    }
    i.m = o,
    i.c = n,
    i.d = function(e, t, o) {
        i.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: o
        })
    }
    ,
    i.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }),
        Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }
    ,
    i.t = function(t, e) {
        if (1 & e && (t = i(t)),
        8 & e)
            return t;
        if (4 & e && "object" == typeof t && t && t.__esModule)
            return t;
        var o = Object.create(null);
        if (i.r(o),
        Object.defineProperty(o, "default", {
            enumerable: !0,
            value: t
        }),
        2 & e && "string" != typeof t)
            for (var n in t)
                i.d(o, n, function(e) {
                    return t[e]
                }
                .bind(null, n));
        return o
    }
    ,
    i.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default
        }
        : function() {
            return e
        }
        ;
        return i.d(t, "a", t),
        t
    }
    ,
    i.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }
    ,
    i.p = "",
    i(i.s = 11)
}([, , function(e, t, o) {
    "use strict";
    e.exports = function(e) {
        "complete" === document.readyState || "interactive" === document.readyState ? e.call() : document.attachEvent ? document.attachEvent("onreadystatechange", function() {
            "interactive" === document.readyState && e.call()
        }) : document.addEventListener && document.addEventListener("DOMContentLoaded", e)
    }
}
, , function(o, e, t) {
    "use strict";
    (function(e) {
        var t;
        t = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {},
        o.exports = t
    }
    ).call(this, t(5))
}
, function(e, t, o) {
    "use strict";
    var n, i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    }
    : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    }
    ;
    n = function() {
        return this
    }();
    try {
        n = n || Function("return this")() || (0,
        eval)("this")
    } catch (e) {
        "object" === ("undefined" == typeof window ? "undefined" : i(window)) && (n = window)
    }
    e.exports = n
}
, , , , , , function(e, t, o) {
    e.exports = o(12)
}
, function(e, t, o) {
    "use strict";
    var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    }
    : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    }
      , i = l(o(2))
      , a = o(4)
      , r = l(o(13));
    function l(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    var s = a.window.jarallax;
    if (a.window.jarallax = r.default,
    a.window.jarallax.noConflict = function() {
        return a.window.jarallax = s,
        this
    }
    ,
    void 0 !== a.jQuery) {
        var c = function() {
            var e = arguments || [];
            Array.prototype.unshift.call(e, this);
            var t = r.default.apply(a.window, e);
            return "object" !== (void 0 === t ? "undefined" : n(t)) ? t : this
        };
        c.constructor = r.default.constructor;
        var u = a.jQuery.fn.jarallax;
        a.jQuery.fn.jarallax = c,
        a.jQuery.fn.jarallax.noConflict = function() {
            return a.jQuery.fn.jarallax = u,
            this
        }
    }
    (0,
    i.default)(function() {
        (0,
        r.default)(document.querySelectorAll("[data-jarallax]"))
    })
}
, function(e, j, S) {
    "use strict";
    (function(e) {
        Object.defineProperty(j, "__esModule", {
            value: !0
        });
        var d = function(e, t) {
            if (Array.isArray(e))
                return e;
            if (Symbol.iterator in Object(e))
                return function(e, t) {
                    var o = []
                      , n = !0
                      , i = !1
                      , a = void 0;
                    try {
                        for (var r, l = e[Symbol.iterator](); !(n = (r = l.next()).done) && (o.push(r.value),
                        !t || o.length !== t); n = !0)
                            ;
                    } catch (e) {
                        i = !0,
                        a = e
                    } finally {
                        try {
                            !n && l.return && l.return()
                        } finally {
                            if (i)
                                throw a
                        }
                    }
                    return o
                }(e, t);
            throw new TypeError("Invalid attempt to destructure non-iterable instance")
        }
          , t = function() {
            function n(e, t) {
                for (var o = 0; o < t.length; o++) {
                    var n = t[o];
                    n.enumerable = n.enumerable || !1,
                    n.configurable = !0,
                    "value"in n && (n.writable = !0),
                    Object.defineProperty(e, n.key, n)
                }
            }
            return function(e, t, o) {
                return t && n(e.prototype, t),
                o && n(e, o),
                e
            }
        }()
          , p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
          , o = a(S(2))
          , n = a(S(14))
          , i = S(4);
        function a(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }
        var s = -1 < navigator.userAgent.indexOf("MSIE ") || -1 < navigator.userAgent.indexOf("Trident/") || -1 < navigator.userAgent.indexOf("Edge/")
          , r = function() {
            for (var e = "transform WebkitTransform MozTransform".split(" "), t = document.createElement("div"), o = 0; o < e.length; o++)
                if (t && void 0 !== t.style[e[o]])
                    return e[o];
            return !1
        }()
          , b = void 0
          , v = void 0
          , l = void 0
          , c = !1
          , u = !1;
        function m(e) {
            b = i.window.innerWidth || document.documentElement.clientWidth,
            v = i.window.innerHeight || document.documentElement.clientHeight,
            "object" !== (void 0 === e ? "undefined" : p(e)) || "load" !== e.type && "dom-loaded" !== e.type || (c = !0)
        }
        m(),
        i.window.addEventListener("resize", m),
        i.window.addEventListener("orientationchange", m),
        i.window.addEventListener("load", m),
        (0,
        o.default)(function() {
            m({
                type: "dom-loaded"
            })
        });
        var f = []
          , y = !1;
        function g() {
            if (f.length) {
                l = void 0 !== i.window.pageYOffset ? i.window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                var t = c || !y || y.width !== b || y.height !== v
                  , o = u || t || !y || y.y !== l;
                u = c = !1,
                (t || o) && (f.forEach(function(e) {
                    t && e.onResize(),
                    o && e.onScroll()
                }),
                y = {
                    width: b,
                    height: v,
                    y: l
                }),
                (0,
                n.default)(g)
            }
        }
        var h = !!e.ResizeObserver && new e.ResizeObserver(function(e) {
            e && e.length && (0,
            n.default)(function() {
                e.forEach(function(e) {
                    e.target && e.target.jarallax && (c || e.target.jarallax.onResize(),
                    u = !0)
                })
            })
        }
        )
          , x = 0
          , w = function() {
            function u(e, t) {
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, u);
                var o = this;
                o.instanceID = x++,
                o.$item = e,
                o.defaults = {
                    type: "scroll",
                    speed: .5,
                    imgSrc: null,
                    imgElement: ".jarallax-img",
                    imgSize: "cover",
                    imgPosition: "50% 50%",
                    imgRepeat: "no-repeat",
                    keepImg: !1,
                    elementInViewport: null,
                    zIndex: -100,
                    disableParallax: !1,
                    disableVideo: !1,
                    automaticResize: !0,
                    videoSrc: null,
                    videoStartTime: 0,
                    videoEndTime: 0,
                    videoVolume: 0,
                    videoPlayOnlyVisible: !0,
                    onScroll: null,
                    onInit: null,
                    onDestroy: null,
                    onCoverImage: null
                };
                var n = o.$item.getAttribute("data-jarallax")
                  , i = JSON.parse(n || "{}");
                n && console.warn("Detected usage of deprecated data-jarallax JSON options, you should use pure data-attribute options. See info here - https://github.com/nk-o/jarallax/issues/53");
                var a = o.$item.dataset || {}
                  , r = {};
                if (Object.keys(a).forEach(function(e) {
                    var t = e.substr(0, 1).toLowerCase() + e.substr(1);
                    t && void 0 !== o.defaults[t] && (r[t] = a[e])
                }),
                o.options = o.extend({}, o.defaults, i, r, t),
                o.pureOptions = o.extend({}, o.options),
                Object.keys(o.options).forEach(function(e) {
                    "true" === o.options[e] ? o.options[e] = !0 : "false" === o.options[e] && (o.options[e] = !1)
                }),
                o.options.speed = Math.min(2, Math.max(-1, parseFloat(o.options.speed))),
                (o.options.noAndroid || o.options.noIos) && (console.warn("Detected usage of deprecated noAndroid or noIos options, you should use disableParallax option. See info here - https://github.com/nk-o/jarallax/#disable-on-mobile-devices"),
                o.options.disableParallax || (o.options.noIos && o.options.noAndroid ? o.options.disableParallax = /iPad|iPhone|iPod|Android/ : o.options.noIos ? o.options.disableParallax = /iPad|iPhone|iPod/ : o.options.noAndroid && (o.options.disableParallax = /Android/))),
                "string" == typeof o.options.disableParallax && (o.options.disableParallax = new RegExp(o.options.disableParallax)),
                o.options.disableParallax instanceof RegExp) {
                    var l = o.options.disableParallax;
                    o.options.disableParallax = function() {
                        return l.test(navigator.userAgent)
                    }
                }
                if ("function" != typeof o.options.disableParallax && (o.options.disableParallax = function() {
                    return !1
                }
                ),
                "string" == typeof o.options.disableVideo && (o.options.disableVideo = new RegExp(o.options.disableVideo)),
                o.options.disableVideo instanceof RegExp) {
                    var s = o.options.disableVideo;
                    o.options.disableVideo = function() {
                        return s.test(navigator.userAgent)
                    }
                }
                "function" != typeof o.options.disableVideo && (o.options.disableVideo = function() {
                    return !1
                }
                );
                var c = o.options.elementInViewport;
                c && "object" === (void 0 === c ? "undefined" : p(c)) && void 0 !== c.length && (c = d(c, 1)[0]);
                c instanceof Element || (c = null),
                o.options.elementInViewport = c,
                o.image = {
                    src: o.options.imgSrc || null,
                    $container: null,
                    useImgTag: !1,
                    position: /iPad|iPhone|iPod|Android/.test(navigator.userAgent) ? "absolute" : "fixed"
                },
                o.initImg() && o.canInitParallax() && o.init()
            }
            return t(u, [{
                key: "css",
                value: function(t, o) {
                    return "string" == typeof o ? i.window.getComputedStyle(t).getPropertyValue(o) : (o.transform && r && (o[r] = o.transform),
                    Object.keys(o).forEach(function(e) {
                        t.style[e] = o[e]
                    }),
                    t)
                }
            }, {
                key: "extend",
                value: function(o) {
                    var n = arguments;
                    return o = o || {},
                    Object.keys(arguments).forEach(function(t) {
                        n[t] && Object.keys(n[t]).forEach(function(e) {
                            o[e] = n[t][e]
                        })
                    }),
                    o
                }
            }, {
                key: "getWindowData",
                value: function() {
                    return {
                        width: b,
                        height: v,
                        y: l
                    }
                }
            }, {
                key: "initImg",
                value: function() {
                    var e = this
                      , t = e.options.imgElement;
                    return t && "string" == typeof t && (t = e.$item.querySelector(t)),
                    t instanceof Element || (t = null),
                    t && (e.options.keepImg ? e.image.$item = t.cloneNode(!0) : (e.image.$item = t,
                    e.image.$itemParent = t.parentNode),
                    e.image.useImgTag = !0),
                    !!e.image.$item || (null === e.image.src && (e.image.src = e.css(e.$item, "background-image").replace(/^url\(['"]?/g, "").replace(/['"]?\)$/g, "")),
                    !(!e.image.src || "none" === e.image.src))
                }
            }, {
                key: "canInitParallax",
                value: function() {
                    return r && !this.options.disableParallax()
                }
            }, {
                key: "init",
                value: function() {
                    var e = this
                      , t = {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        pointerEvents: "none"
                    }
                      , o = {};
                    if (!e.options.keepImg) {
                        var n = e.$item.getAttribute("style");
                        if (n && e.$item.setAttribute("data-jarallax-original-styles", n),
                        e.image.useImgTag) {
                            var i = e.image.$item.getAttribute("style");
                            i && e.image.$item.setAttribute("data-jarallax-original-styles", i)
                        }
                    }
                    if ("static" === e.css(e.$item, "position") && e.css(e.$item, {
                        position: "relative"
                    }),
                    "auto" === e.css(e.$item, "z-index") && e.css(e.$item, {
                        zIndex: 0
                    }),
                    e.image.$container = document.createElement("div"),
                    e.css(e.image.$container, t),
                    e.css(e.image.$container, {
                        "z-index": e.options.zIndex
                    }),
                    s && e.css(e.image.$container, {
                        opacity: .9999
                    }),
                    e.image.$container.setAttribute("id", "jarallax-container-" + e.instanceID),
                    e.$item.appendChild(e.image.$container),
                    e.image.useImgTag ? o = e.extend({
                        "object-fit": e.options.imgSize,
                        "object-position": e.options.imgPosition,
                        "font-family": "object-fit: " + e.options.imgSize + "; object-position: " + e.options.imgPosition + ";",
                        "max-width": "none"
                    }, t, o) : (e.image.$item = document.createElement("div"),
                    e.image.src && (o = e.extend({
                        "background-position": e.options.imgPosition,
                        "background-size": e.options.imgSize,
                        "background-repeat": e.options.imgRepeat,
                        "background-image": 'url("' + e.image.src + '")'
                    }, t, o))),
                    "opacity" !== e.options.type && "scale" !== e.options.type && "scale-opacity" !== e.options.type && 1 !== e.options.speed || (e.image.position = "absolute"),
                    "fixed" === e.image.position)
                        for (var a = 0, r = e.$item; null !== r && r !== document && 0 === a; ) {
                            var l = e.css(r, "-webkit-transform") || e.css(r, "-moz-transform") || e.css(r, "transform");
                            l && "none" !== l && (a = 1,
                            e.image.position = "absolute"),
                            r = r.parentNode
                        }
                    o.position = e.image.position,
                    e.css(e.image.$item, o),
                    e.image.$container.appendChild(e.image.$item),
                    e.onResize(),
                    e.onScroll(!0),
                    e.options.automaticResize && h && h.observe(e.$item),
                    e.options.onInit && e.options.onInit.call(e),
                    "none" !== e.css(e.$item, "background-image") && e.css(e.$item, {
                        "background-image": "none"
                    }),
                    e.addToParallaxList()
                }
            }, {
                key: "addToParallaxList",
                value: function() {
                    f.push(this),
                    1 === f.length && g()
                }
            }, {
                key: "removeFromParallaxList",
                value: function() {
                    var o = this;
                    f.forEach(function(e, t) {
                        e.instanceID === o.instanceID && f.splice(t, 1)
                    })
                }
            }, {
                key: "destroy",
                value: function() {
                    var e = this;
                    e.removeFromParallaxList();
                    var t = e.$item.getAttribute("data-jarallax-original-styles");
                    if (e.$item.removeAttribute("data-jarallax-original-styles"),
                    t ? e.$item.setAttribute("style", t) : e.$item.removeAttribute("style"),
                    e.image.useImgTag) {
                        var o = e.image.$item.getAttribute("data-jarallax-original-styles");
                        e.image.$item.removeAttribute("data-jarallax-original-styles"),
                        o ? e.image.$item.setAttribute("style", t) : e.image.$item.removeAttribute("style"),
                        e.image.$itemParent && e.image.$itemParent.appendChild(e.image.$item)
                    }
                    e.$clipStyles && e.$clipStyles.parentNode.removeChild(e.$clipStyles),
                    e.image.$container && e.image.$container.parentNode.removeChild(e.image.$container),
                    e.options.onDestroy && e.options.onDestroy.call(e),
                    delete e.$item.jarallax
                }
            }, {
                key: "clipContainer",
                value: function() {
                    if ("fixed" === this.image.position) {
                        var e = this
                          , t = e.image.$container.getBoundingClientRect()
                          , o = t.width
                          , n = t.height;
                        if (!e.$clipStyles)
                            e.$clipStyles = document.createElement("style"),
                            e.$clipStyles.setAttribute("type", "text/css"),
                            e.$clipStyles.setAttribute("id", "jarallax-clip-" + e.instanceID),
                            (document.head || document.getElementsByTagName("head")[0]).appendChild(e.$clipStyles);
                        var i = "#jarallax-container-" + e.instanceID + " {\n           clip: rect(0 " + o + "px " + n + "px 0);\n           clip: rect(0, " + o + "px, " + n + "px, 0);\n        }";
                        e.$clipStyles.styleSheet ? e.$clipStyles.styleSheet.cssText = i : e.$clipStyles.innerHTML = i
                    }
                }
            }, {
                key: "coverImage",
                value: function() {
                    var e = this
                      , t = e.image.$container.getBoundingClientRect()
                      , o = t.height
                      , n = e.options.speed
                      , i = "scroll" === e.options.type || "scroll-opacity" === e.options.type
                      , a = 0
                      , r = o
                      , l = 0;
                    return i && (n < 0 ? (a = n * Math.max(o, v),
                    v < o && (a -= n * (o - v))) : a = n * (o + v),
                    1 < n ? r = Math.abs(a - v) : n < 0 ? r = a / n + Math.abs(a) : r += (v - o) * (1 - n),
                    a /= 2),
                    e.parallaxScrollDistance = a,
                    l = i ? (v - r) / 2 : (o - r) / 2,
                    e.css(e.image.$item, {
                        height: r + "px",
                        marginTop: l + "px",
                        left: "fixed" === e.image.position ? t.left + "px" : "0",
                        width: t.width + "px"
                    }),
                    e.options.onCoverImage && e.options.onCoverImage.call(e),
                    {
                        image: {
                            height: r,
                            marginTop: l
                        },
                        container: t
                    }
                }
            }, {
                key: "isVisible",
                value: function() {
                    return this.isElementInViewport || !1
                }
            }, {
                key: "onScroll",
                value: function(e) {
                    var t = this
                      , o = t.$item.getBoundingClientRect()
                      , n = o.top
                      , i = o.height
                      , a = {}
                      , r = o;
                    if (t.options.elementInViewport && (r = t.options.elementInViewport.getBoundingClientRect()),
                    t.isElementInViewport = 0 <= r.bottom && 0 <= r.right && r.top <= v && r.left <= b,
                    e || t.isElementInViewport) {
                        var l = Math.max(0, n)
                          , s = Math.max(0, i + n)
                          , c = Math.max(0, -n)
                          , u = Math.max(0, n + i - v)
                          , d = Math.max(0, i - (n + i - v))
                          , p = Math.max(0, -n + v - i)
                          , m = 1 - 2 * (v - n) / (v + i)
                          , f = 1;
                        if (i < v ? f = 1 - (c || u) / i : s <= v ? f = s / v : d <= v && (f = d / v),
                        "opacity" !== t.options.type && "scale-opacity" !== t.options.type && "scroll-opacity" !== t.options.type || (a.transform = "translate3d(0,0,0)",
                        a.opacity = f),
                        "scale" === t.options.type || "scale-opacity" === t.options.type) {
                            var y = 1;
                            t.options.speed < 0 ? y -= t.options.speed * f : y += t.options.speed * (1 - f),
                            a.transform = "scale(" + y + ") translate3d(0,0,0)"
                        }
                        if ("scroll" === t.options.type || "scroll-opacity" === t.options.type) {
                            var g = t.parallaxScrollDistance * m;
                            "absolute" === t.image.position && (g -= n),
                            a.transform = "translate3d(0," + g + "px,0)"
                        }
                        t.css(t.image.$item, a),
                        t.options.onScroll && t.options.onScroll.call(t, {
                            section: o,
                            beforeTop: l,
                            beforeTopEnd: s,
                            afterTop: c,
                            beforeBottom: u,
                            beforeBottomEnd: d,
                            afterBottom: p,
                            visiblePercent: f,
                            fromViewportCenter: m
                        })
                    }
                }
            }, {
                key: "onResize",
                value: function() {
                    this.coverImage(),
                    this.clipContainer()
                }
            }]),
            u
        }()
          , $ = function(e) {
            ("object" === ("undefined" == typeof HTMLElement ? "undefined" : p(HTMLElement)) ? e instanceof HTMLElement : e && "object" === (void 0 === e ? "undefined" : p(e)) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName) && (e = [e]);
            for (var t = arguments[1], o = Array.prototype.slice.call(arguments, 2), n = e.length, i = 0, a = void 0; i < n; i++)
                if ("object" === (void 0 === t ? "undefined" : p(t)) || void 0 === t ? e[i].jarallax || (e[i].jarallax = new w(e[i],t)) : e[i].jarallax && (a = e[i].jarallax[t].apply(e[i].jarallax, o)),
                void 0 !== a)
                    return a;
            return e
        };
        $.constructor = w,
        j.default = $
    }
    ).call(this, S(5))
}
, function(e, t, o) {
    "use strict";
    var n = o(4)
      , i = n.requestAnimationFrame || n.webkitRequestAnimationFrame || n.mozRequestAnimationFrame || function(e) {
        var t = +new Date
          , o = Math.max(0, 16 - (t - a))
          , n = setTimeout(e, o);
        return a = t,
        n
    }
      , a = +new Date;
    var r = n.cancelAnimationFrame || n.webkitCancelAnimationFrame || n.mozCancelAnimationFrame || clearTimeout;
    Function.prototype.bind && (i = i.bind(n),
    r = r.bind(n)),
    (e.exports = i).cancel = r
}
]);

/*!
Mailchimp Ajax Submit
jQuery Plugin
Author: Siddharth Doshi
*/
(function($) {
    "use strict";
    $.ajaxChimp = {
        responses: {
            "We have sent you a confirmation email": 0,
            "Please enter a value": 1,
            "An email address must contain a single @": 2,
            "The domain portion of the email address is invalid (the portion after the @: )": 3,
            "The username portion of the email address is invalid (the portion before the @: )": 4,
            "This email address looks fake or invalid. Please enter a real email address": 5
        },
        translations: {
            en: null
        },
        init: function(selector, options) {
            $(selector).ajaxChimp(options)
        }
    };
    $.fn.ajaxChimp = function(options) {
        $(this).each(function(i, elem) {
            var form = $(elem);
            var email = form.find("input[type=email]");
            var label = form.find("label[for=" + email.attr("id") + "]");
            var settings = $.extend({
                url: form.attr("action"),
                language: "en"
            }, options);
            var url = settings.url.replace("/post?", "/post-json?").concat("&c=?");
            form.attr("novalidate", "true");
            email.attr("name", "EMAIL");
            form.submit(function() {
                var msg;
                function successCallback(resp) {
                    if (resp.result === "success") {
                        msg = "We have sent you a confirmation email";
                        label.removeClass("error").addClass("valid");
                        email.removeClass("error").addClass("valid")
                    } else {
                        email.removeClass("valid").addClass("error");
                        label.removeClass("valid").addClass("error");
                        var index = -1;
                        try {
                            var parts = resp.msg.split(" - ", 2);
                            if (parts[1] === undefined) {
                                msg = resp.msg
                            } else {
                                var i = parseInt(parts[0], 10);
                                if (i.toString() === parts[0]) {
                                    index = parts[0];
                                    msg = parts[1]
                                } else {
                                    index = -1;
                                    msg = resp.msg
                                }
                            }
                        } catch (e) {
                            index = -1;
                            msg = resp.msg
                        }
                    }
                    if (settings.language !== "en" && $.ajaxChimp.responses[msg] !== undefined && $.ajaxChimp.translations && $.ajaxChimp.translations[settings.language] && $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]) {
                        msg = $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]
                    }
                    label.html(msg);
                    label.show(2e3);
                    if (settings.callback) {
                        settings.callback(resp)
                    }
                }
                var data = {};
                var dataArray = form.serializeArray();
                $.each(dataArray, function(index, item) {
                    data[item.name] = item.value
                });
                $.ajax({
                    url: url,
                    data: data,
                    success: successCallback,
                    dataType: "jsonp",
                    error: function(resp, text) {
                        console.log("mailchimp ajax submit error: " + text)
                    }
                });
                var submitMsg = "Submitting...";
                if (settings.language !== "en" && $.ajaxChimp.translations && $.ajaxChimp.translations[settings.language] && $.ajaxChimp.translations[settings.language]["submit"]) {
                    submitMsg = $.ajaxChimp.translations[settings.language]["submit"]
                }
                label.html(submitMsg).show(2e3);
                return false
            })
        });
        return this
    }
}
)(jQuery);

/* Lettering Js */
(function(t) {
    function n(n, e, i, r) {
        var c = n.text().split(e)
          , s = "";
        c.length && (t(c).each(function(t, n) {
            s += '<span class="' + i + (t + 1) + '">' + n + "</span>" + r
        }),
        n.empty().append(s))
    }
    var e = {
        init: function() {
            return this.each(function() {
                n(t(this), "", "char", "")
            })
        },
        words: function() {
            return this.each(function() {
                n(t(this), " ", "word", " ")
            })
        },
        lines: function() {
            return this.each(function() {
                var e = "eefec303079ad17405c889e092e105b0";
                n(t(this).children("br").replaceWith(e).end(), e, "line", "")
            })
        }
    };
    t.fn.lettering = function(n) {
        return n && e[n] ? e[n].apply(this, [].slice.call(arguments, 1)) : "letters" !== n && n ? (t.error("Method " + n + " does not exist on jQuery.lettering"),
        this) : e.init.apply(this, [].slice.call(arguments, 0))
    }
}
)(jQuery);

/* Textillate.js */
(function(t) {
    "use strict";
    function e(e) {
        return /In/.test(e) || t.inArray(e, t.fn.textillate.defaults.inEffects) >= 0
    }
    function n(e) {
        return /Out/.test(e) || t.inArray(e, t.fn.textillate.defaults.outEffects) >= 0
    }
    function i(t) {
        return "true" !== t && "false" !== t ? t : "true" === t
    }
    function a(e) {
        var n = e.attributes || []
          , a = {};
        return n.length ? (t.each(n, function(t, e) {
            var n = e.nodeName.replace(/delayscale/, "delayScale");
            /^data-in-*/.test(n) ? (a.in = a.in || {},
            a.in[n.replace(/data-in-/, "")] = i(e.nodeValue)) : /^data-out-*/.test(n) ? (a.out = a.out || {},
            a.out[n.replace(/data-out-/, "")] = i(e.nodeValue)) : /^data-*/.test(n) && (a[n.replace(/data-/, "")] = i(e.nodeValue))
        }),
        a) : a
    }
    function o(t) {
        for (var e, n, i = t.length; i; e = parseInt(Math.random() * i),
        n = t[--i],
        t[i] = t[e],
        t[e] = n)
            ;
        return t
    }
    function s(t, e, n) {
        t.addClass("animated " + e).css("visibility", "visible").show(),
        t.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
            t.removeClass("animated " + e),
            n && n()
        })
    }
    function l(i, a, l) {
        var r = i.length;
        return r ? (a.shuffle && (i = o(i)),
        a.reverse && (i = i.toArray().reverse()),
        void t.each(i, function(i, o) {
            function c() {
                e(a.effect) ? u.css("visibility", "visible") : n(a.effect) && u.css("visibility", "hidden"),
                r -= 1,
                !r && l && l()
            }
            var u = t(o)
              , f = a.sync ? a.delay : a.delay * i * a.delayScale;
            u.text() ? setTimeout(function() {
                s(u, a.effect, c)
            }, f) : c()
        })) : void (l && l())
    }
    var r = function(i, o) {
        var s = this
          , r = t(i);
        s.init = function() {
            s.$texts = r.find(o.selector),
            s.$texts.length || (s.$texts = t('<ul class="texts"><li>' + r.html() + "</li></ul>"),
            r.html(s.$texts)),
            s.$texts.hide(),
            s.$current = t("<span>").html(s.$texts.find(":first-child").html()).prependTo(r),
            e(o.in.effect) ? s.$current.css("visibility", "hidden") : n(o.out.effect) && s.$current.css("visibility", "visible"),
            s.setOptions(o),
            s.timeoutRun = null,
            setTimeout(function() {
                s.options.autoStart && s.start()
            }, s.options.initialDelay)
        }
        ,
        s.setOptions = function(t) {
            s.options = t
        }
        ,
        s.triggerEvent = function(e) {
            var n = t.Event(e + ".tlt");
            return r.trigger(n, s),
            n
        }
        ,
        s.in = function(i, o) {
            i = i || 0;
            var c, u = s.$texts.find(":nth-child(" + ((i || 0) + 1) + ")"), f = t.extend(!0, {}, s.options, u.length ? a(u[0]) : {});
            u.addClass("current"),
            s.triggerEvent("inAnimationBegin"),
            r.attr("data-active", u.data("id")),
            s.$current.html(u.html()).lettering("words"),
            "char" == s.options.type && s.$current.find('[class^="word"]').css({
                display: "inline-block",
                "-webkit-transform": "translate3d(0,0,0)",
                "-moz-transform": "translate3d(0,0,0)",
                "-o-transform": "translate3d(0,0,0)",
                transform: "translate3d(0,0,0)"
            }).each(function() {
                t(this).lettering()
            }),
            c = s.$current.find('[class^="' + s.options.type + '"]').css("display", "inline-block"),
            e(f.in.effect) ? c.css("visibility", "hidden") : n(f.in.effect) && c.css("visibility", "visible"),
            s.currentIndex = i,
            l(c, f.in, function() {
                s.triggerEvent("inAnimationEnd"),
                f.in.callback && f.in.callback(),
                o && o(s)
            })
        }
        ,
        s.out = function(e) {
            var n = s.$texts.find(":nth-child(" + ((s.currentIndex || 0) + 1) + ")")
              , i = s.$current.find('[class^="' + s.options.type + '"]')
              , o = t.extend(!0, {}, s.options, n.length ? a(n[0]) : {});
            s.triggerEvent("outAnimationBegin"),
            l(i, o.out, function() {
                n.removeClass("current"),
                s.triggerEvent("outAnimationEnd"),
                r.removeAttr("data-active"),
                o.out.callback && o.out.callback(),
                e && e(s)
            })
        }
        ,
        s.start = function(t) {
            setTimeout(function() {
                s.triggerEvent("start"),
                function t(e) {
                    s.in(e, function() {
                        var n = s.$texts.children().length;
                        e += 1,
                        !s.options.loop && e >= n ? (s.options.callback && s.options.callback(),
                        s.triggerEvent("end")) : (e %= n,
                        s.timeoutRun = setTimeout(function() {
                            s.out(function() {
                                t(e)
                            })
                        }, s.options.minDisplayTime))
                    })
                }(t || 0)
            }, s.options.initialDelay)
        }
        ,
        s.stop = function() {
            s.timeoutRun && (clearInterval(s.timeoutRun),
            s.timeoutRun = null)
        }
        ,
        s.init()
    };
    t.fn.textillate = function(e, n) {
        return this.each(function() {
            var i = t(this)
              , o = i.data("textillate")
              , s = t.extend(!0, {}, t.fn.textillate.defaults, a(this), "object" == typeof e && e);
            o ? "string" == typeof e ? o[e].apply(o, [].concat(n)) : o.setOptions.call(o, s) : i.data("textillate", o = new r(this,s))
        })
    }
    ,
    t.fn.textillate.defaults = {
        selector: ".texts",
        loop: !1,
        minDisplayTime: 2e3,
        initialDelay: 0,
        in: {
            effect: "fadeInLeftBig",
            delayScale: 1.5,
            delay: 50,
            sync: !1,
            reverse: !1,
            shuffle: !1,
            callback: function() {}
        },
        out: {
            effect: "hinge",
            delayScale: 1.5,
            delay: 50,
            sync: !1,
            reverse: !1,
            shuffle: !1,
            callback: function() {}
        },
        autoStart: !0,
        inEffects: [],
        outEffects: ["hinge"],
        callback: function() {},
        type: "char"
    }
}
)(jQuery);
